import React, { useEffect, useLayoutEffect, createContext, forwardRef, useState, useRef } from "react";
function __rest(s, e) {
  var t = {};
  for (var p in s) Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0 && (t[p] = s[p]);
  if (s != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)
      e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]) && (t[p[i]] = s[p[i]]);
  return t;
}
function __awaiter(thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function(resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function(resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}
function getDefaultExportFromCjs(x) {
  return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, "default") ? x.default : x;
}
var bind = { exports: {} };
var hasRequiredBind;
function requireBind() {
  return hasRequiredBind || (hasRequiredBind = 1, (function(module) {
    (function() {
      var hasOwn = {}.hasOwnProperty;
      function classNames2() {
        for (var classes2 = "", i = 0; i < arguments.length; i++) {
          var arg = arguments[i];
          arg && (classes2 = appendClass(classes2, parseValue2.call(this, arg)));
        }
        return classes2;
      }
      function parseValue2(arg) {
        if (typeof arg == "string" || typeof arg == "number")
          return this && this[arg] || arg;
        if (typeof arg != "object")
          return "";
        if (Array.isArray(arg))
          return classNames2.apply(this, arg);
        if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes("[native code]"))
          return arg.toString();
        var classes2 = "";
        for (var key in arg)
          hasOwn.call(arg, key) && arg[key] && (classes2 = appendClass(classes2, this && this[key] || key));
        return classes2;
      }
      function appendClass(value, newClass) {
        return newClass ? value ? value + " " + newClass : value + newClass : value;
      }
      module.exports ? (classNames2.default = classNames2, module.exports = classNames2) : window.classNames = classNames2;
    })();
  })(bind)), bind.exports;
}
var bindExports = requireBind();
const classNames = /* @__PURE__ */ getDefaultExportFromCjs(bindExports);
function assign(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source)
      target[key] = source[key];
  }
  return target;
}
var defaultConverter = {
  read: function(value) {
    return value[0] === '"' && (value = value.slice(1, -1)), value.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
  },
  write: function(value) {
    return encodeURIComponent(value).replace(
      /%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g,
      decodeURIComponent
    );
  }
};
function init(converter, defaultAttributes) {
  function set(name, value, attributes) {
    if (!(typeof document > "u")) {
      attributes = assign({}, defaultAttributes, attributes), typeof attributes.expires == "number" && (attributes.expires = new Date(Date.now() + attributes.expires * 864e5)), attributes.expires && (attributes.expires = attributes.expires.toUTCString()), name = encodeURIComponent(name).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
      var stringifiedAttributes = "";
      for (var attributeName in attributes)
        attributes[attributeName] && (stringifiedAttributes += "; " + attributeName, attributes[attributeName] !== !0 && (stringifiedAttributes += "=" + attributes[attributeName].split(";")[0]));
      return document.cookie = name + "=" + converter.write(value, name) + stringifiedAttributes;
    }
  }
  function get(name) {
    if (!(typeof document > "u" || arguments.length && !name)) {
      for (var cookies = document.cookie ? document.cookie.split("; ") : [], jar = {}, i = 0; i < cookies.length; i++) {
        var parts = cookies[i].split("="), value = parts.slice(1).join("=");
        try {
          var found = decodeURIComponent(parts[0]);
          if (jar[found] = converter.read(value, found), name === found)
            break;
        } catch {
        }
      }
      return name ? jar[name] : jar;
    }
  }
  return Object.create(
    {
      set,
      get,
      remove: function(name, attributes) {
        set(
          name,
          "",
          assign({}, attributes, {
            expires: -1
          })
        );
      },
      withAttributes: function(attributes) {
        return init(this.converter, assign({}, this.attributes, attributes));
      },
      withConverter: function(converter2) {
        return init(assign({}, this.converter, converter2), this.attributes);
      }
    },
    {
      attributes: { value: Object.freeze(defaultAttributes) },
      converter: { value: Object.freeze(converter) }
    }
  );
}
var api = init(defaultConverter, { path: "/" });
const token = "%[a-f0-9]{2}", singleMatcher = new RegExp("(" + token + ")|([^%]+?)", "gi"), multiMatcher = new RegExp("(" + token + ")+", "gi");
function decodeComponents(components, split) {
  try {
    return [decodeURIComponent(components.join(""))];
  } catch {
  }
  if (components.length === 1)
    return components;
  split = split || 1;
  const left = components.slice(0, split), right = components.slice(split);
  return Array.prototype.concat.call([], decodeComponents(left), decodeComponents(right));
}
function decode$1(input) {
  try {
    return decodeURIComponent(input);
  } catch {
    let tokens = input.match(singleMatcher) || [];
    for (let i = 1; i < tokens.length; i++)
      input = decodeComponents(tokens, i).join(""), tokens = input.match(singleMatcher) || [];
    return input;
  }
}
function customDecodeURIComponent(input) {
  const replaceMap = {
    "%FE%FF": "��",
    "%FF%FE": "��"
  };
  let match = multiMatcher.exec(input);
  for (; match; ) {
    try {
      replaceMap[match[0]] = decodeURIComponent(match[0]);
    } catch {
      const result = decode$1(match[0]);
      result !== match[0] && (replaceMap[match[0]] = result);
    }
    match = multiMatcher.exec(input);
  }
  replaceMap["%C2"] = "�";
  const entries = Object.keys(replaceMap);
  for (const key of entries)
    input = input.replace(new RegExp(key, "g"), replaceMap[key]);
  return input;
}
function decodeUriComponent(encodedURI) {
  if (typeof encodedURI != "string")
    throw new TypeError("Expected `encodedURI` to be of type `string`, got `" + typeof encodedURI + "`");
  try {
    return decodeURIComponent(encodedURI);
  } catch {
    return customDecodeURIComponent(encodedURI);
  }
}
function splitOnFirst(string, separator) {
  if (!(typeof string == "string" && typeof separator == "string"))
    throw new TypeError("Expected the arguments to be of type `string`");
  if (string === "" || separator === "")
    return [];
  const separatorIndex = string.indexOf(separator);
  return separatorIndex === -1 ? [] : [
    string.slice(0, separatorIndex),
    string.slice(separatorIndex + separator.length)
  ];
}
function includeKeys(object, predicate) {
  const result = {};
  if (Array.isArray(predicate))
    for (const key of predicate) {
      const descriptor = Object.getOwnPropertyDescriptor(object, key);
      descriptor?.enumerable && Object.defineProperty(result, key, descriptor);
    }
  else
    for (const key of Reflect.ownKeys(object)) {
      const descriptor = Object.getOwnPropertyDescriptor(object, key);
      if (descriptor.enumerable) {
        const value = object[key];
        predicate(key, value, object) && Object.defineProperty(result, key, descriptor);
      }
    }
  return result;
}
const isNullOrUndefined = (value) => value == null, strictUriEncode = (string) => encodeURIComponent(string).replace(/[!'()*]/g, (x) => `%${x.charCodeAt(0).toString(16).toUpperCase()}`), encodeFragmentIdentifier = /* @__PURE__ */ Symbol("encodeFragmentIdentifier");
function encoderForArrayFormat(options) {
  switch (options.arrayFormat) {
    case "index":
      return (key) => (result, value) => {
        const index2 = result.length;
        return value === void 0 || options.skipNull && value === null || options.skipEmptyString && value === "" ? result : value === null ? [
          ...result,
          [encode(key, options), "[", index2, "]"].join("")
        ] : [
          ...result,
          [encode(key, options), "[", encode(index2, options), "]=", encode(value, options)].join("")
        ];
      };
    case "bracket":
      return (key) => (result, value) => value === void 0 || options.skipNull && value === null || options.skipEmptyString && value === "" ? result : value === null ? [
        ...result,
        [encode(key, options), "[]"].join("")
      ] : [
        ...result,
        [encode(key, options), "[]=", encode(value, options)].join("")
      ];
    case "colon-list-separator":
      return (key) => (result, value) => value === void 0 || options.skipNull && value === null || options.skipEmptyString && value === "" ? result : value === null ? [
        ...result,
        [encode(key, options), ":list="].join("")
      ] : [
        ...result,
        [encode(key, options), ":list=", encode(value, options)].join("")
      ];
    case "comma":
    case "separator":
    case "bracket-separator": {
      const keyValueSep = options.arrayFormat === "bracket-separator" ? "[]=" : "=";
      return (key) => (result, value) => value === void 0 || options.skipNull && value === null || options.skipEmptyString && value === "" ? result : (value = value === null ? "" : value, result.length === 0 ? [[encode(key, options), keyValueSep, encode(value, options)].join("")] : [[result, encode(value, options)].join(options.arrayFormatSeparator)]);
    }
    default:
      return (key) => (result, value) => value === void 0 || options.skipNull && value === null || options.skipEmptyString && value === "" ? result : value === null ? [
        ...result,
        encode(key, options)
      ] : [
        ...result,
        [encode(key, options), "=", encode(value, options)].join("")
      ];
  }
}
function parserForArrayFormat(options) {
  let result;
  switch (options.arrayFormat) {
    case "index":
      return (key, value, accumulator) => {
        if (result = /\[(\d*)]$/.exec(key), key = key.replace(/\[\d*]$/, ""), !result) {
          accumulator[key] = value;
          return;
        }
        accumulator[key] === void 0 && (accumulator[key] = {}), accumulator[key][result[1]] = value;
      };
    case "bracket":
      return (key, value, accumulator) => {
        if (result = /(\[])$/.exec(key), key = key.replace(/\[]$/, ""), !result) {
          accumulator[key] = value;
          return;
        }
        if (accumulator[key] === void 0) {
          accumulator[key] = [value];
          return;
        }
        accumulator[key] = [...accumulator[key], value];
      };
    case "colon-list-separator":
      return (key, value, accumulator) => {
        if (result = /(:list)$/.exec(key), key = key.replace(/:list$/, ""), !result) {
          accumulator[key] = value;
          return;
        }
        if (accumulator[key] === void 0) {
          accumulator[key] = [value];
          return;
        }
        accumulator[key] = [...accumulator[key], value];
      };
    case "comma":
    case "separator":
      return (key, value, accumulator) => {
        const isArray = typeof value == "string" && value.includes(options.arrayFormatSeparator), isEncodedArray = typeof value == "string" && !isArray && decode(value, options).includes(options.arrayFormatSeparator);
        value = isEncodedArray ? decode(value, options) : value;
        const newValue = isArray || isEncodedArray ? value.split(options.arrayFormatSeparator).map((item) => decode(item, options)) : value === null ? value : decode(value, options);
        accumulator[key] = newValue;
      };
    case "bracket-separator":
      return (key, value, accumulator) => {
        const isArray = /(\[])$/.test(key);
        if (key = key.replace(/\[]$/, ""), !isArray) {
          accumulator[key] = value && decode(value, options);
          return;
        }
        const arrayValue = value === null ? [] : value.split(options.arrayFormatSeparator).map((item) => decode(item, options));
        if (accumulator[key] === void 0) {
          accumulator[key] = arrayValue;
          return;
        }
        accumulator[key] = [...accumulator[key], ...arrayValue];
      };
    default:
      return (key, value, accumulator) => {
        if (accumulator[key] === void 0) {
          accumulator[key] = value;
          return;
        }
        accumulator[key] = [...[accumulator[key]].flat(), value];
      };
  }
}
function validateArrayFormatSeparator(value) {
  if (typeof value != "string" || value.length !== 1)
    throw new TypeError("arrayFormatSeparator must be single character string");
}
function encode(value, options) {
  return options.encode ? options.strict ? strictUriEncode(value) : encodeURIComponent(value) : value;
}
function decode(value, options) {
  return options.decode ? decodeUriComponent(value) : value;
}
function keysSorter(input) {
  return Array.isArray(input) ? input.sort() : typeof input == "object" ? keysSorter(Object.keys(input)).sort((a, b) => Number(a) - Number(b)).map((key) => input[key]) : input;
}
function removeHash(input) {
  const hashStart = input.indexOf("#");
  return hashStart !== -1 && (input = input.slice(0, hashStart)), input;
}
function getHash(url) {
  let hash = "";
  const hashStart = url.indexOf("#");
  return hashStart !== -1 && (hash = url.slice(hashStart)), hash;
}
function parseValue(value, options) {
  return options.parseNumbers && !Number.isNaN(Number(value)) && typeof value == "string" && value.trim() !== "" ? value = Number(value) : options.parseBooleans && value !== null && (value.toLowerCase() === "true" || value.toLowerCase() === "false") && (value = value.toLowerCase() === "true"), value;
}
function extract(input) {
  input = removeHash(input);
  const queryStart = input.indexOf("?");
  return queryStart === -1 ? "" : input.slice(queryStart + 1);
}
function parse(query, options) {
  options = {
    decode: !0,
    sort: !0,
    arrayFormat: "none",
    arrayFormatSeparator: ",",
    parseNumbers: !1,
    parseBooleans: !1,
    ...options
  }, validateArrayFormatSeparator(options.arrayFormatSeparator);
  const formatter = parserForArrayFormat(options), returnValue = /* @__PURE__ */ Object.create(null);
  if (typeof query != "string" || (query = query.trim().replace(/^[?#&]/, ""), !query))
    return returnValue;
  for (const parameter of query.split("&")) {
    if (parameter === "")
      continue;
    const parameter_ = options.decode ? parameter.replace(/\+/g, " ") : parameter;
    let [key, value] = splitOnFirst(parameter_, "=");
    key === void 0 && (key = parameter_), value = value === void 0 ? null : ["comma", "separator", "bracket-separator"].includes(options.arrayFormat) ? value : decode(value, options), formatter(decode(key, options), value, returnValue);
  }
  for (const [key, value] of Object.entries(returnValue))
    if (typeof value == "object" && value !== null)
      for (const [key2, value2] of Object.entries(value))
        value[key2] = parseValue(value2, options);
    else
      returnValue[key] = parseValue(value, options);
  return options.sort === !1 ? returnValue : (options.sort === !0 ? Object.keys(returnValue).sort() : Object.keys(returnValue).sort(options.sort)).reduce((result, key) => {
    const value = returnValue[key];
    return result[key] = value && typeof value == "object" && !Array.isArray(value) ? keysSorter(value) : value, result;
  }, /* @__PURE__ */ Object.create(null));
}
function stringify(object, options) {
  if (!object)
    return "";
  options = {
    encode: !0,
    strict: !0,
    arrayFormat: "none",
    arrayFormatSeparator: ",",
    ...options
  }, validateArrayFormatSeparator(options.arrayFormatSeparator);
  const shouldFilter = (key) => options.skipNull && isNullOrUndefined(object[key]) || options.skipEmptyString && object[key] === "", formatter = encoderForArrayFormat(options), objectCopy = {};
  for (const [key, value] of Object.entries(object))
    shouldFilter(key) || (objectCopy[key] = value);
  const keys = Object.keys(objectCopy);
  return options.sort !== !1 && keys.sort(options.sort), keys.map((key) => {
    const value = object[key];
    return value === void 0 ? "" : value === null ? encode(key, options) : Array.isArray(value) ? value.length === 0 && options.arrayFormat === "bracket-separator" ? encode(key, options) + "[]" : value.reduce(formatter(key), []).join("&") : encode(key, options) + "=" + encode(value, options);
  }).filter((x) => x.length > 0).join("&");
}
function parseUrl(url, options) {
  options = {
    decode: !0,
    ...options
  };
  let [url_, hash] = splitOnFirst(url, "#");
  return url_ === void 0 && (url_ = url), {
    url: url_?.split("?")?.[0] ?? "",
    query: parse(extract(url), options),
    ...options && options.parseFragmentIdentifier && hash ? { fragmentIdentifier: decode(hash, options) } : {}
  };
}
function stringifyUrl(object, options) {
  options = {
    encode: !0,
    strict: !0,
    [encodeFragmentIdentifier]: !0,
    ...options
  };
  const url = removeHash(object.url).split("?")[0] || "", queryFromUrl = extract(object.url), query = {
    ...parse(queryFromUrl, { sort: !1 }),
    ...object.query
  };
  let queryString2 = stringify(query, options);
  queryString2 && (queryString2 = `?${queryString2}`);
  let hash = getHash(object.url);
  if (object.fragmentIdentifier) {
    const urlObjectForFragmentEncode = new URL(url);
    urlObjectForFragmentEncode.hash = object.fragmentIdentifier, hash = options[encodeFragmentIdentifier] ? urlObjectForFragmentEncode.hash : `#${object.fragmentIdentifier}`;
  }
  return `${url}${queryString2}${hash}`;
}
function pick(input, filter2, options) {
  options = {
    parseFragmentIdentifier: !0,
    [encodeFragmentIdentifier]: !1,
    ...options
  };
  const { url, query, fragmentIdentifier } = parseUrl(input, options);
  return stringifyUrl({
    url,
    query: includeKeys(query, filter2),
    fragmentIdentifier
  }, options);
}
function exclude(input, filter2, options) {
  const exclusionFilter = Array.isArray(filter2) ? (key) => !filter2.includes(key) : (key, value) => !filter2(key, value);
  return pick(input, exclusionFilter, options);
}
const queryString = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  exclude,
  extract,
  parse,
  parseUrl,
  pick,
  stringify,
  stringifyUrl
}, Symbol.toStringTag, { value: "Module" }));
function isObject$2(obj) {
  return obj !== null && typeof obj == "object" && "constructor" in obj && obj.constructor === Object;
}
function extend$2(target = {}, src = {}) {
  Object.keys(src).forEach((key) => {
    typeof target[key] > "u" ? target[key] = src[key] : isObject$2(src[key]) && isObject$2(target[key]) && Object.keys(src[key]).length > 0 && extend$2(target[key], src[key]);
  });
}
const ssrDocument = {
  body: {},
  addEventListener() {
  },
  removeEventListener() {
  },
  activeElement: {
    blur() {
    },
    nodeName: ""
  },
  querySelector() {
    return null;
  },
  querySelectorAll() {
    return [];
  },
  getElementById() {
    return null;
  },
  createEvent() {
    return {
      initEvent() {
      }
    };
  },
  createElement() {
    return {
      children: [],
      childNodes: [],
      style: {},
      setAttribute() {
      },
      getElementsByTagName() {
        return [];
      }
    };
  },
  createElementNS() {
    return {};
  },
  importNode() {
    return null;
  },
  location: {
    hash: "",
    host: "",
    hostname: "",
    href: "",
    origin: "",
    pathname: "",
    protocol: "",
    search: ""
  }
};
function getDocument() {
  const doc = typeof document < "u" ? document : {};
  return extend$2(doc, ssrDocument), doc;
}
const ssrWindow = {
  document: ssrDocument,
  navigator: {
    userAgent: ""
  },
  location: {
    hash: "",
    host: "",
    hostname: "",
    href: "",
    origin: "",
    pathname: "",
    protocol: "",
    search: ""
  },
  history: {
    replaceState() {
    },
    pushState() {
    },
    go() {
    },
    back() {
    }
  },
  CustomEvent: function() {
    return this;
  },
  addEventListener() {
  },
  removeEventListener() {
  },
  getComputedStyle() {
    return {
      getPropertyValue() {
        return "";
      }
    };
  },
  Image() {
  },
  Date() {
  },
  screen: {},
  setTimeout() {
  },
  clearTimeout() {
  },
  matchMedia() {
    return {};
  },
  requestAnimationFrame(callback) {
    return typeof setTimeout > "u" ? (callback(), null) : setTimeout(callback, 0);
  },
  cancelAnimationFrame(id) {
    typeof setTimeout > "u" || clearTimeout(id);
  }
};
function getWindow() {
  const win = typeof window < "u" ? window : {};
  return extend$2(win, ssrWindow), win;
}
function makeReactive(obj) {
  const proto = obj.__proto__;
  Object.defineProperty(obj, "__proto__", {
    get() {
      return proto;
    },
    set(value) {
      proto.__proto__ = value;
    }
  });
}
class Dom7 extends Array {
  constructor(items) {
    typeof items == "number" ? super(items) : (super(...items || []), makeReactive(this));
  }
}
function arrayFlat(arr = []) {
  const res = [];
  return arr.forEach((el) => {
    Array.isArray(el) ? res.push(...arrayFlat(el)) : res.push(el);
  }), res;
}
function arrayFilter(arr, callback) {
  return Array.prototype.filter.call(arr, callback);
}
function arrayUnique(arr) {
  const uniqueArray = [];
  for (let i = 0; i < arr.length; i += 1)
    uniqueArray.indexOf(arr[i]) === -1 && uniqueArray.push(arr[i]);
  return uniqueArray;
}
function qsa(selector, context) {
  if (typeof selector != "string")
    return [selector];
  const a = [], res = context.querySelectorAll(selector);
  for (let i = 0; i < res.length; i += 1)
    a.push(res[i]);
  return a;
}
function $(selector, context) {
  const window2 = getWindow(), document2 = getDocument();
  let arr = [];
  if (!context && selector instanceof Dom7)
    return selector;
  if (!selector)
    return new Dom7(arr);
  if (typeof selector == "string") {
    const html2 = selector.trim();
    if (html2.indexOf("<") >= 0 && html2.indexOf(">") >= 0) {
      let toCreate = "div";
      html2.indexOf("<li") === 0 && (toCreate = "ul"), html2.indexOf("<tr") === 0 && (toCreate = "tbody"), (html2.indexOf("<td") === 0 || html2.indexOf("<th") === 0) && (toCreate = "tr"), html2.indexOf("<tbody") === 0 && (toCreate = "table"), html2.indexOf("<option") === 0 && (toCreate = "select");
      const tempParent = document2.createElement(toCreate);
      tempParent.innerHTML = html2;
      for (let i = 0; i < tempParent.childNodes.length; i += 1)
        arr.push(tempParent.childNodes[i]);
    } else
      arr = qsa(selector.trim(), context || document2);
  } else if (selector.nodeType || selector === window2 || selector === document2)
    arr.push(selector);
  else if (Array.isArray(selector)) {
    if (selector instanceof Dom7) return selector;
    arr = selector;
  }
  return new Dom7(arrayUnique(arr));
}
$.fn = Dom7.prototype;
function addClass(...classes2) {
  const classNames2 = arrayFlat(classes2.map((c) => c.split(" ")));
  return this.forEach((el) => {
    el.classList.add(...classNames2);
  }), this;
}
function removeClass(...classes2) {
  const classNames2 = arrayFlat(classes2.map((c) => c.split(" ")));
  return this.forEach((el) => {
    el.classList.remove(...classNames2);
  }), this;
}
function toggleClass(...classes2) {
  const classNames2 = arrayFlat(classes2.map((c) => c.split(" ")));
  this.forEach((el) => {
    classNames2.forEach((className) => {
      el.classList.toggle(className);
    });
  });
}
function hasClass(...classes2) {
  const classNames2 = arrayFlat(classes2.map((c) => c.split(" ")));
  return arrayFilter(this, (el) => classNames2.filter((className) => el.classList.contains(className)).length > 0).length > 0;
}
function attr(attrs, value) {
  if (arguments.length === 1 && typeof attrs == "string")
    return this[0] ? this[0].getAttribute(attrs) : void 0;
  for (let i = 0; i < this.length; i += 1)
    if (arguments.length === 2)
      this[i].setAttribute(attrs, value);
    else
      for (const attrName in attrs)
        this[i][attrName] = attrs[attrName], this[i].setAttribute(attrName, attrs[attrName]);
  return this;
}
function removeAttr(attr2) {
  for (let i = 0; i < this.length; i += 1)
    this[i].removeAttribute(attr2);
  return this;
}
function transform(transform2) {
  for (let i = 0; i < this.length; i += 1)
    this[i].style.transform = transform2;
  return this;
}
function transition$1(duration) {
  for (let i = 0; i < this.length; i += 1)
    this[i].style.transitionDuration = typeof duration != "string" ? `${duration}ms` : duration;
  return this;
}
function on(...args) {
  let [eventType, targetSelector, listener, capture] = args;
  typeof args[1] == "function" && ([eventType, listener, capture] = args, targetSelector = void 0), capture || (capture = !1);
  function handleLiveEvent(e) {
    const target = e.target;
    if (!target) return;
    const eventData = e.target.dom7EventData || [];
    if (eventData.indexOf(e) < 0 && eventData.unshift(e), $(target).is(targetSelector)) listener.apply(target, eventData);
    else {
      const parents2 = $(target).parents();
      for (let k = 0; k < parents2.length; k += 1)
        $(parents2[k]).is(targetSelector) && listener.apply(parents2[k], eventData);
    }
  }
  function handleEvent(e) {
    const eventData = e && e.target ? e.target.dom7EventData || [] : [];
    eventData.indexOf(e) < 0 && eventData.unshift(e), listener.apply(this, eventData);
  }
  const events2 = eventType.split(" ");
  let j;
  for (let i = 0; i < this.length; i += 1) {
    const el = this[i];
    if (targetSelector)
      for (j = 0; j < events2.length; j += 1) {
        const event = events2[j];
        el.dom7LiveListeners || (el.dom7LiveListeners = {}), el.dom7LiveListeners[event] || (el.dom7LiveListeners[event] = []), el.dom7LiveListeners[event].push({
          listener,
          proxyListener: handleLiveEvent
        }), el.addEventListener(event, handleLiveEvent, capture);
      }
    else
      for (j = 0; j < events2.length; j += 1) {
        const event = events2[j];
        el.dom7Listeners || (el.dom7Listeners = {}), el.dom7Listeners[event] || (el.dom7Listeners[event] = []), el.dom7Listeners[event].push({
          listener,
          proxyListener: handleEvent
        }), el.addEventListener(event, handleEvent, capture);
      }
  }
  return this;
}
function off(...args) {
  let [eventType, targetSelector, listener, capture] = args;
  typeof args[1] == "function" && ([eventType, listener, capture] = args, targetSelector = void 0), capture || (capture = !1);
  const events2 = eventType.split(" ");
  for (let i = 0; i < events2.length; i += 1) {
    const event = events2[i];
    for (let j = 0; j < this.length; j += 1) {
      const el = this[j];
      let handlers;
      if (!targetSelector && el.dom7Listeners ? handlers = el.dom7Listeners[event] : targetSelector && el.dom7LiveListeners && (handlers = el.dom7LiveListeners[event]), handlers && handlers.length)
        for (let k = handlers.length - 1; k >= 0; k -= 1) {
          const handler = handlers[k];
          listener && handler.listener === listener || listener && handler.listener && handler.listener.dom7proxy && handler.listener.dom7proxy === listener ? (el.removeEventListener(event, handler.proxyListener, capture), handlers.splice(k, 1)) : listener || (el.removeEventListener(event, handler.proxyListener, capture), handlers.splice(k, 1));
        }
    }
  }
  return this;
}
function trigger(...args) {
  const window2 = getWindow(), events2 = args[0].split(" "), eventData = args[1];
  for (let i = 0; i < events2.length; i += 1) {
    const event = events2[i];
    for (let j = 0; j < this.length; j += 1) {
      const el = this[j];
      if (window2.CustomEvent) {
        const evt = new window2.CustomEvent(event, {
          detail: eventData,
          bubbles: !0,
          cancelable: !0
        });
        el.dom7EventData = args.filter((data, dataIndex) => dataIndex > 0), el.dispatchEvent(evt), el.dom7EventData = [], delete el.dom7EventData;
      }
    }
  }
  return this;
}
function transitionEnd$1(callback) {
  const dom = this;
  function fireCallBack(e) {
    e.target === this && (callback.call(this, e), dom.off("transitionend", fireCallBack));
  }
  return callback && dom.on("transitionend", fireCallBack), this;
}
function outerWidth(includeMargins) {
  if (this.length > 0) {
    if (includeMargins) {
      const styles2 = this.styles();
      return this[0].offsetWidth + parseFloat(styles2.getPropertyValue("margin-right")) + parseFloat(styles2.getPropertyValue("margin-left"));
    }
    return this[0].offsetWidth;
  }
  return null;
}
function outerHeight(includeMargins) {
  if (this.length > 0) {
    if (includeMargins) {
      const styles2 = this.styles();
      return this[0].offsetHeight + parseFloat(styles2.getPropertyValue("margin-top")) + parseFloat(styles2.getPropertyValue("margin-bottom"));
    }
    return this[0].offsetHeight;
  }
  return null;
}
function offset() {
  if (this.length > 0) {
    const window2 = getWindow(), document2 = getDocument(), el = this[0], box = el.getBoundingClientRect(), body = document2.body, clientTop = el.clientTop || body.clientTop || 0, clientLeft = el.clientLeft || body.clientLeft || 0, scrollTop = el === window2 ? window2.scrollY : el.scrollTop, scrollLeft = el === window2 ? window2.scrollX : el.scrollLeft;
    return {
      top: box.top + scrollTop - clientTop,
      left: box.left + scrollLeft - clientLeft
    };
  }
  return null;
}
function styles() {
  const window2 = getWindow();
  return this[0] ? window2.getComputedStyle(this[0], null) : {};
}
function css(props, value) {
  const window2 = getWindow();
  let i;
  if (arguments.length === 1)
    if (typeof props == "string") {
      if (this[0]) return window2.getComputedStyle(this[0], null).getPropertyValue(props);
    } else {
      for (i = 0; i < this.length; i += 1)
        for (const prop in props)
          this[i].style[prop] = props[prop];
      return this;
    }
  if (arguments.length === 2 && typeof props == "string") {
    for (i = 0; i < this.length; i += 1)
      this[i].style[props] = value;
    return this;
  }
  return this;
}
function each(callback) {
  return callback ? (this.forEach((el, index2) => {
    callback.apply(el, [el, index2]);
  }), this) : this;
}
function filter(callback) {
  const result = arrayFilter(this, callback);
  return $(result);
}
function html(html2) {
  if (typeof html2 > "u")
    return this[0] ? this[0].innerHTML : null;
  for (let i = 0; i < this.length; i += 1)
    this[i].innerHTML = html2;
  return this;
}
function text(text2) {
  if (typeof text2 > "u")
    return this[0] ? this[0].textContent.trim() : null;
  for (let i = 0; i < this.length; i += 1)
    this[i].textContent = text2;
  return this;
}
function is(selector) {
  const window2 = getWindow(), document2 = getDocument(), el = this[0];
  let compareWith, i;
  if (!el || typeof selector > "u") return !1;
  if (typeof selector == "string") {
    if (el.matches) return el.matches(selector);
    if (el.webkitMatchesSelector) return el.webkitMatchesSelector(selector);
    if (el.msMatchesSelector) return el.msMatchesSelector(selector);
    for (compareWith = $(selector), i = 0; i < compareWith.length; i += 1)
      if (compareWith[i] === el) return !0;
    return !1;
  }
  if (selector === document2)
    return el === document2;
  if (selector === window2)
    return el === window2;
  if (selector.nodeType || selector instanceof Dom7) {
    for (compareWith = selector.nodeType ? [selector] : selector, i = 0; i < compareWith.length; i += 1)
      if (compareWith[i] === el) return !0;
    return !1;
  }
  return !1;
}
function index() {
  let child = this[0], i;
  if (child) {
    for (i = 0; (child = child.previousSibling) !== null; )
      child.nodeType === 1 && (i += 1);
    return i;
  }
}
function eq(index2) {
  if (typeof index2 > "u") return this;
  const length = this.length;
  if (index2 > length - 1)
    return $([]);
  if (index2 < 0) {
    const returnIndex = length + index2;
    return returnIndex < 0 ? $([]) : $([this[returnIndex]]);
  }
  return $([this[index2]]);
}
function append(...els) {
  let newChild;
  const document2 = getDocument();
  for (let k = 0; k < els.length; k += 1) {
    newChild = els[k];
    for (let i = 0; i < this.length; i += 1)
      if (typeof newChild == "string") {
        const tempDiv = document2.createElement("div");
        for (tempDiv.innerHTML = newChild; tempDiv.firstChild; )
          this[i].appendChild(tempDiv.firstChild);
      } else if (newChild instanceof Dom7)
        for (let j = 0; j < newChild.length; j += 1)
          this[i].appendChild(newChild[j]);
      else
        this[i].appendChild(newChild);
  }
  return this;
}
function prepend(newChild) {
  const document2 = getDocument();
  let i, j;
  for (i = 0; i < this.length; i += 1)
    if (typeof newChild == "string") {
      const tempDiv = document2.createElement("div");
      for (tempDiv.innerHTML = newChild, j = tempDiv.childNodes.length - 1; j >= 0; j -= 1)
        this[i].insertBefore(tempDiv.childNodes[j], this[i].childNodes[0]);
    } else if (newChild instanceof Dom7)
      for (j = 0; j < newChild.length; j += 1)
        this[i].insertBefore(newChild[j], this[i].childNodes[0]);
    else
      this[i].insertBefore(newChild, this[i].childNodes[0]);
  return this;
}
function next(selector) {
  return this.length > 0 ? selector ? this[0].nextElementSibling && $(this[0].nextElementSibling).is(selector) ? $([this[0].nextElementSibling]) : $([]) : this[0].nextElementSibling ? $([this[0].nextElementSibling]) : $([]) : $([]);
}
function nextAll(selector) {
  const nextEls = [];
  let el = this[0];
  if (!el) return $([]);
  for (; el.nextElementSibling; ) {
    const next2 = el.nextElementSibling;
    selector ? $(next2).is(selector) && nextEls.push(next2) : nextEls.push(next2), el = next2;
  }
  return $(nextEls);
}
function prev(selector) {
  if (this.length > 0) {
    const el = this[0];
    return selector ? el.previousElementSibling && $(el.previousElementSibling).is(selector) ? $([el.previousElementSibling]) : $([]) : el.previousElementSibling ? $([el.previousElementSibling]) : $([]);
  }
  return $([]);
}
function prevAll(selector) {
  const prevEls = [];
  let el = this[0];
  if (!el) return $([]);
  for (; el.previousElementSibling; ) {
    const prev2 = el.previousElementSibling;
    selector ? $(prev2).is(selector) && prevEls.push(prev2) : prevEls.push(prev2), el = prev2;
  }
  return $(prevEls);
}
function parent(selector) {
  const parents2 = [];
  for (let i = 0; i < this.length; i += 1)
    this[i].parentNode !== null && (selector ? $(this[i].parentNode).is(selector) && parents2.push(this[i].parentNode) : parents2.push(this[i].parentNode));
  return $(parents2);
}
function parents(selector) {
  const parents2 = [];
  for (let i = 0; i < this.length; i += 1) {
    let parent2 = this[i].parentNode;
    for (; parent2; )
      selector ? $(parent2).is(selector) && parents2.push(parent2) : parents2.push(parent2), parent2 = parent2.parentNode;
  }
  return $(parents2);
}
function closest(selector) {
  let closest2 = this;
  return typeof selector > "u" ? $([]) : (closest2.is(selector) || (closest2 = closest2.parents(selector).eq(0)), closest2);
}
function find(selector) {
  const foundElements = [];
  for (let i = 0; i < this.length; i += 1) {
    const found = this[i].querySelectorAll(selector);
    for (let j = 0; j < found.length; j += 1)
      foundElements.push(found[j]);
  }
  return $(foundElements);
}
function children(selector) {
  const children2 = [];
  for (let i = 0; i < this.length; i += 1) {
    const childNodes = this[i].children;
    for (let j = 0; j < childNodes.length; j += 1)
      (!selector || $(childNodes[j]).is(selector)) && children2.push(childNodes[j]);
  }
  return $(children2);
}
function remove() {
  for (let i = 0; i < this.length; i += 1)
    this[i].parentNode && this[i].parentNode.removeChild(this[i]);
  return this;
}
const Methods = {
  addClass,
  removeClass,
  hasClass,
  toggleClass,
  attr,
  removeAttr,
  transform,
  transition: transition$1,
  on,
  off,
  trigger,
  transitionEnd: transitionEnd$1,
  outerWidth,
  outerHeight,
  styles,
  offset,
  css,
  each,
  html,
  text,
  is,
  index,
  eq,
  append,
  prepend,
  next,
  nextAll,
  prev,
  prevAll,
  parent,
  parents,
  closest,
  find,
  children,
  filter,
  remove
};
Object.keys(Methods).forEach((methodName) => {
  Object.defineProperty($.fn, methodName, {
    value: Methods[methodName],
    writable: !0
  });
});
function deleteProps(obj) {
  const object = obj;
  Object.keys(object).forEach((key) => {
    try {
      object[key] = null;
    } catch {
    }
    try {
      delete object[key];
    } catch {
    }
  });
}
function nextTick(callback, delay = 0) {
  return setTimeout(callback, delay);
}
function now() {
  return Date.now();
}
function getComputedStyle$1(el) {
  const window2 = getWindow();
  let style;
  return window2.getComputedStyle && (style = window2.getComputedStyle(el, null)), !style && el.currentStyle && (style = el.currentStyle), style || (style = el.style), style;
}
function getTranslate(el, axis = "x") {
  const window2 = getWindow();
  let matrix, curTransform, transformMatrix;
  const curStyle = getComputedStyle$1(el);
  return window2.WebKitCSSMatrix ? (curTransform = curStyle.transform || curStyle.webkitTransform, curTransform.split(",").length > 6 && (curTransform = curTransform.split(", ").map((a) => a.replace(",", ".")).join(", ")), transformMatrix = new window2.WebKitCSSMatrix(curTransform === "none" ? "" : curTransform)) : (transformMatrix = curStyle.MozTransform || curStyle.OTransform || curStyle.MsTransform || curStyle.msTransform || curStyle.transform || curStyle.getPropertyValue("transform").replace("translate(", "matrix(1, 0, 0, 1,"), matrix = transformMatrix.toString().split(",")), axis === "x" && (window2.WebKitCSSMatrix ? curTransform = transformMatrix.m41 : matrix.length === 16 ? curTransform = parseFloat(matrix[12]) : curTransform = parseFloat(matrix[4])), axis === "y" && (window2.WebKitCSSMatrix ? curTransform = transformMatrix.m42 : matrix.length === 16 ? curTransform = parseFloat(matrix[13]) : curTransform = parseFloat(matrix[5])), curTransform || 0;
}
function isObject$1(o) {
  return typeof o == "object" && o !== null && o.constructor && Object.prototype.toString.call(o).slice(8, -1) === "Object";
}
function isNode(node) {
  return typeof window < "u" && typeof window.HTMLElement < "u" ? node instanceof HTMLElement : node && (node.nodeType === 1 || node.nodeType === 11);
}
function extend$1(...args) {
  const to = Object(args[0]), noExtend = ["__proto__", "constructor", "prototype"];
  for (let i = 1; i < args.length; i += 1) {
    const nextSource = args[i];
    if (nextSource != null && !isNode(nextSource)) {
      const keysArray = Object.keys(Object(nextSource)).filter((key) => noExtend.indexOf(key) < 0);
      for (let nextIndex = 0, len = keysArray.length; nextIndex < len; nextIndex += 1) {
        const nextKey = keysArray[nextIndex], desc = Object.getOwnPropertyDescriptor(nextSource, nextKey);
        desc !== void 0 && desc.enumerable && (isObject$1(to[nextKey]) && isObject$1(nextSource[nextKey]) ? nextSource[nextKey].__swiper__ ? to[nextKey] = nextSource[nextKey] : extend$1(to[nextKey], nextSource[nextKey]) : !isObject$1(to[nextKey]) && isObject$1(nextSource[nextKey]) ? (to[nextKey] = {}, nextSource[nextKey].__swiper__ ? to[nextKey] = nextSource[nextKey] : extend$1(to[nextKey], nextSource[nextKey])) : to[nextKey] = nextSource[nextKey]);
      }
    }
  }
  return to;
}
function setCSSProperty(el, varName, varValue) {
  el.style.setProperty(varName, varValue);
}
function animateCSSModeScroll({
  swiper,
  targetPosition,
  side
}) {
  const window2 = getWindow(), startPosition = -swiper.translate;
  let startTime = null, time;
  const duration = swiper.params.speed;
  swiper.wrapperEl.style.scrollSnapType = "none", window2.cancelAnimationFrame(swiper.cssModeFrameID);
  const dir = targetPosition > startPosition ? "next" : "prev", isOutOfBound = (current, target) => dir === "next" && current >= target || dir === "prev" && current <= target, animate = () => {
    time = (/* @__PURE__ */ new Date()).getTime(), startTime === null && (startTime = time);
    const progress = Math.max(Math.min((time - startTime) / duration, 1), 0), easeProgress = 0.5 - Math.cos(progress * Math.PI) / 2;
    let currentPosition = startPosition + easeProgress * (targetPosition - startPosition);
    if (isOutOfBound(currentPosition, targetPosition) && (currentPosition = targetPosition), swiper.wrapperEl.scrollTo({
      [side]: currentPosition
    }), isOutOfBound(currentPosition, targetPosition)) {
      swiper.wrapperEl.style.overflow = "hidden", swiper.wrapperEl.style.scrollSnapType = "", setTimeout(() => {
        swiper.wrapperEl.style.overflow = "", swiper.wrapperEl.scrollTo({
          [side]: currentPosition
        });
      }), window2.cancelAnimationFrame(swiper.cssModeFrameID);
      return;
    }
    swiper.cssModeFrameID = window2.requestAnimationFrame(animate);
  };
  animate();
}
let support;
function calcSupport() {
  const window2 = getWindow(), document2 = getDocument();
  return {
    smoothScroll: document2.documentElement && "scrollBehavior" in document2.documentElement.style,
    touch: !!("ontouchstart" in window2 || window2.DocumentTouch && document2 instanceof window2.DocumentTouch),
    passiveListener: (function() {
      let supportsPassive = !1;
      try {
        const opts = Object.defineProperty({}, "passive", {
          // eslint-disable-next-line
          get() {
            supportsPassive = !0;
          }
        });
        window2.addEventListener("testPassiveListener", null, opts);
      } catch {
      }
      return supportsPassive;
    })(),
    gestures: (function() {
      return "ongesturestart" in window2;
    })()
  };
}
function getSupport() {
  return support || (support = calcSupport()), support;
}
let deviceCached;
function calcDevice({
  userAgent
} = {}) {
  const support2 = getSupport(), window2 = getWindow(), platform = window2.navigator.platform, ua = userAgent || window2.navigator.userAgent, device = {
    ios: !1,
    android: !1
  }, screenWidth = window2.screen.width, screenHeight = window2.screen.height, android = ua.match(/(Android);?[\s\/]+([\d.]+)?/);
  let ipad = ua.match(/(iPad).*OS\s([\d_]+)/);
  const ipod = ua.match(/(iPod)(.*OS\s([\d_]+))?/), iphone = !ipad && ua.match(/(iPhone\sOS|iOS)\s([\d_]+)/), windows = platform === "Win32";
  let macos = platform === "MacIntel";
  const iPadScreens = ["1024x1366", "1366x1024", "834x1194", "1194x834", "834x1112", "1112x834", "768x1024", "1024x768", "820x1180", "1180x820", "810x1080", "1080x810"];
  return !ipad && macos && support2.touch && iPadScreens.indexOf(`${screenWidth}x${screenHeight}`) >= 0 && (ipad = ua.match(/(Version)\/([\d.]+)/), ipad || (ipad = [0, 1, "13_0_0"]), macos = !1), android && !windows && (device.os = "android", device.android = !0), (ipad || iphone || ipod) && (device.os = "ios", device.ios = !0), device;
}
function getDevice(overrides = {}) {
  return deviceCached || (deviceCached = calcDevice(overrides)), deviceCached;
}
let browser;
function calcBrowser() {
  const window2 = getWindow();
  function isSafari() {
    const ua = window2.navigator.userAgent.toLowerCase();
    return ua.indexOf("safari") >= 0 && ua.indexOf("chrome") < 0 && ua.indexOf("android") < 0;
  }
  return {
    isSafari: isSafari(),
    isWebView: /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(window2.navigator.userAgent)
  };
}
function getBrowser() {
  return browser || (browser = calcBrowser()), browser;
}
function Resize({
  swiper,
  on: on2,
  emit
}) {
  const window2 = getWindow();
  let observer = null, animationFrame = null;
  const resizeHandler = () => {
    !swiper || swiper.destroyed || !swiper.initialized || (emit("beforeResize"), emit("resize"));
  }, createObserver = () => {
    !swiper || swiper.destroyed || !swiper.initialized || (observer = new ResizeObserver((entries) => {
      animationFrame = window2.requestAnimationFrame(() => {
        const {
          width,
          height
        } = swiper;
        let newWidth = width, newHeight = height;
        entries.forEach(({
          contentBoxSize,
          contentRect,
          target
        }) => {
          target && target !== swiper.el || (newWidth = contentRect ? contentRect.width : (contentBoxSize[0] || contentBoxSize).inlineSize, newHeight = contentRect ? contentRect.height : (contentBoxSize[0] || contentBoxSize).blockSize);
        }), (newWidth !== width || newHeight !== height) && resizeHandler();
      });
    }), observer.observe(swiper.el));
  }, removeObserver = () => {
    animationFrame && window2.cancelAnimationFrame(animationFrame), observer && observer.unobserve && swiper.el && (observer.unobserve(swiper.el), observer = null);
  }, orientationChangeHandler = () => {
    !swiper || swiper.destroyed || !swiper.initialized || emit("orientationchange");
  };
  on2("init", () => {
    if (swiper.params.resizeObserver && typeof window2.ResizeObserver < "u") {
      createObserver();
      return;
    }
    window2.addEventListener("resize", resizeHandler), window2.addEventListener("orientationchange", orientationChangeHandler);
  }), on2("destroy", () => {
    removeObserver(), window2.removeEventListener("resize", resizeHandler), window2.removeEventListener("orientationchange", orientationChangeHandler);
  });
}
function Observer({
  swiper,
  extendParams,
  on: on2,
  emit
}) {
  const observers = [], window2 = getWindow(), attach = (target, options = {}) => {
    const ObserverFunc = window2.MutationObserver || window2.WebkitMutationObserver, observer = new ObserverFunc((mutations) => {
      if (mutations.length === 1) {
        emit("observerUpdate", mutations[0]);
        return;
      }
      const observerUpdate = function() {
        emit("observerUpdate", mutations[0]);
      };
      window2.requestAnimationFrame ? window2.requestAnimationFrame(observerUpdate) : window2.setTimeout(observerUpdate, 0);
    });
    observer.observe(target, {
      attributes: typeof options.attributes > "u" ? !0 : options.attributes,
      childList: typeof options.childList > "u" ? !0 : options.childList,
      characterData: typeof options.characterData > "u" ? !0 : options.characterData
    }), observers.push(observer);
  }, init2 = () => {
    if (swiper.params.observer) {
      if (swiper.params.observeParents) {
        const containerParents = swiper.$el.parents();
        for (let i = 0; i < containerParents.length; i += 1)
          attach(containerParents[i]);
      }
      attach(swiper.$el[0], {
        childList: swiper.params.observeSlideChildren
      }), attach(swiper.$wrapperEl[0], {
        attributes: !1
      });
    }
  }, destroy = () => {
    observers.forEach((observer) => {
      observer.disconnect();
    }), observers.splice(0, observers.length);
  };
  extendParams({
    observer: !1,
    observeParents: !1,
    observeSlideChildren: !1
  }), on2("init", init2), on2("destroy", destroy);
}
const eventsEmitter = {
  on(events2, handler, priority) {
    const self = this;
    if (!self.eventsListeners || self.destroyed || typeof handler != "function") return self;
    const method = priority ? "unshift" : "push";
    return events2.split(" ").forEach((event) => {
      self.eventsListeners[event] || (self.eventsListeners[event] = []), self.eventsListeners[event][method](handler);
    }), self;
  },
  once(events2, handler, priority) {
    const self = this;
    if (!self.eventsListeners || self.destroyed || typeof handler != "function") return self;
    function onceHandler(...args) {
      self.off(events2, onceHandler), onceHandler.__emitterProxy && delete onceHandler.__emitterProxy, handler.apply(self, args);
    }
    return onceHandler.__emitterProxy = handler, self.on(events2, onceHandler, priority);
  },
  onAny(handler, priority) {
    const self = this;
    if (!self.eventsListeners || self.destroyed || typeof handler != "function") return self;
    const method = priority ? "unshift" : "push";
    return self.eventsAnyListeners.indexOf(handler) < 0 && self.eventsAnyListeners[method](handler), self;
  },
  offAny(handler) {
    const self = this;
    if (!self.eventsListeners || self.destroyed || !self.eventsAnyListeners) return self;
    const index2 = self.eventsAnyListeners.indexOf(handler);
    return index2 >= 0 && self.eventsAnyListeners.splice(index2, 1), self;
  },
  off(events2, handler) {
    const self = this;
    return !self.eventsListeners || self.destroyed || !self.eventsListeners || events2.split(" ").forEach((event) => {
      typeof handler > "u" ? self.eventsListeners[event] = [] : self.eventsListeners[event] && self.eventsListeners[event].forEach((eventHandler, index2) => {
        (eventHandler === handler || eventHandler.__emitterProxy && eventHandler.__emitterProxy === handler) && self.eventsListeners[event].splice(index2, 1);
      });
    }), self;
  },
  emit(...args) {
    const self = this;
    if (!self.eventsListeners || self.destroyed || !self.eventsListeners) return self;
    let events2, data, context;
    return typeof args[0] == "string" || Array.isArray(args[0]) ? (events2 = args[0], data = args.slice(1, args.length), context = self) : (events2 = args[0].events, data = args[0].data, context = args[0].context || self), data.unshift(context), (Array.isArray(events2) ? events2 : events2.split(" ")).forEach((event) => {
      self.eventsAnyListeners && self.eventsAnyListeners.length && self.eventsAnyListeners.forEach((eventHandler) => {
        eventHandler.apply(context, [event, ...data]);
      }), self.eventsListeners && self.eventsListeners[event] && self.eventsListeners[event].forEach((eventHandler) => {
        eventHandler.apply(context, data);
      });
    }), self;
  }
};
function updateSize() {
  const swiper = this;
  let width, height;
  const $el = swiper.$el;
  typeof swiper.params.width < "u" && swiper.params.width !== null ? width = swiper.params.width : width = $el[0].clientWidth, typeof swiper.params.height < "u" && swiper.params.height !== null ? height = swiper.params.height : height = $el[0].clientHeight, !(width === 0 && swiper.isHorizontal() || height === 0 && swiper.isVertical()) && (width = width - parseInt($el.css("padding-left") || 0, 10) - parseInt($el.css("padding-right") || 0, 10), height = height - parseInt($el.css("padding-top") || 0, 10) - parseInt($el.css("padding-bottom") || 0, 10), Number.isNaN(width) && (width = 0), Number.isNaN(height) && (height = 0), Object.assign(swiper, {
    width,
    height,
    size: swiper.isHorizontal() ? width : height
  }));
}
function updateSlides() {
  const swiper = this;
  function getDirectionLabel(property) {
    return swiper.isHorizontal() ? property : {
      width: "height",
      "margin-top": "margin-left",
      "margin-bottom ": "margin-right",
      "margin-left": "margin-top",
      "margin-right": "margin-bottom",
      "padding-left": "padding-top",
      "padding-right": "padding-bottom",
      marginRight: "marginBottom"
    }[property];
  }
  function getDirectionPropertyValue(node, label) {
    return parseFloat(node.getPropertyValue(getDirectionLabel(label)) || 0);
  }
  const params = swiper.params, {
    $wrapperEl,
    size: swiperSize,
    rtlTranslate: rtl,
    wrongRTL
  } = swiper, isVirtual = swiper.virtual && params.virtual.enabled, previousSlidesLength = isVirtual ? swiper.virtual.slides.length : swiper.slides.length, slides = $wrapperEl.children(`.${swiper.params.slideClass}`), slidesLength = isVirtual ? swiper.virtual.slides.length : slides.length;
  let snapGrid = [];
  const slidesGrid = [], slidesSizesGrid = [];
  let offsetBefore = params.slidesOffsetBefore;
  typeof offsetBefore == "function" && (offsetBefore = params.slidesOffsetBefore.call(swiper));
  let offsetAfter = params.slidesOffsetAfter;
  typeof offsetAfter == "function" && (offsetAfter = params.slidesOffsetAfter.call(swiper));
  const previousSnapGridLength = swiper.snapGrid.length, previousSlidesGridLength = swiper.slidesGrid.length;
  let spaceBetween = params.spaceBetween, slidePosition = -offsetBefore, prevSlideSize = 0, index2 = 0;
  if (typeof swiperSize > "u")
    return;
  typeof spaceBetween == "string" && spaceBetween.indexOf("%") >= 0 && (spaceBetween = parseFloat(spaceBetween.replace("%", "")) / 100 * swiperSize), swiper.virtualSize = -spaceBetween, rtl ? slides.css({
    marginLeft: "",
    marginBottom: "",
    marginTop: ""
  }) : slides.css({
    marginRight: "",
    marginBottom: "",
    marginTop: ""
  }), params.centeredSlides && params.cssMode && (setCSSProperty(swiper.wrapperEl, "--swiper-centered-offset-before", ""), setCSSProperty(swiper.wrapperEl, "--swiper-centered-offset-after", ""));
  const gridEnabled = params.grid && params.grid.rows > 1 && swiper.grid;
  gridEnabled && swiper.grid.initSlides(slidesLength);
  let slideSize;
  const shouldResetSlideSize = params.slidesPerView === "auto" && params.breakpoints && Object.keys(params.breakpoints).filter((key) => typeof params.breakpoints[key].slidesPerView < "u").length > 0;
  for (let i = 0; i < slidesLength; i += 1) {
    slideSize = 0;
    const slide2 = slides.eq(i);
    if (gridEnabled && swiper.grid.updateSlide(i, slide2, slidesLength, getDirectionLabel), slide2.css("display") !== "none") {
      if (params.slidesPerView === "auto") {
        shouldResetSlideSize && (slides[i].style[getDirectionLabel("width")] = "");
        const slideStyles = getComputedStyle(slide2[0]), currentTransform = slide2[0].style.transform, currentWebKitTransform = slide2[0].style.webkitTransform;
        if (currentTransform && (slide2[0].style.transform = "none"), currentWebKitTransform && (slide2[0].style.webkitTransform = "none"), params.roundLengths)
          slideSize = swiper.isHorizontal() ? slide2.outerWidth(!0) : slide2.outerHeight(!0);
        else {
          const width = getDirectionPropertyValue(slideStyles, "width"), paddingLeft = getDirectionPropertyValue(slideStyles, "padding-left"), paddingRight = getDirectionPropertyValue(slideStyles, "padding-right"), marginLeft = getDirectionPropertyValue(slideStyles, "margin-left"), marginRight = getDirectionPropertyValue(slideStyles, "margin-right"), boxSizing = slideStyles.getPropertyValue("box-sizing");
          if (boxSizing && boxSizing === "border-box")
            slideSize = width + marginLeft + marginRight;
          else {
            const {
              clientWidth,
              offsetWidth
            } = slide2[0];
            slideSize = width + paddingLeft + paddingRight + marginLeft + marginRight + (offsetWidth - clientWidth);
          }
        }
        currentTransform && (slide2[0].style.transform = currentTransform), currentWebKitTransform && (slide2[0].style.webkitTransform = currentWebKitTransform), params.roundLengths && (slideSize = Math.floor(slideSize));
      } else
        slideSize = (swiperSize - (params.slidesPerView - 1) * spaceBetween) / params.slidesPerView, params.roundLengths && (slideSize = Math.floor(slideSize)), slides[i] && (slides[i].style[getDirectionLabel("width")] = `${slideSize}px`);
      slides[i] && (slides[i].swiperSlideSize = slideSize), slidesSizesGrid.push(slideSize), params.centeredSlides ? (slidePosition = slidePosition + slideSize / 2 + prevSlideSize / 2 + spaceBetween, prevSlideSize === 0 && i !== 0 && (slidePosition = slidePosition - swiperSize / 2 - spaceBetween), i === 0 && (slidePosition = slidePosition - swiperSize / 2 - spaceBetween), Math.abs(slidePosition) < 1 / 1e3 && (slidePosition = 0), params.roundLengths && (slidePosition = Math.floor(slidePosition)), index2 % params.slidesPerGroup === 0 && snapGrid.push(slidePosition), slidesGrid.push(slidePosition)) : (params.roundLengths && (slidePosition = Math.floor(slidePosition)), (index2 - Math.min(swiper.params.slidesPerGroupSkip, index2)) % swiper.params.slidesPerGroup === 0 && snapGrid.push(slidePosition), slidesGrid.push(slidePosition), slidePosition = slidePosition + slideSize + spaceBetween), swiper.virtualSize += slideSize + spaceBetween, prevSlideSize = slideSize, index2 += 1;
    }
  }
  if (swiper.virtualSize = Math.max(swiper.virtualSize, swiperSize) + offsetAfter, rtl && wrongRTL && (params.effect === "slide" || params.effect === "coverflow") && $wrapperEl.css({
    width: `${swiper.virtualSize + params.spaceBetween}px`
  }), params.setWrapperSize && $wrapperEl.css({
    [getDirectionLabel("width")]: `${swiper.virtualSize + params.spaceBetween}px`
  }), gridEnabled && swiper.grid.updateWrapperSize(slideSize, snapGrid, getDirectionLabel), !params.centeredSlides) {
    const newSlidesGrid = [];
    for (let i = 0; i < snapGrid.length; i += 1) {
      let slidesGridItem = snapGrid[i];
      params.roundLengths && (slidesGridItem = Math.floor(slidesGridItem)), snapGrid[i] <= swiper.virtualSize - swiperSize && newSlidesGrid.push(slidesGridItem);
    }
    snapGrid = newSlidesGrid, Math.floor(swiper.virtualSize - swiperSize) - Math.floor(snapGrid[snapGrid.length - 1]) > 1 && snapGrid.push(swiper.virtualSize - swiperSize);
  }
  if (snapGrid.length === 0 && (snapGrid = [0]), params.spaceBetween !== 0) {
    const key = swiper.isHorizontal() && rtl ? "marginLeft" : getDirectionLabel("marginRight");
    slides.filter((_, slideIndex) => params.cssMode ? slideIndex !== slides.length - 1 : !0).css({
      [key]: `${spaceBetween}px`
    });
  }
  if (params.centeredSlides && params.centeredSlidesBounds) {
    let allSlidesSize = 0;
    slidesSizesGrid.forEach((slideSizeValue) => {
      allSlidesSize += slideSizeValue + (params.spaceBetween ? params.spaceBetween : 0);
    }), allSlidesSize -= params.spaceBetween;
    const maxSnap = allSlidesSize - swiperSize;
    snapGrid = snapGrid.map((snap) => snap < 0 ? -offsetBefore : snap > maxSnap ? maxSnap + offsetAfter : snap);
  }
  if (params.centerInsufficientSlides) {
    let allSlidesSize = 0;
    if (slidesSizesGrid.forEach((slideSizeValue) => {
      allSlidesSize += slideSizeValue + (params.spaceBetween ? params.spaceBetween : 0);
    }), allSlidesSize -= params.spaceBetween, allSlidesSize < swiperSize) {
      const allSlidesOffset = (swiperSize - allSlidesSize) / 2;
      snapGrid.forEach((snap, snapIndex) => {
        snapGrid[snapIndex] = snap - allSlidesOffset;
      }), slidesGrid.forEach((snap, snapIndex) => {
        slidesGrid[snapIndex] = snap + allSlidesOffset;
      });
    }
  }
  if (Object.assign(swiper, {
    slides,
    snapGrid,
    slidesGrid,
    slidesSizesGrid
  }), params.centeredSlides && params.cssMode && !params.centeredSlidesBounds) {
    setCSSProperty(swiper.wrapperEl, "--swiper-centered-offset-before", `${-snapGrid[0]}px`), setCSSProperty(swiper.wrapperEl, "--swiper-centered-offset-after", `${swiper.size / 2 - slidesSizesGrid[slidesSizesGrid.length - 1] / 2}px`);
    const addToSnapGrid = -swiper.snapGrid[0], addToSlidesGrid = -swiper.slidesGrid[0];
    swiper.snapGrid = swiper.snapGrid.map((v) => v + addToSnapGrid), swiper.slidesGrid = swiper.slidesGrid.map((v) => v + addToSlidesGrid);
  }
  if (slidesLength !== previousSlidesLength && swiper.emit("slidesLengthChange"), snapGrid.length !== previousSnapGridLength && (swiper.params.watchOverflow && swiper.checkOverflow(), swiper.emit("snapGridLengthChange")), slidesGrid.length !== previousSlidesGridLength && swiper.emit("slidesGridLengthChange"), params.watchSlidesProgress && swiper.updateSlidesOffset(), !isVirtual && !params.cssMode && (params.effect === "slide" || params.effect === "fade")) {
    const backFaceHiddenClass = `${params.containerModifierClass}backface-hidden`, hasClassBackfaceClassAdded = swiper.$el.hasClass(backFaceHiddenClass);
    slidesLength <= params.maxBackfaceHiddenSlides ? hasClassBackfaceClassAdded || swiper.$el.addClass(backFaceHiddenClass) : hasClassBackfaceClassAdded && swiper.$el.removeClass(backFaceHiddenClass);
  }
}
function updateAutoHeight(speed) {
  const swiper = this, activeSlides = [], isVirtual = swiper.virtual && swiper.params.virtual.enabled;
  let newHeight = 0, i;
  typeof speed == "number" ? swiper.setTransition(speed) : speed === !0 && swiper.setTransition(swiper.params.speed);
  const getSlideByIndex = (index2) => isVirtual ? swiper.slides.filter((el) => parseInt(el.getAttribute("data-swiper-slide-index"), 10) === index2)[0] : swiper.slides.eq(index2)[0];
  if (swiper.params.slidesPerView !== "auto" && swiper.params.slidesPerView > 1)
    if (swiper.params.centeredSlides)
      (swiper.visibleSlides || $([])).each((slide2) => {
        activeSlides.push(slide2);
      });
    else
      for (i = 0; i < Math.ceil(swiper.params.slidesPerView); i += 1) {
        const index2 = swiper.activeIndex + i;
        if (index2 > swiper.slides.length && !isVirtual) break;
        activeSlides.push(getSlideByIndex(index2));
      }
  else
    activeSlides.push(getSlideByIndex(swiper.activeIndex));
  for (i = 0; i < activeSlides.length; i += 1)
    if (typeof activeSlides[i] < "u") {
      const height = activeSlides[i].offsetHeight;
      newHeight = height > newHeight ? height : newHeight;
    }
  (newHeight || newHeight === 0) && swiper.$wrapperEl.css("height", `${newHeight}px`);
}
function updateSlidesOffset() {
  const swiper = this, slides = swiper.slides;
  for (let i = 0; i < slides.length; i += 1)
    slides[i].swiperSlideOffset = swiper.isHorizontal() ? slides[i].offsetLeft : slides[i].offsetTop;
}
function updateSlidesProgress(translate2 = this && this.translate || 0) {
  const swiper = this, params = swiper.params, {
    slides,
    rtlTranslate: rtl,
    snapGrid
  } = swiper;
  if (slides.length === 0) return;
  typeof slides[0].swiperSlideOffset > "u" && swiper.updateSlidesOffset();
  let offsetCenter = -translate2;
  rtl && (offsetCenter = translate2), slides.removeClass(params.slideVisibleClass), swiper.visibleSlidesIndexes = [], swiper.visibleSlides = [];
  for (let i = 0; i < slides.length; i += 1) {
    const slide2 = slides[i];
    let slideOffset = slide2.swiperSlideOffset;
    params.cssMode && params.centeredSlides && (slideOffset -= slides[0].swiperSlideOffset);
    const slideProgress = (offsetCenter + (params.centeredSlides ? swiper.minTranslate() : 0) - slideOffset) / (slide2.swiperSlideSize + params.spaceBetween), originalSlideProgress = (offsetCenter - snapGrid[0] + (params.centeredSlides ? swiper.minTranslate() : 0) - slideOffset) / (slide2.swiperSlideSize + params.spaceBetween), slideBefore = -(offsetCenter - slideOffset), slideAfter = slideBefore + swiper.slidesSizesGrid[i];
    (slideBefore >= 0 && slideBefore < swiper.size - 1 || slideAfter > 1 && slideAfter <= swiper.size || slideBefore <= 0 && slideAfter >= swiper.size) && (swiper.visibleSlides.push(slide2), swiper.visibleSlidesIndexes.push(i), slides.eq(i).addClass(params.slideVisibleClass)), slide2.progress = rtl ? -slideProgress : slideProgress, slide2.originalProgress = rtl ? -originalSlideProgress : originalSlideProgress;
  }
  swiper.visibleSlides = $(swiper.visibleSlides);
}
function updateProgress(translate2) {
  const swiper = this;
  if (typeof translate2 > "u") {
    const multiplier = swiper.rtlTranslate ? -1 : 1;
    translate2 = swiper && swiper.translate && swiper.translate * multiplier || 0;
  }
  const params = swiper.params, translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
  let {
    progress,
    isBeginning,
    isEnd
  } = swiper;
  const wasBeginning = isBeginning, wasEnd = isEnd;
  translatesDiff === 0 ? (progress = 0, isBeginning = !0, isEnd = !0) : (progress = (translate2 - swiper.minTranslate()) / translatesDiff, isBeginning = progress <= 0, isEnd = progress >= 1), Object.assign(swiper, {
    progress,
    isBeginning,
    isEnd
  }), (params.watchSlidesProgress || params.centeredSlides && params.autoHeight) && swiper.updateSlidesProgress(translate2), isBeginning && !wasBeginning && swiper.emit("reachBeginning toEdge"), isEnd && !wasEnd && swiper.emit("reachEnd toEdge"), (wasBeginning && !isBeginning || wasEnd && !isEnd) && swiper.emit("fromEdge"), swiper.emit("progress", progress);
}
function updateSlidesClasses() {
  const swiper = this, {
    slides,
    params,
    $wrapperEl,
    activeIndex,
    realIndex
  } = swiper, isVirtual = swiper.virtual && params.virtual.enabled;
  slides.removeClass(`${params.slideActiveClass} ${params.slideNextClass} ${params.slidePrevClass} ${params.slideDuplicateActiveClass} ${params.slideDuplicateNextClass} ${params.slideDuplicatePrevClass}`);
  let activeSlide;
  isVirtual ? activeSlide = swiper.$wrapperEl.find(`.${params.slideClass}[data-swiper-slide-index="${activeIndex}"]`) : activeSlide = slides.eq(activeIndex), activeSlide.addClass(params.slideActiveClass), params.loop && (activeSlide.hasClass(params.slideDuplicateClass) ? $wrapperEl.children(`.${params.slideClass}:not(.${params.slideDuplicateClass})[data-swiper-slide-index="${realIndex}"]`).addClass(params.slideDuplicateActiveClass) : $wrapperEl.children(`.${params.slideClass}.${params.slideDuplicateClass}[data-swiper-slide-index="${realIndex}"]`).addClass(params.slideDuplicateActiveClass));
  let nextSlide = activeSlide.nextAll(`.${params.slideClass}`).eq(0).addClass(params.slideNextClass);
  params.loop && nextSlide.length === 0 && (nextSlide = slides.eq(0), nextSlide.addClass(params.slideNextClass));
  let prevSlide = activeSlide.prevAll(`.${params.slideClass}`).eq(0).addClass(params.slidePrevClass);
  params.loop && prevSlide.length === 0 && (prevSlide = slides.eq(-1), prevSlide.addClass(params.slidePrevClass)), params.loop && (nextSlide.hasClass(params.slideDuplicateClass) ? $wrapperEl.children(`.${params.slideClass}:not(.${params.slideDuplicateClass})[data-swiper-slide-index="${nextSlide.attr("data-swiper-slide-index")}"]`).addClass(params.slideDuplicateNextClass) : $wrapperEl.children(`.${params.slideClass}.${params.slideDuplicateClass}[data-swiper-slide-index="${nextSlide.attr("data-swiper-slide-index")}"]`).addClass(params.slideDuplicateNextClass), prevSlide.hasClass(params.slideDuplicateClass) ? $wrapperEl.children(`.${params.slideClass}:not(.${params.slideDuplicateClass})[data-swiper-slide-index="${prevSlide.attr("data-swiper-slide-index")}"]`).addClass(params.slideDuplicatePrevClass) : $wrapperEl.children(`.${params.slideClass}.${params.slideDuplicateClass}[data-swiper-slide-index="${prevSlide.attr("data-swiper-slide-index")}"]`).addClass(params.slideDuplicatePrevClass)), swiper.emitSlidesClasses();
}
function updateActiveIndex(newActiveIndex) {
  const swiper = this, translate2 = swiper.rtlTranslate ? swiper.translate : -swiper.translate, {
    slidesGrid,
    snapGrid,
    params,
    activeIndex: previousIndex,
    realIndex: previousRealIndex,
    snapIndex: previousSnapIndex
  } = swiper;
  let activeIndex = newActiveIndex, snapIndex;
  if (typeof activeIndex > "u") {
    for (let i = 0; i < slidesGrid.length; i += 1)
      typeof slidesGrid[i + 1] < "u" ? translate2 >= slidesGrid[i] && translate2 < slidesGrid[i + 1] - (slidesGrid[i + 1] - slidesGrid[i]) / 2 ? activeIndex = i : translate2 >= slidesGrid[i] && translate2 < slidesGrid[i + 1] && (activeIndex = i + 1) : translate2 >= slidesGrid[i] && (activeIndex = i);
    params.normalizeSlideIndex && (activeIndex < 0 || typeof activeIndex > "u") && (activeIndex = 0);
  }
  if (snapGrid.indexOf(translate2) >= 0)
    snapIndex = snapGrid.indexOf(translate2);
  else {
    const skip = Math.min(params.slidesPerGroupSkip, activeIndex);
    snapIndex = skip + Math.floor((activeIndex - skip) / params.slidesPerGroup);
  }
  if (snapIndex >= snapGrid.length && (snapIndex = snapGrid.length - 1), activeIndex === previousIndex) {
    snapIndex !== previousSnapIndex && (swiper.snapIndex = snapIndex, swiper.emit("snapIndexChange"));
    return;
  }
  const realIndex = parseInt(swiper.slides.eq(activeIndex).attr("data-swiper-slide-index") || activeIndex, 10);
  Object.assign(swiper, {
    snapIndex,
    realIndex,
    previousIndex,
    activeIndex
  }), swiper.emit("activeIndexChange"), swiper.emit("snapIndexChange"), previousRealIndex !== realIndex && swiper.emit("realIndexChange"), (swiper.initialized || swiper.params.runCallbacksOnInit) && swiper.emit("slideChange");
}
function updateClickedSlide(e) {
  const swiper = this, params = swiper.params, slide2 = $(e).closest(`.${params.slideClass}`)[0];
  let slideFound = !1, slideIndex;
  if (slide2) {
    for (let i = 0; i < swiper.slides.length; i += 1)
      if (swiper.slides[i] === slide2) {
        slideFound = !0, slideIndex = i;
        break;
      }
  }
  if (slide2 && slideFound)
    swiper.clickedSlide = slide2, swiper.virtual && swiper.params.virtual.enabled ? swiper.clickedIndex = parseInt($(slide2).attr("data-swiper-slide-index"), 10) : swiper.clickedIndex = slideIndex;
  else {
    swiper.clickedSlide = void 0, swiper.clickedIndex = void 0;
    return;
  }
  params.slideToClickedSlide && swiper.clickedIndex !== void 0 && swiper.clickedIndex !== swiper.activeIndex && swiper.slideToClickedSlide();
}
const update = {
  updateSize,
  updateSlides,
  updateAutoHeight,
  updateSlidesOffset,
  updateSlidesProgress,
  updateProgress,
  updateSlidesClasses,
  updateActiveIndex,
  updateClickedSlide
};
function getSwiperTranslate(axis = this.isHorizontal() ? "x" : "y") {
  const swiper = this, {
    params,
    rtlTranslate: rtl,
    translate: translate2,
    $wrapperEl
  } = swiper;
  if (params.virtualTranslate)
    return rtl ? -translate2 : translate2;
  if (params.cssMode)
    return translate2;
  let currentTranslate = getTranslate($wrapperEl[0], axis);
  return rtl && (currentTranslate = -currentTranslate), currentTranslate || 0;
}
function setTranslate(translate2, byController) {
  const swiper = this, {
    rtlTranslate: rtl,
    params,
    $wrapperEl,
    wrapperEl,
    progress
  } = swiper;
  let x = 0, y = 0;
  const z = 0;
  swiper.isHorizontal() ? x = rtl ? -translate2 : translate2 : y = translate2, params.roundLengths && (x = Math.floor(x), y = Math.floor(y)), params.cssMode ? wrapperEl[swiper.isHorizontal() ? "scrollLeft" : "scrollTop"] = swiper.isHorizontal() ? -x : -y : params.virtualTranslate || $wrapperEl.transform(`translate3d(${x}px, ${y}px, ${z}px)`), swiper.previousTranslate = swiper.translate, swiper.translate = swiper.isHorizontal() ? x : y;
  let newProgress;
  const translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
  translatesDiff === 0 ? newProgress = 0 : newProgress = (translate2 - swiper.minTranslate()) / translatesDiff, newProgress !== progress && swiper.updateProgress(translate2), swiper.emit("setTranslate", swiper.translate, byController);
}
function minTranslate() {
  return -this.snapGrid[0];
}
function maxTranslate() {
  return -this.snapGrid[this.snapGrid.length - 1];
}
function translateTo(translate2 = 0, speed = this.params.speed, runCallbacks = !0, translateBounds = !0, internal) {
  const swiper = this, {
    params,
    wrapperEl
  } = swiper;
  if (swiper.animating && params.preventInteractionOnTransition)
    return !1;
  const minTranslate2 = swiper.minTranslate(), maxTranslate2 = swiper.maxTranslate();
  let newTranslate;
  if (translateBounds && translate2 > minTranslate2 ? newTranslate = minTranslate2 : translateBounds && translate2 < maxTranslate2 ? newTranslate = maxTranslate2 : newTranslate = translate2, swiper.updateProgress(newTranslate), params.cssMode) {
    const isH = swiper.isHorizontal();
    if (speed === 0)
      wrapperEl[isH ? "scrollLeft" : "scrollTop"] = -newTranslate;
    else {
      if (!swiper.support.smoothScroll)
        return animateCSSModeScroll({
          swiper,
          targetPosition: -newTranslate,
          side: isH ? "left" : "top"
        }), !0;
      wrapperEl.scrollTo({
        [isH ? "left" : "top"]: -newTranslate,
        behavior: "smooth"
      });
    }
    return !0;
  }
  return speed === 0 ? (swiper.setTransition(0), swiper.setTranslate(newTranslate), runCallbacks && (swiper.emit("beforeTransitionStart", speed, internal), swiper.emit("transitionEnd"))) : (swiper.setTransition(speed), swiper.setTranslate(newTranslate), runCallbacks && (swiper.emit("beforeTransitionStart", speed, internal), swiper.emit("transitionStart")), swiper.animating || (swiper.animating = !0, swiper.onTranslateToWrapperTransitionEnd || (swiper.onTranslateToWrapperTransitionEnd = function(e) {
    !swiper || swiper.destroyed || e.target === this && (swiper.$wrapperEl[0].removeEventListener("transitionend", swiper.onTranslateToWrapperTransitionEnd), swiper.$wrapperEl[0].removeEventListener("webkitTransitionEnd", swiper.onTranslateToWrapperTransitionEnd), swiper.onTranslateToWrapperTransitionEnd = null, delete swiper.onTranslateToWrapperTransitionEnd, runCallbacks && swiper.emit("transitionEnd"));
  }), swiper.$wrapperEl[0].addEventListener("transitionend", swiper.onTranslateToWrapperTransitionEnd), swiper.$wrapperEl[0].addEventListener("webkitTransitionEnd", swiper.onTranslateToWrapperTransitionEnd))), !0;
}
const translate = {
  getTranslate: getSwiperTranslate,
  setTranslate,
  minTranslate,
  maxTranslate,
  translateTo
};
function setTransition(duration, byController) {
  const swiper = this;
  swiper.params.cssMode || swiper.$wrapperEl.transition(duration), swiper.emit("setTransition", duration, byController);
}
function transitionEmit({
  swiper,
  runCallbacks,
  direction,
  step
}) {
  const {
    activeIndex,
    previousIndex
  } = swiper;
  let dir = direction;
  if (dir || (activeIndex > previousIndex ? dir = "next" : activeIndex < previousIndex ? dir = "prev" : dir = "reset"), swiper.emit(`transition${step}`), runCallbacks && activeIndex !== previousIndex) {
    if (dir === "reset") {
      swiper.emit(`slideResetTransition${step}`);
      return;
    }
    swiper.emit(`slideChangeTransition${step}`), dir === "next" ? swiper.emit(`slideNextTransition${step}`) : swiper.emit(`slidePrevTransition${step}`);
  }
}
function transitionStart(runCallbacks = !0, direction) {
  const swiper = this, {
    params
  } = swiper;
  params.cssMode || (params.autoHeight && swiper.updateAutoHeight(), transitionEmit({
    swiper,
    runCallbacks,
    direction,
    step: "Start"
  }));
}
function transitionEnd(runCallbacks = !0, direction) {
  const swiper = this, {
    params
  } = swiper;
  swiper.animating = !1, !params.cssMode && (swiper.setTransition(0), transitionEmit({
    swiper,
    runCallbacks,
    direction,
    step: "End"
  }));
}
const transition = {
  setTransition,
  transitionStart,
  transitionEnd
};
function slideTo(index2 = 0, speed = this.params.speed, runCallbacks = !0, internal, initial) {
  if (typeof index2 != "number" && typeof index2 != "string")
    throw new Error(`The 'index' argument cannot have type other than 'number' or 'string'. [${typeof index2}] given.`);
  if (typeof index2 == "string") {
    const indexAsNumber = parseInt(index2, 10);
    if (!isFinite(indexAsNumber))
      throw new Error(`The passed-in 'index' (string) couldn't be converted to 'number'. [${index2}] given.`);
    index2 = indexAsNumber;
  }
  const swiper = this;
  let slideIndex = index2;
  slideIndex < 0 && (slideIndex = 0);
  const {
    params,
    snapGrid,
    slidesGrid,
    previousIndex,
    activeIndex,
    rtlTranslate: rtl,
    wrapperEl,
    enabled
  } = swiper;
  if (swiper.animating && params.preventInteractionOnTransition || !enabled && !internal && !initial)
    return !1;
  const skip = Math.min(swiper.params.slidesPerGroupSkip, slideIndex);
  let snapIndex = skip + Math.floor((slideIndex - skip) / swiper.params.slidesPerGroup);
  snapIndex >= snapGrid.length && (snapIndex = snapGrid.length - 1);
  const translate2 = -snapGrid[snapIndex];
  if (params.normalizeSlideIndex)
    for (let i = 0; i < slidesGrid.length; i += 1) {
      const normalizedTranslate = -Math.floor(translate2 * 100), normalizedGrid = Math.floor(slidesGrid[i] * 100), normalizedGridNext = Math.floor(slidesGrid[i + 1] * 100);
      typeof slidesGrid[i + 1] < "u" ? normalizedTranslate >= normalizedGrid && normalizedTranslate < normalizedGridNext - (normalizedGridNext - normalizedGrid) / 2 ? slideIndex = i : normalizedTranslate >= normalizedGrid && normalizedTranslate < normalizedGridNext && (slideIndex = i + 1) : normalizedTranslate >= normalizedGrid && (slideIndex = i);
    }
  if (swiper.initialized && slideIndex !== activeIndex && (!swiper.allowSlideNext && translate2 < swiper.translate && translate2 < swiper.minTranslate() || !swiper.allowSlidePrev && translate2 > swiper.translate && translate2 > swiper.maxTranslate() && (activeIndex || 0) !== slideIndex))
    return !1;
  slideIndex !== (previousIndex || 0) && runCallbacks && swiper.emit("beforeSlideChangeStart"), swiper.updateProgress(translate2);
  let direction;
  if (slideIndex > activeIndex ? direction = "next" : slideIndex < activeIndex ? direction = "prev" : direction = "reset", rtl && -translate2 === swiper.translate || !rtl && translate2 === swiper.translate)
    return swiper.updateActiveIndex(slideIndex), params.autoHeight && swiper.updateAutoHeight(), swiper.updateSlidesClasses(), params.effect !== "slide" && swiper.setTranslate(translate2), direction !== "reset" && (swiper.transitionStart(runCallbacks, direction), swiper.transitionEnd(runCallbacks, direction)), !1;
  if (params.cssMode) {
    const isH = swiper.isHorizontal(), t = rtl ? translate2 : -translate2;
    if (speed === 0) {
      const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
      isVirtual && (swiper.wrapperEl.style.scrollSnapType = "none", swiper._immediateVirtual = !0), wrapperEl[isH ? "scrollLeft" : "scrollTop"] = t, isVirtual && requestAnimationFrame(() => {
        swiper.wrapperEl.style.scrollSnapType = "", swiper._swiperImmediateVirtual = !1;
      });
    } else {
      if (!swiper.support.smoothScroll)
        return animateCSSModeScroll({
          swiper,
          targetPosition: t,
          side: isH ? "left" : "top"
        }), !0;
      wrapperEl.scrollTo({
        [isH ? "left" : "top"]: t,
        behavior: "smooth"
      });
    }
    return !0;
  }
  return swiper.setTransition(speed), swiper.setTranslate(translate2), swiper.updateActiveIndex(slideIndex), swiper.updateSlidesClasses(), swiper.emit("beforeTransitionStart", speed, internal), swiper.transitionStart(runCallbacks, direction), speed === 0 ? swiper.transitionEnd(runCallbacks, direction) : swiper.animating || (swiper.animating = !0, swiper.onSlideToWrapperTransitionEnd || (swiper.onSlideToWrapperTransitionEnd = function(e) {
    !swiper || swiper.destroyed || e.target === this && (swiper.$wrapperEl[0].removeEventListener("transitionend", swiper.onSlideToWrapperTransitionEnd), swiper.$wrapperEl[0].removeEventListener("webkitTransitionEnd", swiper.onSlideToWrapperTransitionEnd), swiper.onSlideToWrapperTransitionEnd = null, delete swiper.onSlideToWrapperTransitionEnd, swiper.transitionEnd(runCallbacks, direction));
  }), swiper.$wrapperEl[0].addEventListener("transitionend", swiper.onSlideToWrapperTransitionEnd), swiper.$wrapperEl[0].addEventListener("webkitTransitionEnd", swiper.onSlideToWrapperTransitionEnd)), !0;
}
function slideToLoop(index2 = 0, speed = this.params.speed, runCallbacks = !0, internal) {
  if (typeof index2 == "string") {
    const indexAsNumber = parseInt(index2, 10);
    if (!isFinite(indexAsNumber))
      throw new Error(`The passed-in 'index' (string) couldn't be converted to 'number'. [${index2}] given.`);
    index2 = indexAsNumber;
  }
  const swiper = this;
  let newIndex = index2;
  return swiper.params.loop && (newIndex += swiper.loopedSlides), swiper.slideTo(newIndex, speed, runCallbacks, internal);
}
function slideNext(speed = this.params.speed, runCallbacks = !0, internal) {
  const swiper = this, {
    animating,
    enabled,
    params
  } = swiper;
  if (!enabled) return swiper;
  let perGroup = params.slidesPerGroup;
  params.slidesPerView === "auto" && params.slidesPerGroup === 1 && params.slidesPerGroupAuto && (perGroup = Math.max(swiper.slidesPerViewDynamic("current", !0), 1));
  const increment = swiper.activeIndex < params.slidesPerGroupSkip ? 1 : perGroup;
  if (params.loop) {
    if (animating && params.loopPreventsSlide) return !1;
    swiper.loopFix(), swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
  }
  return params.rewind && swiper.isEnd ? swiper.slideTo(0, speed, runCallbacks, internal) : swiper.slideTo(swiper.activeIndex + increment, speed, runCallbacks, internal);
}
function slidePrev(speed = this.params.speed, runCallbacks = !0, internal) {
  const swiper = this, {
    params,
    animating,
    snapGrid,
    slidesGrid,
    rtlTranslate,
    enabled
  } = swiper;
  if (!enabled) return swiper;
  if (params.loop) {
    if (animating && params.loopPreventsSlide) return !1;
    swiper.loopFix(), swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
  }
  const translate2 = rtlTranslate ? swiper.translate : -swiper.translate;
  function normalize(val) {
    return val < 0 ? -Math.floor(Math.abs(val)) : Math.floor(val);
  }
  const normalizedTranslate = normalize(translate2), normalizedSnapGrid = snapGrid.map((val) => normalize(val));
  let prevSnap = snapGrid[normalizedSnapGrid.indexOf(normalizedTranslate) - 1];
  if (typeof prevSnap > "u" && params.cssMode) {
    let prevSnapIndex;
    snapGrid.forEach((snap, snapIndex) => {
      normalizedTranslate >= snap && (prevSnapIndex = snapIndex);
    }), typeof prevSnapIndex < "u" && (prevSnap = snapGrid[prevSnapIndex > 0 ? prevSnapIndex - 1 : prevSnapIndex]);
  }
  let prevIndex = 0;
  if (typeof prevSnap < "u" && (prevIndex = slidesGrid.indexOf(prevSnap), prevIndex < 0 && (prevIndex = swiper.activeIndex - 1), params.slidesPerView === "auto" && params.slidesPerGroup === 1 && params.slidesPerGroupAuto && (prevIndex = prevIndex - swiper.slidesPerViewDynamic("previous", !0) + 1, prevIndex = Math.max(prevIndex, 0))), params.rewind && swiper.isBeginning) {
    const lastIndex = swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual ? swiper.virtual.slides.length - 1 : swiper.slides.length - 1;
    return swiper.slideTo(lastIndex, speed, runCallbacks, internal);
  }
  return swiper.slideTo(prevIndex, speed, runCallbacks, internal);
}
function slideReset(speed = this.params.speed, runCallbacks = !0, internal) {
  const swiper = this;
  return swiper.slideTo(swiper.activeIndex, speed, runCallbacks, internal);
}
function slideToClosest(speed = this.params.speed, runCallbacks = !0, internal, threshold = 0.5) {
  const swiper = this;
  let index2 = swiper.activeIndex;
  const skip = Math.min(swiper.params.slidesPerGroupSkip, index2), snapIndex = skip + Math.floor((index2 - skip) / swiper.params.slidesPerGroup), translate2 = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
  if (translate2 >= swiper.snapGrid[snapIndex]) {
    const currentSnap = swiper.snapGrid[snapIndex], nextSnap = swiper.snapGrid[snapIndex + 1];
    translate2 - currentSnap > (nextSnap - currentSnap) * threshold && (index2 += swiper.params.slidesPerGroup);
  } else {
    const prevSnap = swiper.snapGrid[snapIndex - 1], currentSnap = swiper.snapGrid[snapIndex];
    translate2 - prevSnap <= (currentSnap - prevSnap) * threshold && (index2 -= swiper.params.slidesPerGroup);
  }
  return index2 = Math.max(index2, 0), index2 = Math.min(index2, swiper.slidesGrid.length - 1), swiper.slideTo(index2, speed, runCallbacks, internal);
}
function slideToClickedSlide() {
  const swiper = this, {
    params,
    $wrapperEl
  } = swiper, slidesPerView = params.slidesPerView === "auto" ? swiper.slidesPerViewDynamic() : params.slidesPerView;
  let slideToIndex = swiper.clickedIndex, realIndex;
  if (params.loop) {
    if (swiper.animating) return;
    realIndex = parseInt($(swiper.clickedSlide).attr("data-swiper-slide-index"), 10), params.centeredSlides ? slideToIndex < swiper.loopedSlides - slidesPerView / 2 || slideToIndex > swiper.slides.length - swiper.loopedSlides + slidesPerView / 2 ? (swiper.loopFix(), slideToIndex = $wrapperEl.children(`.${params.slideClass}[data-swiper-slide-index="${realIndex}"]:not(.${params.slideDuplicateClass})`).eq(0).index(), nextTick(() => {
      swiper.slideTo(slideToIndex);
    })) : swiper.slideTo(slideToIndex) : slideToIndex > swiper.slides.length - slidesPerView ? (swiper.loopFix(), slideToIndex = $wrapperEl.children(`.${params.slideClass}[data-swiper-slide-index="${realIndex}"]:not(.${params.slideDuplicateClass})`).eq(0).index(), nextTick(() => {
      swiper.slideTo(slideToIndex);
    })) : swiper.slideTo(slideToIndex);
  } else
    swiper.slideTo(slideToIndex);
}
const slide = {
  slideTo,
  slideToLoop,
  slideNext,
  slidePrev,
  slideReset,
  slideToClosest,
  slideToClickedSlide
};
function loopCreate() {
  const swiper = this, document2 = getDocument(), {
    params,
    $wrapperEl
  } = swiper, $selector = $wrapperEl.children().length > 0 ? $($wrapperEl.children()[0].parentNode) : $wrapperEl;
  $selector.children(`.${params.slideClass}.${params.slideDuplicateClass}`).remove();
  let slides = $selector.children(`.${params.slideClass}`);
  if (params.loopFillGroupWithBlank) {
    const blankSlidesNum = params.slidesPerGroup - slides.length % params.slidesPerGroup;
    if (blankSlidesNum !== params.slidesPerGroup) {
      for (let i = 0; i < blankSlidesNum; i += 1) {
        const blankNode = $(document2.createElement("div")).addClass(`${params.slideClass} ${params.slideBlankClass}`);
        $selector.append(blankNode);
      }
      slides = $selector.children(`.${params.slideClass}`);
    }
  }
  params.slidesPerView === "auto" && !params.loopedSlides && (params.loopedSlides = slides.length), swiper.loopedSlides = Math.ceil(parseFloat(params.loopedSlides || params.slidesPerView, 10)), swiper.loopedSlides += params.loopAdditionalSlides, swiper.loopedSlides > slides.length && swiper.params.loopedSlidesLimit && (swiper.loopedSlides = slides.length);
  const prependSlides = [], appendSlides = [];
  slides.each((el, index2) => {
    $(el).attr("data-swiper-slide-index", index2);
  });
  for (let i = 0; i < swiper.loopedSlides; i += 1) {
    const index2 = i - Math.floor(i / slides.length) * slides.length;
    appendSlides.push(slides.eq(index2)[0]), prependSlides.unshift(slides.eq(slides.length - index2 - 1)[0]);
  }
  for (let i = 0; i < appendSlides.length; i += 1)
    $selector.append($(appendSlides[i].cloneNode(!0)).addClass(params.slideDuplicateClass));
  for (let i = prependSlides.length - 1; i >= 0; i -= 1)
    $selector.prepend($(prependSlides[i].cloneNode(!0)).addClass(params.slideDuplicateClass));
}
function loopFix() {
  const swiper = this;
  swiper.emit("beforeLoopFix");
  const {
    activeIndex,
    slides,
    loopedSlides,
    allowSlidePrev,
    allowSlideNext,
    snapGrid,
    rtlTranslate: rtl
  } = swiper;
  let newIndex;
  swiper.allowSlidePrev = !0, swiper.allowSlideNext = !0;
  const diff = -snapGrid[activeIndex] - swiper.getTranslate();
  activeIndex < loopedSlides ? (newIndex = slides.length - loopedSlides * 3 + activeIndex, newIndex += loopedSlides, swiper.slideTo(newIndex, 0, !1, !0) && diff !== 0 && swiper.setTranslate((rtl ? -swiper.translate : swiper.translate) - diff)) : activeIndex >= slides.length - loopedSlides && (newIndex = -slides.length + activeIndex + loopedSlides, newIndex += loopedSlides, swiper.slideTo(newIndex, 0, !1, !0) && diff !== 0 && swiper.setTranslate((rtl ? -swiper.translate : swiper.translate) - diff)), swiper.allowSlidePrev = allowSlidePrev, swiper.allowSlideNext = allowSlideNext, swiper.emit("loopFix");
}
function loopDestroy() {
  const swiper = this, {
    $wrapperEl,
    params,
    slides
  } = swiper;
  $wrapperEl.children(`.${params.slideClass}.${params.slideDuplicateClass},.${params.slideClass}.${params.slideBlankClass}`).remove(), slides.removeAttr("data-swiper-slide-index");
}
const loop = {
  loopCreate,
  loopFix,
  loopDestroy
};
function setGrabCursor(moving) {
  const swiper = this;
  if (swiper.support.touch || !swiper.params.simulateTouch || swiper.params.watchOverflow && swiper.isLocked || swiper.params.cssMode) return;
  const el = swiper.params.touchEventsTarget === "container" ? swiper.el : swiper.wrapperEl;
  el.style.cursor = "move", el.style.cursor = moving ? "grabbing" : "grab";
}
function unsetGrabCursor() {
  const swiper = this;
  swiper.support.touch || swiper.params.watchOverflow && swiper.isLocked || swiper.params.cssMode || (swiper[swiper.params.touchEventsTarget === "container" ? "el" : "wrapperEl"].style.cursor = "");
}
const grabCursor = {
  setGrabCursor,
  unsetGrabCursor
};
function closestElement(selector, base = this) {
  function __closestFrom(el) {
    if (!el || el === getDocument() || el === getWindow()) return null;
    el.assignedSlot && (el = el.assignedSlot);
    const found = el.closest(selector);
    return !found && !el.getRootNode ? null : found || __closestFrom(el.getRootNode().host);
  }
  return __closestFrom(base);
}
function onTouchStart(event) {
  const swiper = this, document2 = getDocument(), window2 = getWindow(), data = swiper.touchEventsData, {
    params,
    touches,
    enabled
  } = swiper;
  if (!enabled || swiper.animating && params.preventInteractionOnTransition)
    return;
  !swiper.animating && params.cssMode && params.loop && swiper.loopFix();
  let e = event;
  e.originalEvent && (e = e.originalEvent);
  let $targetEl = $(e.target);
  if (params.touchEventsTarget === "wrapper" && !$targetEl.closest(swiper.wrapperEl).length || (data.isTouchEvent = e.type === "touchstart", !data.isTouchEvent && "which" in e && e.which === 3) || !data.isTouchEvent && "button" in e && e.button > 0 || data.isTouched && data.isMoved) return;
  const swipingClassHasValue = !!params.noSwipingClass && params.noSwipingClass !== "", eventPath = event.composedPath ? event.composedPath() : event.path;
  swipingClassHasValue && e.target && e.target.shadowRoot && eventPath && ($targetEl = $(eventPath[0]));
  const noSwipingSelector = params.noSwipingSelector ? params.noSwipingSelector : `.${params.noSwipingClass}`, isTargetShadow = !!(e.target && e.target.shadowRoot);
  if (params.noSwiping && (isTargetShadow ? closestElement(noSwipingSelector, $targetEl[0]) : $targetEl.closest(noSwipingSelector)[0])) {
    swiper.allowClick = !0;
    return;
  }
  if (params.swipeHandler && !$targetEl.closest(params.swipeHandler)[0])
    return;
  touches.currentX = e.type === "touchstart" ? e.targetTouches[0].pageX : e.pageX, touches.currentY = e.type === "touchstart" ? e.targetTouches[0].pageY : e.pageY;
  const startX = touches.currentX, startY = touches.currentY, edgeSwipeDetection = params.edgeSwipeDetection || params.iOSEdgeSwipeDetection, edgeSwipeThreshold = params.edgeSwipeThreshold || params.iOSEdgeSwipeThreshold;
  if (edgeSwipeDetection && (startX <= edgeSwipeThreshold || startX >= window2.innerWidth - edgeSwipeThreshold))
    if (edgeSwipeDetection === "prevent")
      event.preventDefault();
    else
      return;
  if (Object.assign(data, {
    isTouched: !0,
    isMoved: !1,
    allowTouchCallbacks: !0,
    isScrolling: void 0,
    startMoving: void 0
  }), touches.startX = startX, touches.startY = startY, data.touchStartTime = now(), swiper.allowClick = !0, swiper.updateSize(), swiper.swipeDirection = void 0, params.threshold > 0 && (data.allowThresholdMove = !1), e.type !== "touchstart") {
    let preventDefault3 = !0;
    $targetEl.is(data.focusableElements) && (preventDefault3 = !1, $targetEl[0].nodeName === "SELECT" && (data.isTouched = !1)), document2.activeElement && $(document2.activeElement).is(data.focusableElements) && document2.activeElement !== $targetEl[0] && document2.activeElement.blur();
    const shouldPreventDefault = preventDefault3 && swiper.allowTouchMove && params.touchStartPreventDefault;
    (params.touchStartForcePreventDefault || shouldPreventDefault) && !$targetEl[0].isContentEditable && e.preventDefault();
  }
  swiper.params.freeMode && swiper.params.freeMode.enabled && swiper.freeMode && swiper.animating && !params.cssMode && swiper.freeMode.onTouchStart(), swiper.emit("touchStart", e);
}
function onTouchMove(event) {
  const document2 = getDocument(), swiper = this, data = swiper.touchEventsData, {
    params,
    touches,
    rtlTranslate: rtl,
    enabled
  } = swiper;
  if (!enabled) return;
  let e = event;
  if (e.originalEvent && (e = e.originalEvent), !data.isTouched) {
    data.startMoving && data.isScrolling && swiper.emit("touchMoveOpposite", e);
    return;
  }
  if (data.isTouchEvent && e.type !== "touchmove") return;
  const targetTouch = e.type === "touchmove" && e.targetTouches && (e.targetTouches[0] || e.changedTouches[0]), pageX = e.type === "touchmove" ? targetTouch.pageX : e.pageX, pageY = e.type === "touchmove" ? targetTouch.pageY : e.pageY;
  if (e.preventedByNestedSwiper) {
    touches.startX = pageX, touches.startY = pageY;
    return;
  }
  if (!swiper.allowTouchMove) {
    $(e.target).is(data.focusableElements) || (swiper.allowClick = !1), data.isTouched && (Object.assign(touches, {
      startX: pageX,
      startY: pageY,
      currentX: pageX,
      currentY: pageY
    }), data.touchStartTime = now());
    return;
  }
  if (data.isTouchEvent && params.touchReleaseOnEdges && !params.loop) {
    if (swiper.isVertical()) {
      if (pageY < touches.startY && swiper.translate <= swiper.maxTranslate() || pageY > touches.startY && swiper.translate >= swiper.minTranslate()) {
        data.isTouched = !1, data.isMoved = !1;
        return;
      }
    } else if (pageX < touches.startX && swiper.translate <= swiper.maxTranslate() || pageX > touches.startX && swiper.translate >= swiper.minTranslate())
      return;
  }
  if (data.isTouchEvent && document2.activeElement && e.target === document2.activeElement && $(e.target).is(data.focusableElements)) {
    data.isMoved = !0, swiper.allowClick = !1;
    return;
  }
  if (data.allowTouchCallbacks && swiper.emit("touchMove", e), e.targetTouches && e.targetTouches.length > 1) return;
  touches.currentX = pageX, touches.currentY = pageY;
  const diffX = touches.currentX - touches.startX, diffY = touches.currentY - touches.startY;
  if (swiper.params.threshold && Math.sqrt(diffX ** 2 + diffY ** 2) < swiper.params.threshold) return;
  if (typeof data.isScrolling > "u") {
    let touchAngle;
    swiper.isHorizontal() && touches.currentY === touches.startY || swiper.isVertical() && touches.currentX === touches.startX ? data.isScrolling = !1 : diffX * diffX + diffY * diffY >= 25 && (touchAngle = Math.atan2(Math.abs(diffY), Math.abs(diffX)) * 180 / Math.PI, data.isScrolling = swiper.isHorizontal() ? touchAngle > params.touchAngle : 90 - touchAngle > params.touchAngle);
  }
  if (data.isScrolling && swiper.emit("touchMoveOpposite", e), typeof data.startMoving > "u" && (touches.currentX !== touches.startX || touches.currentY !== touches.startY) && (data.startMoving = !0), data.isScrolling) {
    data.isTouched = !1;
    return;
  }
  if (!data.startMoving)
    return;
  swiper.allowClick = !1, !params.cssMode && e.cancelable && e.preventDefault(), params.touchMoveStopPropagation && !params.nested && e.stopPropagation(), data.isMoved || (params.loop && !params.cssMode && swiper.loopFix(), data.startTranslate = swiper.getTranslate(), swiper.setTransition(0), swiper.animating && swiper.$wrapperEl.trigger("webkitTransitionEnd transitionend"), data.allowMomentumBounce = !1, params.grabCursor && (swiper.allowSlideNext === !0 || swiper.allowSlidePrev === !0) && swiper.setGrabCursor(!0), swiper.emit("sliderFirstMove", e)), swiper.emit("sliderMove", e), data.isMoved = !0;
  let diff = swiper.isHorizontal() ? diffX : diffY;
  touches.diff = diff, diff *= params.touchRatio, rtl && (diff = -diff), swiper.swipeDirection = diff > 0 ? "prev" : "next", data.currentTranslate = diff + data.startTranslate;
  let disableParentSwiper = !0, resistanceRatio = params.resistanceRatio;
  if (params.touchReleaseOnEdges && (resistanceRatio = 0), diff > 0 && data.currentTranslate > swiper.minTranslate() ? (disableParentSwiper = !1, params.resistance && (data.currentTranslate = swiper.minTranslate() - 1 + (-swiper.minTranslate() + data.startTranslate + diff) ** resistanceRatio)) : diff < 0 && data.currentTranslate < swiper.maxTranslate() && (disableParentSwiper = !1, params.resistance && (data.currentTranslate = swiper.maxTranslate() + 1 - (swiper.maxTranslate() - data.startTranslate - diff) ** resistanceRatio)), disableParentSwiper && (e.preventedByNestedSwiper = !0), !swiper.allowSlideNext && swiper.swipeDirection === "next" && data.currentTranslate < data.startTranslate && (data.currentTranslate = data.startTranslate), !swiper.allowSlidePrev && swiper.swipeDirection === "prev" && data.currentTranslate > data.startTranslate && (data.currentTranslate = data.startTranslate), !swiper.allowSlidePrev && !swiper.allowSlideNext && (data.currentTranslate = data.startTranslate), params.threshold > 0)
    if (Math.abs(diff) > params.threshold || data.allowThresholdMove) {
      if (!data.allowThresholdMove) {
        data.allowThresholdMove = !0, touches.startX = touches.currentX, touches.startY = touches.currentY, data.currentTranslate = data.startTranslate, touches.diff = swiper.isHorizontal() ? touches.currentX - touches.startX : touches.currentY - touches.startY;
        return;
      }
    } else {
      data.currentTranslate = data.startTranslate;
      return;
    }
  !params.followFinger || params.cssMode || ((params.freeMode && params.freeMode.enabled && swiper.freeMode || params.watchSlidesProgress) && (swiper.updateActiveIndex(), swiper.updateSlidesClasses()), swiper.params.freeMode && params.freeMode.enabled && swiper.freeMode && swiper.freeMode.onTouchMove(), swiper.updateProgress(data.currentTranslate), swiper.setTranslate(data.currentTranslate));
}
function onTouchEnd(event) {
  const swiper = this, data = swiper.touchEventsData, {
    params,
    touches,
    rtlTranslate: rtl,
    slidesGrid,
    enabled
  } = swiper;
  if (!enabled) return;
  let e = event;
  if (e.originalEvent && (e = e.originalEvent), data.allowTouchCallbacks && swiper.emit("touchEnd", e), data.allowTouchCallbacks = !1, !data.isTouched) {
    data.isMoved && params.grabCursor && swiper.setGrabCursor(!1), data.isMoved = !1, data.startMoving = !1;
    return;
  }
  params.grabCursor && data.isMoved && data.isTouched && (swiper.allowSlideNext === !0 || swiper.allowSlidePrev === !0) && swiper.setGrabCursor(!1);
  const touchEndTime = now(), timeDiff = touchEndTime - data.touchStartTime;
  if (swiper.allowClick) {
    const pathTree = e.path || e.composedPath && e.composedPath();
    swiper.updateClickedSlide(pathTree && pathTree[0] || e.target), swiper.emit("tap click", e), timeDiff < 300 && touchEndTime - data.lastClickTime < 300 && swiper.emit("doubleTap doubleClick", e);
  }
  if (data.lastClickTime = now(), nextTick(() => {
    swiper.destroyed || (swiper.allowClick = !0);
  }), !data.isTouched || !data.isMoved || !swiper.swipeDirection || touches.diff === 0 || data.currentTranslate === data.startTranslate) {
    data.isTouched = !1, data.isMoved = !1, data.startMoving = !1;
    return;
  }
  data.isTouched = !1, data.isMoved = !1, data.startMoving = !1;
  let currentPos;
  if (params.followFinger ? currentPos = rtl ? swiper.translate : -swiper.translate : currentPos = -data.currentTranslate, params.cssMode)
    return;
  if (swiper.params.freeMode && params.freeMode.enabled) {
    swiper.freeMode.onTouchEnd({
      currentPos
    });
    return;
  }
  let stopIndex = 0, groupSize = swiper.slidesSizesGrid[0];
  for (let i = 0; i < slidesGrid.length; i += i < params.slidesPerGroupSkip ? 1 : params.slidesPerGroup) {
    const increment2 = i < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup;
    typeof slidesGrid[i + increment2] < "u" ? currentPos >= slidesGrid[i] && currentPos < slidesGrid[i + increment2] && (stopIndex = i, groupSize = slidesGrid[i + increment2] - slidesGrid[i]) : currentPos >= slidesGrid[i] && (stopIndex = i, groupSize = slidesGrid[slidesGrid.length - 1] - slidesGrid[slidesGrid.length - 2]);
  }
  let rewindFirstIndex = null, rewindLastIndex = null;
  params.rewind && (swiper.isBeginning ? rewindLastIndex = swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual ? swiper.virtual.slides.length - 1 : swiper.slides.length - 1 : swiper.isEnd && (rewindFirstIndex = 0));
  const ratio = (currentPos - slidesGrid[stopIndex]) / groupSize, increment = stopIndex < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup;
  if (timeDiff > params.longSwipesMs) {
    if (!params.longSwipes) {
      swiper.slideTo(swiper.activeIndex);
      return;
    }
    swiper.swipeDirection === "next" && (ratio >= params.longSwipesRatio ? swiper.slideTo(params.rewind && swiper.isEnd ? rewindFirstIndex : stopIndex + increment) : swiper.slideTo(stopIndex)), swiper.swipeDirection === "prev" && (ratio > 1 - params.longSwipesRatio ? swiper.slideTo(stopIndex + increment) : rewindLastIndex !== null && ratio < 0 && Math.abs(ratio) > params.longSwipesRatio ? swiper.slideTo(rewindLastIndex) : swiper.slideTo(stopIndex));
  } else {
    if (!params.shortSwipes) {
      swiper.slideTo(swiper.activeIndex);
      return;
    }
    swiper.navigation && (e.target === swiper.navigation.nextEl || e.target === swiper.navigation.prevEl) ? e.target === swiper.navigation.nextEl ? swiper.slideTo(stopIndex + increment) : swiper.slideTo(stopIndex) : (swiper.swipeDirection === "next" && swiper.slideTo(rewindFirstIndex !== null ? rewindFirstIndex : stopIndex + increment), swiper.swipeDirection === "prev" && swiper.slideTo(rewindLastIndex !== null ? rewindLastIndex : stopIndex));
  }
}
function onResize() {
  const swiper = this, {
    params,
    el
  } = swiper;
  if (el && el.offsetWidth === 0) return;
  params.breakpoints && swiper.setBreakpoint();
  const {
    allowSlideNext,
    allowSlidePrev,
    snapGrid
  } = swiper;
  swiper.allowSlideNext = !0, swiper.allowSlidePrev = !0, swiper.updateSize(), swiper.updateSlides(), swiper.updateSlidesClasses(), (params.slidesPerView === "auto" || params.slidesPerView > 1) && swiper.isEnd && !swiper.isBeginning && !swiper.params.centeredSlides ? swiper.slideTo(swiper.slides.length - 1, 0, !1, !0) : swiper.slideTo(swiper.activeIndex, 0, !1, !0), swiper.autoplay && swiper.autoplay.running && swiper.autoplay.paused && swiper.autoplay.run(), swiper.allowSlidePrev = allowSlidePrev, swiper.allowSlideNext = allowSlideNext, swiper.params.watchOverflow && snapGrid !== swiper.snapGrid && swiper.checkOverflow();
}
function onClick(e) {
  const swiper = this;
  swiper.enabled && (swiper.allowClick || (swiper.params.preventClicks && e.preventDefault(), swiper.params.preventClicksPropagation && swiper.animating && (e.stopPropagation(), e.stopImmediatePropagation())));
}
function onScroll() {
  const swiper = this, {
    wrapperEl,
    rtlTranslate,
    enabled
  } = swiper;
  if (!enabled) return;
  swiper.previousTranslate = swiper.translate, swiper.isHorizontal() ? swiper.translate = -wrapperEl.scrollLeft : swiper.translate = -wrapperEl.scrollTop, swiper.translate === 0 && (swiper.translate = 0), swiper.updateActiveIndex(), swiper.updateSlidesClasses();
  let newProgress;
  const translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
  translatesDiff === 0 ? newProgress = 0 : newProgress = (swiper.translate - swiper.minTranslate()) / translatesDiff, newProgress !== swiper.progress && swiper.updateProgress(rtlTranslate ? -swiper.translate : swiper.translate), swiper.emit("setTranslate", swiper.translate, !1);
}
let dummyEventAttached = !1;
function dummyEventListener() {
}
const events = (swiper, method) => {
  const document2 = getDocument(), {
    params,
    touchEvents,
    el,
    wrapperEl,
    device,
    support: support2
  } = swiper, capture = !!params.nested, domMethod = method === "on" ? "addEventListener" : "removeEventListener", swiperMethod = method;
  if (!support2.touch)
    el[domMethod](touchEvents.start, swiper.onTouchStart, !1), document2[domMethod](touchEvents.move, swiper.onTouchMove, capture), document2[domMethod](touchEvents.end, swiper.onTouchEnd, !1);
  else {
    const passiveListener = touchEvents.start === "touchstart" && support2.passiveListener && params.passiveListeners ? {
      passive: !0,
      capture: !1
    } : !1;
    el[domMethod](touchEvents.start, swiper.onTouchStart, passiveListener), el[domMethod](touchEvents.move, swiper.onTouchMove, support2.passiveListener ? {
      passive: !1,
      capture
    } : capture), el[domMethod](touchEvents.end, swiper.onTouchEnd, passiveListener), touchEvents.cancel && el[domMethod](touchEvents.cancel, swiper.onTouchEnd, passiveListener);
  }
  (params.preventClicks || params.preventClicksPropagation) && el[domMethod]("click", swiper.onClick, !0), params.cssMode && wrapperEl[domMethod]("scroll", swiper.onScroll), params.updateOnWindowResize ? swiper[swiperMethod](device.ios || device.android ? "resize orientationchange observerUpdate" : "resize observerUpdate", onResize, !0) : swiper[swiperMethod]("observerUpdate", onResize, !0);
};
function attachEvents() {
  const swiper = this, document2 = getDocument(), {
    params,
    support: support2
  } = swiper;
  swiper.onTouchStart = onTouchStart.bind(swiper), swiper.onTouchMove = onTouchMove.bind(swiper), swiper.onTouchEnd = onTouchEnd.bind(swiper), params.cssMode && (swiper.onScroll = onScroll.bind(swiper)), swiper.onClick = onClick.bind(swiper), support2.touch && !dummyEventAttached && (document2.addEventListener("touchstart", dummyEventListener), dummyEventAttached = !0), events(swiper, "on");
}
function detachEvents() {
  events(this, "off");
}
const events$1 = {
  attachEvents,
  detachEvents
}, isGridEnabled = (swiper, params) => swiper.grid && params.grid && params.grid.rows > 1;
function setBreakpoint() {
  const swiper = this, {
    activeIndex,
    initialized,
    loopedSlides = 0,
    params,
    $el
  } = swiper, breakpoints2 = params.breakpoints;
  if (!breakpoints2 || breakpoints2 && Object.keys(breakpoints2).length === 0) return;
  const breakpoint = swiper.getBreakpoint(breakpoints2, swiper.params.breakpointsBase, swiper.el);
  if (!breakpoint || swiper.currentBreakpoint === breakpoint) return;
  const breakpointParams = (breakpoint in breakpoints2 ? breakpoints2[breakpoint] : void 0) || swiper.originalParams, wasMultiRow = isGridEnabled(swiper, params), isMultiRow = isGridEnabled(swiper, breakpointParams), wasEnabled = params.enabled;
  wasMultiRow && !isMultiRow ? ($el.removeClass(`${params.containerModifierClass}grid ${params.containerModifierClass}grid-column`), swiper.emitContainerClasses()) : !wasMultiRow && isMultiRow && ($el.addClass(`${params.containerModifierClass}grid`), (breakpointParams.grid.fill && breakpointParams.grid.fill === "column" || !breakpointParams.grid.fill && params.grid.fill === "column") && $el.addClass(`${params.containerModifierClass}grid-column`), swiper.emitContainerClasses()), ["navigation", "pagination", "scrollbar"].forEach((prop) => {
    const wasModuleEnabled = params[prop] && params[prop].enabled, isModuleEnabled = breakpointParams[prop] && breakpointParams[prop].enabled;
    wasModuleEnabled && !isModuleEnabled && swiper[prop].disable(), !wasModuleEnabled && isModuleEnabled && swiper[prop].enable();
  });
  const directionChanged = breakpointParams.direction && breakpointParams.direction !== params.direction, needsReLoop = params.loop && (breakpointParams.slidesPerView !== params.slidesPerView || directionChanged);
  directionChanged && initialized && swiper.changeDirection(), extend$1(swiper.params, breakpointParams);
  const isEnabled = swiper.params.enabled;
  Object.assign(swiper, {
    allowTouchMove: swiper.params.allowTouchMove,
    allowSlideNext: swiper.params.allowSlideNext,
    allowSlidePrev: swiper.params.allowSlidePrev
  }), wasEnabled && !isEnabled ? swiper.disable() : !wasEnabled && isEnabled && swiper.enable(), swiper.currentBreakpoint = breakpoint, swiper.emit("_beforeBreakpoint", breakpointParams), needsReLoop && initialized && (swiper.loopDestroy(), swiper.loopCreate(), swiper.updateSlides(), swiper.slideTo(activeIndex - loopedSlides + swiper.loopedSlides, 0, !1)), swiper.emit("breakpoint", breakpointParams);
}
function getBreakpoint(breakpoints2, base = "window", containerEl) {
  if (!breakpoints2 || base === "container" && !containerEl) return;
  let breakpoint = !1;
  const window2 = getWindow(), currentHeight = base === "window" ? window2.innerHeight : containerEl.clientHeight, points = Object.keys(breakpoints2).map((point) => {
    if (typeof point == "string" && point.indexOf("@") === 0) {
      const minRatio = parseFloat(point.substr(1));
      return {
        value: currentHeight * minRatio,
        point
      };
    }
    return {
      value: point,
      point
    };
  });
  points.sort((a, b) => parseInt(a.value, 10) - parseInt(b.value, 10));
  for (let i = 0; i < points.length; i += 1) {
    const {
      point,
      value
    } = points[i];
    base === "window" ? window2.matchMedia(`(min-width: ${value}px)`).matches && (breakpoint = point) : value <= containerEl.clientWidth && (breakpoint = point);
  }
  return breakpoint || "max";
}
const breakpoints = {
  setBreakpoint,
  getBreakpoint
};
function prepareClasses(entries, prefix) {
  const resultClasses = [];
  return entries.forEach((item) => {
    typeof item == "object" ? Object.keys(item).forEach((classNames2) => {
      item[classNames2] && resultClasses.push(prefix + classNames2);
    }) : typeof item == "string" && resultClasses.push(prefix + item);
  }), resultClasses;
}
function addClasses() {
  const swiper = this, {
    classNames: classNames2,
    params,
    rtl,
    $el,
    device,
    support: support2
  } = swiper, suffixes = prepareClasses(["initialized", params.direction, {
    "pointer-events": !support2.touch
  }, {
    "free-mode": swiper.params.freeMode && params.freeMode.enabled
  }, {
    autoheight: params.autoHeight
  }, {
    rtl
  }, {
    grid: params.grid && params.grid.rows > 1
  }, {
    "grid-column": params.grid && params.grid.rows > 1 && params.grid.fill === "column"
  }, {
    android: device.android
  }, {
    ios: device.ios
  }, {
    "css-mode": params.cssMode
  }, {
    centered: params.cssMode && params.centeredSlides
  }, {
    "watch-progress": params.watchSlidesProgress
  }], params.containerModifierClass);
  classNames2.push(...suffixes), $el.addClass([...classNames2].join(" ")), swiper.emitContainerClasses();
}
function removeClasses() {
  const swiper = this, {
    $el,
    classNames: classNames2
  } = swiper;
  $el.removeClass(classNames2.join(" ")), swiper.emitContainerClasses();
}
const classes = {
  addClasses,
  removeClasses
};
function loadImage(imageEl, src, srcset, sizes, checkForComplete, callback) {
  const window2 = getWindow();
  let image;
  function onReady() {
    callback && callback();
  }
  !$(imageEl).parent("picture")[0] && (!imageEl.complete || !checkForComplete) && src ? (image = new window2.Image(), image.onload = onReady, image.onerror = onReady, sizes && (image.sizes = sizes), srcset && (image.srcset = srcset), src && (image.src = src)) : onReady();
}
function preloadImages() {
  const swiper = this;
  swiper.imagesToLoad = swiper.$el.find("img");
  function onReady() {
    typeof swiper > "u" || swiper === null || !swiper || swiper.destroyed || (swiper.imagesLoaded !== void 0 && (swiper.imagesLoaded += 1), swiper.imagesLoaded === swiper.imagesToLoad.length && (swiper.params.updateOnImagesReady && swiper.update(), swiper.emit("imagesReady")));
  }
  for (let i = 0; i < swiper.imagesToLoad.length; i += 1) {
    const imageEl = swiper.imagesToLoad[i];
    swiper.loadImage(imageEl, imageEl.currentSrc || imageEl.getAttribute("src"), imageEl.srcset || imageEl.getAttribute("srcset"), imageEl.sizes || imageEl.getAttribute("sizes"), !0, onReady);
  }
}
const images = {
  loadImage,
  preloadImages
};
function checkOverflow() {
  const swiper = this, {
    isLocked: wasLocked,
    params
  } = swiper, {
    slidesOffsetBefore
  } = params;
  if (slidesOffsetBefore) {
    const lastSlideIndex = swiper.slides.length - 1, lastSlideRightEdge = swiper.slidesGrid[lastSlideIndex] + swiper.slidesSizesGrid[lastSlideIndex] + slidesOffsetBefore * 2;
    swiper.isLocked = swiper.size > lastSlideRightEdge;
  } else
    swiper.isLocked = swiper.snapGrid.length === 1;
  params.allowSlideNext === !0 && (swiper.allowSlideNext = !swiper.isLocked), params.allowSlidePrev === !0 && (swiper.allowSlidePrev = !swiper.isLocked), wasLocked && wasLocked !== swiper.isLocked && (swiper.isEnd = !1), wasLocked !== swiper.isLocked && swiper.emit(swiper.isLocked ? "lock" : "unlock");
}
const checkOverflow$1 = {
  checkOverflow
}, defaults = {
  init: !0,
  direction: "horizontal",
  touchEventsTarget: "wrapper",
  initialSlide: 0,
  speed: 300,
  cssMode: !1,
  updateOnWindowResize: !0,
  resizeObserver: !0,
  nested: !1,
  createElements: !1,
  enabled: !0,
  focusableElements: "input, select, option, textarea, button, video, label",
  // Overrides
  width: null,
  height: null,
  //
  preventInteractionOnTransition: !1,
  // ssr
  userAgent: null,
  url: null,
  // To support iOS's swipe-to-go-back gesture (when being used in-app).
  edgeSwipeDetection: !1,
  edgeSwipeThreshold: 20,
  // Autoheight
  autoHeight: !1,
  // Set wrapper width
  setWrapperSize: !1,
  // Virtual Translate
  virtualTranslate: !1,
  // Effects
  effect: "slide",
  // 'slide' or 'fade' or 'cube' or 'coverflow' or 'flip'
  // Breakpoints
  breakpoints: void 0,
  breakpointsBase: "window",
  // Slides grid
  spaceBetween: 0,
  slidesPerView: 1,
  slidesPerGroup: 1,
  slidesPerGroupSkip: 0,
  slidesPerGroupAuto: !1,
  centeredSlides: !1,
  centeredSlidesBounds: !1,
  slidesOffsetBefore: 0,
  // in px
  slidesOffsetAfter: 0,
  // in px
  normalizeSlideIndex: !0,
  centerInsufficientSlides: !1,
  // Disable swiper and hide navigation when container not overflow
  watchOverflow: !0,
  // Round length
  roundLengths: !1,
  // Touches
  touchRatio: 1,
  touchAngle: 45,
  simulateTouch: !0,
  shortSwipes: !0,
  longSwipes: !0,
  longSwipesRatio: 0.5,
  longSwipesMs: 300,
  followFinger: !0,
  allowTouchMove: !0,
  threshold: 0,
  touchMoveStopPropagation: !1,
  touchStartPreventDefault: !0,
  touchStartForcePreventDefault: !1,
  touchReleaseOnEdges: !1,
  // Unique Navigation Elements
  uniqueNavElements: !0,
  // Resistance
  resistance: !0,
  resistanceRatio: 0.85,
  // Progress
  watchSlidesProgress: !1,
  // Cursor
  grabCursor: !1,
  // Clicks
  preventClicks: !0,
  preventClicksPropagation: !0,
  slideToClickedSlide: !1,
  // Images
  preloadImages: !0,
  updateOnImagesReady: !0,
  // loop
  loop: !1,
  loopAdditionalSlides: 0,
  loopedSlides: null,
  loopedSlidesLimit: !0,
  loopFillGroupWithBlank: !1,
  loopPreventsSlide: !0,
  // rewind
  rewind: !1,
  // Swiping/no swiping
  allowSlidePrev: !0,
  allowSlideNext: !0,
  swipeHandler: null,
  // '.swipe-handler',
  noSwiping: !0,
  noSwipingClass: "swiper-no-swiping",
  noSwipingSelector: null,
  // Passive Listeners
  passiveListeners: !0,
  maxBackfaceHiddenSlides: 10,
  // NS
  containerModifierClass: "swiper-",
  // NEW
  slideClass: "swiper-slide",
  slideBlankClass: "swiper-slide-invisible-blank",
  slideActiveClass: "swiper-slide-active",
  slideDuplicateActiveClass: "swiper-slide-duplicate-active",
  slideVisibleClass: "swiper-slide-visible",
  slideDuplicateClass: "swiper-slide-duplicate",
  slideNextClass: "swiper-slide-next",
  slideDuplicateNextClass: "swiper-slide-duplicate-next",
  slidePrevClass: "swiper-slide-prev",
  slideDuplicatePrevClass: "swiper-slide-duplicate-prev",
  wrapperClass: "swiper-wrapper",
  // Callbacks
  runCallbacksOnInit: !0,
  // Internals
  _emitClasses: !1
};
function moduleExtendParams(params, allModulesParams) {
  return function(obj = {}) {
    const moduleParamName = Object.keys(obj)[0], moduleParams = obj[moduleParamName];
    if (typeof moduleParams != "object" || moduleParams === null) {
      extend$1(allModulesParams, obj);
      return;
    }
    if (["navigation", "pagination", "scrollbar"].indexOf(moduleParamName) >= 0 && params[moduleParamName] === !0 && (params[moduleParamName] = {
      auto: !0
    }), !(moduleParamName in params && "enabled" in moduleParams)) {
      extend$1(allModulesParams, obj);
      return;
    }
    params[moduleParamName] === !0 && (params[moduleParamName] = {
      enabled: !0
    }), typeof params[moduleParamName] == "object" && !("enabled" in params[moduleParamName]) && (params[moduleParamName].enabled = !0), params[moduleParamName] || (params[moduleParamName] = {
      enabled: !1
    }), extend$1(allModulesParams, obj);
  };
}
const prototypes = {
  eventsEmitter,
  update,
  translate,
  transition,
  slide,
  loop,
  grabCursor,
  events: events$1,
  breakpoints,
  checkOverflow: checkOverflow$1,
  classes,
  images
}, extendedDefaults = {};
let Swiper$1 = class Swiper {
  constructor(...args) {
    let el, params;
    if (args.length === 1 && args[0].constructor && Object.prototype.toString.call(args[0]).slice(8, -1) === "Object" ? params = args[0] : [el, params] = args, params || (params = {}), params = extend$1({}, params), el && !params.el && (params.el = el), params.el && $(params.el).length > 1) {
      const swipers = [];
      return $(params.el).each((containerEl) => {
        const newParams = extend$1({}, params, {
          el: containerEl
        });
        swipers.push(new Swiper(newParams));
      }), swipers;
    }
    const swiper = this;
    swiper.__swiper__ = !0, swiper.support = getSupport(), swiper.device = getDevice({
      userAgent: params.userAgent
    }), swiper.browser = getBrowser(), swiper.eventsListeners = {}, swiper.eventsAnyListeners = [], swiper.modules = [...swiper.__modules__], params.modules && Array.isArray(params.modules) && swiper.modules.push(...params.modules);
    const allModulesParams = {};
    swiper.modules.forEach((mod) => {
      mod({
        swiper,
        extendParams: moduleExtendParams(params, allModulesParams),
        on: swiper.on.bind(swiper),
        once: swiper.once.bind(swiper),
        off: swiper.off.bind(swiper),
        emit: swiper.emit.bind(swiper)
      });
    });
    const swiperParams = extend$1({}, defaults, allModulesParams);
    return swiper.params = extend$1({}, swiperParams, extendedDefaults, params), swiper.originalParams = extend$1({}, swiper.params), swiper.passedParams = extend$1({}, params), swiper.params && swiper.params.on && Object.keys(swiper.params.on).forEach((eventName) => {
      swiper.on(eventName, swiper.params.on[eventName]);
    }), swiper.params && swiper.params.onAny && swiper.onAny(swiper.params.onAny), swiper.$ = $, Object.assign(swiper, {
      enabled: swiper.params.enabled,
      el,
      // Classes
      classNames: [],
      // Slides
      slides: $(),
      slidesGrid: [],
      snapGrid: [],
      slidesSizesGrid: [],
      // isDirection
      isHorizontal() {
        return swiper.params.direction === "horizontal";
      },
      isVertical() {
        return swiper.params.direction === "vertical";
      },
      // Indexes
      activeIndex: 0,
      realIndex: 0,
      //
      isBeginning: !0,
      isEnd: !1,
      // Props
      translate: 0,
      previousTranslate: 0,
      progress: 0,
      velocity: 0,
      animating: !1,
      // Locks
      allowSlideNext: swiper.params.allowSlideNext,
      allowSlidePrev: swiper.params.allowSlidePrev,
      // Touch Events
      touchEvents: (function() {
        const touch = ["touchstart", "touchmove", "touchend", "touchcancel"], desktop = ["pointerdown", "pointermove", "pointerup"];
        return swiper.touchEventsTouch = {
          start: touch[0],
          move: touch[1],
          end: touch[2],
          cancel: touch[3]
        }, swiper.touchEventsDesktop = {
          start: desktop[0],
          move: desktop[1],
          end: desktop[2]
        }, swiper.support.touch || !swiper.params.simulateTouch ? swiper.touchEventsTouch : swiper.touchEventsDesktop;
      })(),
      touchEventsData: {
        isTouched: void 0,
        isMoved: void 0,
        allowTouchCallbacks: void 0,
        touchStartTime: void 0,
        isScrolling: void 0,
        currentTranslate: void 0,
        startTranslate: void 0,
        allowThresholdMove: void 0,
        // Form elements to match
        focusableElements: swiper.params.focusableElements,
        // Last click time
        lastClickTime: now(),
        clickTimeout: void 0,
        // Velocities
        velocities: [],
        allowMomentumBounce: void 0,
        isTouchEvent: void 0,
        startMoving: void 0
      },
      // Clicks
      allowClick: !0,
      // Touches
      allowTouchMove: swiper.params.allowTouchMove,
      touches: {
        startX: 0,
        startY: 0,
        currentX: 0,
        currentY: 0,
        diff: 0
      },
      // Images
      imagesToLoad: [],
      imagesLoaded: 0
    }), swiper.emit("_swiper"), swiper.params.init && swiper.init(), swiper;
  }
  enable() {
    const swiper = this;
    swiper.enabled || (swiper.enabled = !0, swiper.params.grabCursor && swiper.setGrabCursor(), swiper.emit("enable"));
  }
  disable() {
    const swiper = this;
    swiper.enabled && (swiper.enabled = !1, swiper.params.grabCursor && swiper.unsetGrabCursor(), swiper.emit("disable"));
  }
  setProgress(progress, speed) {
    const swiper = this;
    progress = Math.min(Math.max(progress, 0), 1);
    const min = swiper.minTranslate(), current = (swiper.maxTranslate() - min) * progress + min;
    swiper.translateTo(current, typeof speed > "u" ? 0 : speed), swiper.updateActiveIndex(), swiper.updateSlidesClasses();
  }
  emitContainerClasses() {
    const swiper = this;
    if (!swiper.params._emitClasses || !swiper.el) return;
    const cls = swiper.el.className.split(" ").filter((className) => className.indexOf("swiper") === 0 || className.indexOf(swiper.params.containerModifierClass) === 0);
    swiper.emit("_containerClasses", cls.join(" "));
  }
  getSlideClasses(slideEl) {
    const swiper = this;
    return swiper.destroyed ? "" : slideEl.className.split(" ").filter((className) => className.indexOf("swiper-slide") === 0 || className.indexOf(swiper.params.slideClass) === 0).join(" ");
  }
  emitSlidesClasses() {
    const swiper = this;
    if (!swiper.params._emitClasses || !swiper.el) return;
    const updates = [];
    swiper.slides.each((slideEl) => {
      const classNames2 = swiper.getSlideClasses(slideEl);
      updates.push({
        slideEl,
        classNames: classNames2
      }), swiper.emit("_slideClass", slideEl, classNames2);
    }), swiper.emit("_slideClasses", updates);
  }
  slidesPerViewDynamic(view = "current", exact = !1) {
    const swiper = this, {
      params,
      slides,
      slidesGrid,
      slidesSizesGrid,
      size: swiperSize,
      activeIndex
    } = swiper;
    let spv = 1;
    if (params.centeredSlides) {
      let slideSize = slides[activeIndex].swiperSlideSize, breakLoop;
      for (let i = activeIndex + 1; i < slides.length; i += 1)
        slides[i] && !breakLoop && (slideSize += slides[i].swiperSlideSize, spv += 1, slideSize > swiperSize && (breakLoop = !0));
      for (let i = activeIndex - 1; i >= 0; i -= 1)
        slides[i] && !breakLoop && (slideSize += slides[i].swiperSlideSize, spv += 1, slideSize > swiperSize && (breakLoop = !0));
    } else if (view === "current")
      for (let i = activeIndex + 1; i < slides.length; i += 1)
        (exact ? slidesGrid[i] + slidesSizesGrid[i] - slidesGrid[activeIndex] < swiperSize : slidesGrid[i] - slidesGrid[activeIndex] < swiperSize) && (spv += 1);
    else
      for (let i = activeIndex - 1; i >= 0; i -= 1)
        slidesGrid[activeIndex] - slidesGrid[i] < swiperSize && (spv += 1);
    return spv;
  }
  update() {
    const swiper = this;
    if (!swiper || swiper.destroyed) return;
    const {
      snapGrid,
      params
    } = swiper;
    params.breakpoints && swiper.setBreakpoint(), swiper.updateSize(), swiper.updateSlides(), swiper.updateProgress(), swiper.updateSlidesClasses();
    function setTranslate2() {
      const translateValue = swiper.rtlTranslate ? swiper.translate * -1 : swiper.translate, newTranslate = Math.min(Math.max(translateValue, swiper.maxTranslate()), swiper.minTranslate());
      swiper.setTranslate(newTranslate), swiper.updateActiveIndex(), swiper.updateSlidesClasses();
    }
    let translated;
    swiper.params.freeMode && swiper.params.freeMode.enabled ? (setTranslate2(), swiper.params.autoHeight && swiper.updateAutoHeight()) : ((swiper.params.slidesPerView === "auto" || swiper.params.slidesPerView > 1) && swiper.isEnd && !swiper.params.centeredSlides ? translated = swiper.slideTo(swiper.slides.length - 1, 0, !1, !0) : translated = swiper.slideTo(swiper.activeIndex, 0, !1, !0), translated || setTranslate2()), params.watchOverflow && snapGrid !== swiper.snapGrid && swiper.checkOverflow(), swiper.emit("update");
  }
  changeDirection(newDirection, needUpdate = !0) {
    const swiper = this, currentDirection = swiper.params.direction;
    return newDirection || (newDirection = currentDirection === "horizontal" ? "vertical" : "horizontal"), newDirection === currentDirection || newDirection !== "horizontal" && newDirection !== "vertical" || (swiper.$el.removeClass(`${swiper.params.containerModifierClass}${currentDirection}`).addClass(`${swiper.params.containerModifierClass}${newDirection}`), swiper.emitContainerClasses(), swiper.params.direction = newDirection, swiper.slides.each((slideEl) => {
      newDirection === "vertical" ? slideEl.style.width = "" : slideEl.style.height = "";
    }), swiper.emit("changeDirection"), needUpdate && swiper.update()), swiper;
  }
  changeLanguageDirection(direction) {
    const swiper = this;
    swiper.rtl && direction === "rtl" || !swiper.rtl && direction === "ltr" || (swiper.rtl = direction === "rtl", swiper.rtlTranslate = swiper.params.direction === "horizontal" && swiper.rtl, swiper.rtl ? (swiper.$el.addClass(`${swiper.params.containerModifierClass}rtl`), swiper.el.dir = "rtl") : (swiper.$el.removeClass(`${swiper.params.containerModifierClass}rtl`), swiper.el.dir = "ltr"), swiper.update());
  }
  mount(el) {
    const swiper = this;
    if (swiper.mounted) return !0;
    const $el = $(el || swiper.params.el);
    if (el = $el[0], !el)
      return !1;
    el.swiper = swiper;
    const getWrapperSelector = () => `.${(swiper.params.wrapperClass || "").trim().split(" ").join(".")}`;
    let $wrapperEl = (() => {
      if (el && el.shadowRoot && el.shadowRoot.querySelector) {
        const res = $(el.shadowRoot.querySelector(getWrapperSelector()));
        return res.children = (options) => $el.children(options), res;
      }
      return $el.children ? $el.children(getWrapperSelector()) : $($el).children(getWrapperSelector());
    })();
    if ($wrapperEl.length === 0 && swiper.params.createElements) {
      const wrapper = getDocument().createElement("div");
      $wrapperEl = $(wrapper), wrapper.className = swiper.params.wrapperClass, $el.append(wrapper), $el.children(`.${swiper.params.slideClass}`).each((slideEl) => {
        $wrapperEl.append(slideEl);
      });
    }
    return Object.assign(swiper, {
      $el,
      el,
      $wrapperEl,
      wrapperEl: $wrapperEl[0],
      mounted: !0,
      // RTL
      rtl: el.dir.toLowerCase() === "rtl" || $el.css("direction") === "rtl",
      rtlTranslate: swiper.params.direction === "horizontal" && (el.dir.toLowerCase() === "rtl" || $el.css("direction") === "rtl"),
      wrongRTL: $wrapperEl.css("display") === "-webkit-box"
    }), !0;
  }
  init(el) {
    const swiper = this;
    return swiper.initialized || swiper.mount(el) === !1 || (swiper.emit("beforeInit"), swiper.params.breakpoints && swiper.setBreakpoint(), swiper.addClasses(), swiper.params.loop && swiper.loopCreate(), swiper.updateSize(), swiper.updateSlides(), swiper.params.watchOverflow && swiper.checkOverflow(), swiper.params.grabCursor && swiper.enabled && swiper.setGrabCursor(), swiper.params.preloadImages && swiper.preloadImages(), swiper.params.loop ? swiper.slideTo(swiper.params.initialSlide + swiper.loopedSlides, 0, swiper.params.runCallbacksOnInit, !1, !0) : swiper.slideTo(swiper.params.initialSlide, 0, swiper.params.runCallbacksOnInit, !1, !0), swiper.attachEvents(), swiper.initialized = !0, swiper.emit("init"), swiper.emit("afterInit")), swiper;
  }
  destroy(deleteInstance = !0, cleanStyles = !0) {
    const swiper = this, {
      params,
      $el,
      $wrapperEl,
      slides
    } = swiper;
    return typeof swiper.params > "u" || swiper.destroyed || (swiper.emit("beforeDestroy"), swiper.initialized = !1, swiper.detachEvents(), params.loop && swiper.loopDestroy(), cleanStyles && (swiper.removeClasses(), $el.removeAttr("style"), $wrapperEl.removeAttr("style"), slides && slides.length && slides.removeClass([params.slideVisibleClass, params.slideActiveClass, params.slideNextClass, params.slidePrevClass].join(" ")).removeAttr("style").removeAttr("data-swiper-slide-index")), swiper.emit("destroy"), Object.keys(swiper.eventsListeners).forEach((eventName) => {
      swiper.off(eventName);
    }), deleteInstance !== !1 && (swiper.$el[0].swiper = null, deleteProps(swiper)), swiper.destroyed = !0), null;
  }
  static extendDefaults(newDefaults) {
    extend$1(extendedDefaults, newDefaults);
  }
  static get extendedDefaults() {
    return extendedDefaults;
  }
  static get defaults() {
    return defaults;
  }
  static installModule(mod) {
    Swiper.prototype.__modules__ || (Swiper.prototype.__modules__ = []);
    const modules = Swiper.prototype.__modules__;
    typeof mod == "function" && modules.indexOf(mod) < 0 && modules.push(mod);
  }
  static use(module) {
    return Array.isArray(module) ? (module.forEach((m) => Swiper.installModule(m)), Swiper) : (Swiper.installModule(module), Swiper);
  }
};
Object.keys(prototypes).forEach((prototypeGroup) => {
  Object.keys(prototypes[prototypeGroup]).forEach((protoMethod) => {
    Swiper$1.prototype[protoMethod] = prototypes[prototypeGroup][protoMethod];
  });
});
Swiper$1.use([Resize, Observer]);
function createElementIfNotDefined(swiper, originalParams, params, checkProps) {
  const document2 = getDocument();
  return swiper.params.createElements && Object.keys(checkProps).forEach((key) => {
    if (!params[key] && params.auto === !0) {
      let element = swiper.$el.children(`.${checkProps[key]}`)[0];
      element || (element = document2.createElement("div"), element.className = checkProps[key], swiper.$el.append(element)), params[key] = element, originalParams[key] = element;
    }
  }), params;
}
function Navigation({
  swiper,
  extendParams,
  on: on2,
  emit
}) {
  extendParams({
    navigation: {
      nextEl: null,
      prevEl: null,
      hideOnClick: !1,
      disabledClass: "swiper-button-disabled",
      hiddenClass: "swiper-button-hidden",
      lockClass: "swiper-button-lock",
      navigationDisabledClass: "swiper-navigation-disabled"
    }
  }), swiper.navigation = {
    nextEl: null,
    $nextEl: null,
    prevEl: null,
    $prevEl: null
  };
  function getEl(el) {
    let $el;
    return el && ($el = $(el), swiper.params.uniqueNavElements && typeof el == "string" && $el.length > 1 && swiper.$el.find(el).length === 1 && ($el = swiper.$el.find(el))), $el;
  }
  function toggleEl($el, disabled) {
    const params = swiper.params.navigation;
    $el && $el.length > 0 && ($el[disabled ? "addClass" : "removeClass"](params.disabledClass), $el[0] && $el[0].tagName === "BUTTON" && ($el[0].disabled = disabled), swiper.params.watchOverflow && swiper.enabled && $el[swiper.isLocked ? "addClass" : "removeClass"](params.lockClass));
  }
  function update2() {
    if (swiper.params.loop) return;
    const {
      $nextEl,
      $prevEl
    } = swiper.navigation;
    toggleEl($prevEl, swiper.isBeginning && !swiper.params.rewind), toggleEl($nextEl, swiper.isEnd && !swiper.params.rewind);
  }
  function onPrevClick(e) {
    e.preventDefault(), !(swiper.isBeginning && !swiper.params.loop && !swiper.params.rewind) && (swiper.slidePrev(), emit("navigationPrev"));
  }
  function onNextClick(e) {
    e.preventDefault(), !(swiper.isEnd && !swiper.params.loop && !swiper.params.rewind) && (swiper.slideNext(), emit("navigationNext"));
  }
  function init2() {
    const params = swiper.params.navigation;
    if (swiper.params.navigation = createElementIfNotDefined(swiper, swiper.originalParams.navigation, swiper.params.navigation, {
      nextEl: "swiper-button-next",
      prevEl: "swiper-button-prev"
    }), !(params.nextEl || params.prevEl)) return;
    const $nextEl = getEl(params.nextEl), $prevEl = getEl(params.prevEl);
    $nextEl && $nextEl.length > 0 && $nextEl.on("click", onNextClick), $prevEl && $prevEl.length > 0 && $prevEl.on("click", onPrevClick), Object.assign(swiper.navigation, {
      $nextEl,
      nextEl: $nextEl && $nextEl[0],
      $prevEl,
      prevEl: $prevEl && $prevEl[0]
    }), swiper.enabled || ($nextEl && $nextEl.addClass(params.lockClass), $prevEl && $prevEl.addClass(params.lockClass));
  }
  function destroy() {
    const {
      $nextEl,
      $prevEl
    } = swiper.navigation;
    $nextEl && $nextEl.length && ($nextEl.off("click", onNextClick), $nextEl.removeClass(swiper.params.navigation.disabledClass)), $prevEl && $prevEl.length && ($prevEl.off("click", onPrevClick), $prevEl.removeClass(swiper.params.navigation.disabledClass));
  }
  on2("init", () => {
    swiper.params.navigation.enabled === !1 ? disable() : (init2(), update2());
  }), on2("toEdge fromEdge lock unlock", () => {
    update2();
  }), on2("destroy", () => {
    destroy();
  }), on2("enable disable", () => {
    const {
      $nextEl,
      $prevEl
    } = swiper.navigation;
    $nextEl && $nextEl[swiper.enabled ? "removeClass" : "addClass"](swiper.params.navigation.lockClass), $prevEl && $prevEl[swiper.enabled ? "removeClass" : "addClass"](swiper.params.navigation.lockClass);
  }), on2("click", (_s, e) => {
    const {
      $nextEl,
      $prevEl
    } = swiper.navigation, targetEl = e.target;
    if (swiper.params.navigation.hideOnClick && !$(targetEl).is($prevEl) && !$(targetEl).is($nextEl)) {
      if (swiper.pagination && swiper.params.pagination && swiper.params.pagination.clickable && (swiper.pagination.el === targetEl || swiper.pagination.el.contains(targetEl))) return;
      let isHidden;
      $nextEl ? isHidden = $nextEl.hasClass(swiper.params.navigation.hiddenClass) : $prevEl && (isHidden = $prevEl.hasClass(swiper.params.navigation.hiddenClass)), emit(isHidden === !0 ? "navigationShow" : "navigationHide"), $nextEl && $nextEl.toggleClass(swiper.params.navigation.hiddenClass), $prevEl && $prevEl.toggleClass(swiper.params.navigation.hiddenClass);
    }
  });
  const enable = () => {
    swiper.$el.removeClass(swiper.params.navigation.navigationDisabledClass), init2(), update2();
  }, disable = () => {
    swiper.$el.addClass(swiper.params.navigation.navigationDisabledClass), destroy();
  };
  Object.assign(swiper.navigation, {
    enable,
    disable,
    update: update2,
    init: init2,
    destroy
  });
}
function classesToSelector(classes2 = "") {
  return `.${classes2.trim().replace(/([\.:!\/])/g, "\\$1").replace(/ /g, ".")}`;
}
function Pagination({
  swiper,
  extendParams,
  on: on2,
  emit
}) {
  const pfx = "swiper-pagination";
  extendParams({
    pagination: {
      el: null,
      bulletElement: "span",
      clickable: !1,
      hideOnClick: !1,
      renderBullet: null,
      renderProgressbar: null,
      renderFraction: null,
      renderCustom: null,
      progressbarOpposite: !1,
      type: "bullets",
      // 'bullets' or 'progressbar' or 'fraction' or 'custom'
      dynamicBullets: !1,
      dynamicMainBullets: 1,
      formatFractionCurrent: (number) => number,
      formatFractionTotal: (number) => number,
      bulletClass: `${pfx}-bullet`,
      bulletActiveClass: `${pfx}-bullet-active`,
      modifierClass: `${pfx}-`,
      currentClass: `${pfx}-current`,
      totalClass: `${pfx}-total`,
      hiddenClass: `${pfx}-hidden`,
      progressbarFillClass: `${pfx}-progressbar-fill`,
      progressbarOppositeClass: `${pfx}-progressbar-opposite`,
      clickableClass: `${pfx}-clickable`,
      lockClass: `${pfx}-lock`,
      horizontalClass: `${pfx}-horizontal`,
      verticalClass: `${pfx}-vertical`,
      paginationDisabledClass: `${pfx}-disabled`
    }
  }), swiper.pagination = {
    el: null,
    $el: null,
    bullets: []
  };
  let bulletSize, dynamicBulletIndex = 0;
  function isPaginationDisabled() {
    return !swiper.params.pagination.el || !swiper.pagination.el || !swiper.pagination.$el || swiper.pagination.$el.length === 0;
  }
  function setSideBullets($bulletEl, position) {
    const {
      bulletActiveClass
    } = swiper.params.pagination;
    $bulletEl[position]().addClass(`${bulletActiveClass}-${position}`)[position]().addClass(`${bulletActiveClass}-${position}-${position}`);
  }
  function update2() {
    const rtl = swiper.rtl, params = swiper.params.pagination;
    if (isPaginationDisabled()) return;
    const slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.slides.length, $el = swiper.pagination.$el;
    let current;
    const total = swiper.params.loop ? Math.ceil((slidesLength - swiper.loopedSlides * 2) / swiper.params.slidesPerGroup) : swiper.snapGrid.length;
    if (swiper.params.loop ? (current = Math.ceil((swiper.activeIndex - swiper.loopedSlides) / swiper.params.slidesPerGroup), current > slidesLength - 1 - swiper.loopedSlides * 2 && (current -= slidesLength - swiper.loopedSlides * 2), current > total - 1 && (current -= total), current < 0 && swiper.params.paginationType !== "bullets" && (current = total + current)) : typeof swiper.snapIndex < "u" ? current = swiper.snapIndex : current = swiper.activeIndex || 0, params.type === "bullets" && swiper.pagination.bullets && swiper.pagination.bullets.length > 0) {
      const bullets = swiper.pagination.bullets;
      let firstIndex, lastIndex, midIndex;
      if (params.dynamicBullets && (bulletSize = bullets.eq(0)[swiper.isHorizontal() ? "outerWidth" : "outerHeight"](!0), $el.css(swiper.isHorizontal() ? "width" : "height", `${bulletSize * (params.dynamicMainBullets + 4)}px`), params.dynamicMainBullets > 1 && swiper.previousIndex !== void 0 && (dynamicBulletIndex += current - (swiper.previousIndex - swiper.loopedSlides || 0), dynamicBulletIndex > params.dynamicMainBullets - 1 ? dynamicBulletIndex = params.dynamicMainBullets - 1 : dynamicBulletIndex < 0 && (dynamicBulletIndex = 0)), firstIndex = Math.max(current - dynamicBulletIndex, 0), lastIndex = firstIndex + (Math.min(bullets.length, params.dynamicMainBullets) - 1), midIndex = (lastIndex + firstIndex) / 2), bullets.removeClass(["", "-next", "-next-next", "-prev", "-prev-prev", "-main"].map((suffix) => `${params.bulletActiveClass}${suffix}`).join(" ")), $el.length > 1)
        bullets.each((bullet) => {
          const $bullet = $(bullet), bulletIndex = $bullet.index();
          bulletIndex === current && $bullet.addClass(params.bulletActiveClass), params.dynamicBullets && (bulletIndex >= firstIndex && bulletIndex <= lastIndex && $bullet.addClass(`${params.bulletActiveClass}-main`), bulletIndex === firstIndex && setSideBullets($bullet, "prev"), bulletIndex === lastIndex && setSideBullets($bullet, "next"));
        });
      else {
        const $bullet = bullets.eq(current), bulletIndex = $bullet.index();
        if ($bullet.addClass(params.bulletActiveClass), params.dynamicBullets) {
          const $firstDisplayedBullet = bullets.eq(firstIndex), $lastDisplayedBullet = bullets.eq(lastIndex);
          for (let i = firstIndex; i <= lastIndex; i += 1)
            bullets.eq(i).addClass(`${params.bulletActiveClass}-main`);
          if (swiper.params.loop)
            if (bulletIndex >= bullets.length) {
              for (let i = params.dynamicMainBullets; i >= 0; i -= 1)
                bullets.eq(bullets.length - i).addClass(`${params.bulletActiveClass}-main`);
              bullets.eq(bullets.length - params.dynamicMainBullets - 1).addClass(`${params.bulletActiveClass}-prev`);
            } else
              setSideBullets($firstDisplayedBullet, "prev"), setSideBullets($lastDisplayedBullet, "next");
          else
            setSideBullets($firstDisplayedBullet, "prev"), setSideBullets($lastDisplayedBullet, "next");
        }
      }
      if (params.dynamicBullets) {
        const dynamicBulletsLength = Math.min(bullets.length, params.dynamicMainBullets + 4), bulletsOffset = (bulletSize * dynamicBulletsLength - bulletSize) / 2 - midIndex * bulletSize, offsetProp = rtl ? "right" : "left";
        bullets.css(swiper.isHorizontal() ? offsetProp : "top", `${bulletsOffset}px`);
      }
    }
    if (params.type === "fraction" && ($el.find(classesToSelector(params.currentClass)).text(params.formatFractionCurrent(current + 1)), $el.find(classesToSelector(params.totalClass)).text(params.formatFractionTotal(total))), params.type === "progressbar") {
      let progressbarDirection;
      params.progressbarOpposite ? progressbarDirection = swiper.isHorizontal() ? "vertical" : "horizontal" : progressbarDirection = swiper.isHorizontal() ? "horizontal" : "vertical";
      const scale = (current + 1) / total;
      let scaleX = 1, scaleY = 1;
      progressbarDirection === "horizontal" ? scaleX = scale : scaleY = scale, $el.find(classesToSelector(params.progressbarFillClass)).transform(`translate3d(0,0,0) scaleX(${scaleX}) scaleY(${scaleY})`).transition(swiper.params.speed);
    }
    params.type === "custom" && params.renderCustom ? ($el.html(params.renderCustom(swiper, current + 1, total)), emit("paginationRender", $el[0])) : emit("paginationUpdate", $el[0]), swiper.params.watchOverflow && swiper.enabled && $el[swiper.isLocked ? "addClass" : "removeClass"](params.lockClass);
  }
  function render() {
    const params = swiper.params.pagination;
    if (isPaginationDisabled()) return;
    const slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.slides.length, $el = swiper.pagination.$el;
    let paginationHTML = "";
    if (params.type === "bullets") {
      let numberOfBullets = swiper.params.loop ? Math.ceil((slidesLength - swiper.loopedSlides * 2) / swiper.params.slidesPerGroup) : swiper.snapGrid.length;
      swiper.params.freeMode && swiper.params.freeMode.enabled && !swiper.params.loop && numberOfBullets > slidesLength && (numberOfBullets = slidesLength);
      for (let i = 0; i < numberOfBullets; i += 1)
        params.renderBullet ? paginationHTML += params.renderBullet.call(swiper, i, params.bulletClass) : paginationHTML += `<${params.bulletElement} class="${params.bulletClass}"></${params.bulletElement}>`;
      $el.html(paginationHTML), swiper.pagination.bullets = $el.find(classesToSelector(params.bulletClass));
    }
    params.type === "fraction" && (params.renderFraction ? paginationHTML = params.renderFraction.call(swiper, params.currentClass, params.totalClass) : paginationHTML = `<span class="${params.currentClass}"></span> / <span class="${params.totalClass}"></span>`, $el.html(paginationHTML)), params.type === "progressbar" && (params.renderProgressbar ? paginationHTML = params.renderProgressbar.call(swiper, params.progressbarFillClass) : paginationHTML = `<span class="${params.progressbarFillClass}"></span>`, $el.html(paginationHTML)), params.type !== "custom" && emit("paginationRender", swiper.pagination.$el[0]);
  }
  function init2() {
    swiper.params.pagination = createElementIfNotDefined(swiper, swiper.originalParams.pagination, swiper.params.pagination, {
      el: "swiper-pagination"
    });
    const params = swiper.params.pagination;
    if (!params.el) return;
    let $el = $(params.el);
    $el.length !== 0 && (swiper.params.uniqueNavElements && typeof params.el == "string" && $el.length > 1 && ($el = swiper.$el.find(params.el), $el.length > 1 && ($el = $el.filter((el) => $(el).parents(".swiper")[0] === swiper.el))), params.type === "bullets" && params.clickable && $el.addClass(params.clickableClass), $el.addClass(params.modifierClass + params.type), $el.addClass(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass), params.type === "bullets" && params.dynamicBullets && ($el.addClass(`${params.modifierClass}${params.type}-dynamic`), dynamicBulletIndex = 0, params.dynamicMainBullets < 1 && (params.dynamicMainBullets = 1)), params.type === "progressbar" && params.progressbarOpposite && $el.addClass(params.progressbarOppositeClass), params.clickable && $el.on("click", classesToSelector(params.bulletClass), function(e) {
      e.preventDefault();
      let index2 = $(this).index() * swiper.params.slidesPerGroup;
      swiper.params.loop && (index2 += swiper.loopedSlides), swiper.slideTo(index2);
    }), Object.assign(swiper.pagination, {
      $el,
      el: $el[0]
    }), swiper.enabled || $el.addClass(params.lockClass));
  }
  function destroy() {
    const params = swiper.params.pagination;
    if (isPaginationDisabled()) return;
    const $el = swiper.pagination.$el;
    $el.removeClass(params.hiddenClass), $el.removeClass(params.modifierClass + params.type), $el.removeClass(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass), swiper.pagination.bullets && swiper.pagination.bullets.removeClass && swiper.pagination.bullets.removeClass(params.bulletActiveClass), params.clickable && $el.off("click", classesToSelector(params.bulletClass));
  }
  on2("init", () => {
    swiper.params.pagination.enabled === !1 ? disable() : (init2(), render(), update2());
  }), on2("activeIndexChange", () => {
    (swiper.params.loop || typeof swiper.snapIndex > "u") && update2();
  }), on2("snapIndexChange", () => {
    swiper.params.loop || update2();
  }), on2("slidesLengthChange", () => {
    swiper.params.loop && (render(), update2());
  }), on2("snapGridLengthChange", () => {
    swiper.params.loop || (render(), update2());
  }), on2("destroy", () => {
    destroy();
  }), on2("enable disable", () => {
    const {
      $el
    } = swiper.pagination;
    $el && $el[swiper.enabled ? "removeClass" : "addClass"](swiper.params.pagination.lockClass);
  }), on2("lock unlock", () => {
    update2();
  }), on2("click", (_s, e) => {
    const targetEl = e.target, {
      $el
    } = swiper.pagination;
    if (swiper.params.pagination.el && swiper.params.pagination.hideOnClick && $el && $el.length > 0 && !$(targetEl).hasClass(swiper.params.pagination.bulletClass)) {
      if (swiper.navigation && (swiper.navigation.nextEl && targetEl === swiper.navigation.nextEl || swiper.navigation.prevEl && targetEl === swiper.navigation.prevEl)) return;
      const isHidden = $el.hasClass(swiper.params.pagination.hiddenClass);
      emit(isHidden === !0 ? "paginationShow" : "paginationHide"), $el.toggleClass(swiper.params.pagination.hiddenClass);
    }
  });
  const enable = () => {
    swiper.$el.removeClass(swiper.params.pagination.paginationDisabledClass), swiper.pagination.$el && swiper.pagination.$el.removeClass(swiper.params.pagination.paginationDisabledClass), init2(), render(), update2();
  }, disable = () => {
    swiper.$el.addClass(swiper.params.pagination.paginationDisabledClass), swiper.pagination.$el && swiper.pagination.$el.addClass(swiper.params.pagination.paginationDisabledClass), destroy();
  };
  Object.assign(swiper.pagination, {
    enable,
    disable,
    render,
    update: update2,
    init: init2,
    destroy
  });
}
function Zoom({
  swiper,
  extendParams,
  on: on2,
  emit
}) {
  const window2 = getWindow();
  extendParams({
    zoom: {
      enabled: !1,
      maxRatio: 3,
      minRatio: 1,
      toggle: !0,
      containerClass: "swiper-zoom-container",
      zoomedSlideClass: "swiper-slide-zoomed"
    }
  }), swiper.zoom = {
    enabled: !1
  };
  let currentScale = 1, isScaling = !1, gesturesEnabled, fakeGestureTouched, fakeGestureMoved;
  const gesture = {
    $slideEl: void 0,
    slideWidth: void 0,
    slideHeight: void 0,
    $imageEl: void 0,
    $imageWrapEl: void 0,
    maxRatio: 3
  }, image = {
    isTouched: void 0,
    isMoved: void 0,
    currentX: void 0,
    currentY: void 0,
    minX: void 0,
    minY: void 0,
    maxX: void 0,
    maxY: void 0,
    width: void 0,
    height: void 0,
    startX: void 0,
    startY: void 0,
    touchesStart: {},
    touchesCurrent: {}
  }, velocity = {
    x: void 0,
    y: void 0,
    prevPositionX: void 0,
    prevPositionY: void 0,
    prevTime: void 0
  };
  let scale = 1;
  Object.defineProperty(swiper.zoom, "scale", {
    get() {
      return scale;
    },
    set(value) {
      if (scale !== value) {
        const imageEl = gesture.$imageEl ? gesture.$imageEl[0] : void 0, slideEl = gesture.$slideEl ? gesture.$slideEl[0] : void 0;
        emit("zoomChange", value, imageEl, slideEl);
      }
      scale = value;
    }
  });
  function getDistanceBetweenTouches(e) {
    if (e.targetTouches.length < 2) return 1;
    const x1 = e.targetTouches[0].pageX, y1 = e.targetTouches[0].pageY, x2 = e.targetTouches[1].pageX, y2 = e.targetTouches[1].pageY;
    return Math.sqrt((x2 - x1) ** 2 + (y2 - y1) ** 2);
  }
  function onGestureStart(e) {
    const support2 = swiper.support, params = swiper.params.zoom;
    if (fakeGestureTouched = !1, fakeGestureMoved = !1, !support2.gestures) {
      if (e.type !== "touchstart" || e.type === "touchstart" && e.targetTouches.length < 2)
        return;
      fakeGestureTouched = !0, gesture.scaleStart = getDistanceBetweenTouches(e);
    }
    if ((!gesture.$slideEl || !gesture.$slideEl.length) && (gesture.$slideEl = $(e.target).closest(`.${swiper.params.slideClass}`), gesture.$slideEl.length === 0 && (gesture.$slideEl = swiper.slides.eq(swiper.activeIndex)), gesture.$imageEl = gesture.$slideEl.find(`.${params.containerClass}`).eq(0).find("picture, img, svg, canvas, .swiper-zoom-target").eq(0), gesture.$imageWrapEl = gesture.$imageEl.parent(`.${params.containerClass}`), gesture.maxRatio = gesture.$imageWrapEl.attr("data-swiper-zoom") || params.maxRatio, gesture.$imageWrapEl.length === 0)) {
      gesture.$imageEl = void 0;
      return;
    }
    gesture.$imageEl && gesture.$imageEl.transition(0), isScaling = !0;
  }
  function onGestureChange(e) {
    const support2 = swiper.support, params = swiper.params.zoom, zoom = swiper.zoom;
    if (!support2.gestures) {
      if (e.type !== "touchmove" || e.type === "touchmove" && e.targetTouches.length < 2)
        return;
      fakeGestureMoved = !0, gesture.scaleMove = getDistanceBetweenTouches(e);
    }
    if (!gesture.$imageEl || gesture.$imageEl.length === 0) {
      e.type === "gesturechange" && onGestureStart(e);
      return;
    }
    support2.gestures ? zoom.scale = e.scale * currentScale : zoom.scale = gesture.scaleMove / gesture.scaleStart * currentScale, zoom.scale > gesture.maxRatio && (zoom.scale = gesture.maxRatio - 1 + (zoom.scale - gesture.maxRatio + 1) ** 0.5), zoom.scale < params.minRatio && (zoom.scale = params.minRatio + 1 - (params.minRatio - zoom.scale + 1) ** 0.5), gesture.$imageEl.transform(`translate3d(0,0,0) scale(${zoom.scale})`);
  }
  function onGestureEnd(e) {
    const device = swiper.device, support2 = swiper.support, params = swiper.params.zoom, zoom = swiper.zoom;
    if (!support2.gestures) {
      if (!fakeGestureTouched || !fakeGestureMoved || e.type !== "touchend" || e.type === "touchend" && e.changedTouches.length < 2 && !device.android)
        return;
      fakeGestureTouched = !1, fakeGestureMoved = !1;
    }
    !gesture.$imageEl || gesture.$imageEl.length === 0 || (zoom.scale = Math.max(Math.min(zoom.scale, gesture.maxRatio), params.minRatio), gesture.$imageEl.transition(swiper.params.speed).transform(`translate3d(0,0,0) scale(${zoom.scale})`), currentScale = zoom.scale, isScaling = !1, zoom.scale === 1 && (gesture.$slideEl = void 0));
  }
  function onTouchStart2(e) {
    const device = swiper.device;
    !gesture.$imageEl || gesture.$imageEl.length === 0 || image.isTouched || (device.android && e.cancelable && e.preventDefault(), image.isTouched = !0, image.touchesStart.x = e.type === "touchstart" ? e.targetTouches[0].pageX : e.pageX, image.touchesStart.y = e.type === "touchstart" ? e.targetTouches[0].pageY : e.pageY);
  }
  function onTouchMove2(e) {
    const zoom = swiper.zoom;
    if (!gesture.$imageEl || gesture.$imageEl.length === 0 || (swiper.allowClick = !1, !image.isTouched || !gesture.$slideEl)) return;
    image.isMoved || (image.width = gesture.$imageEl[0].offsetWidth, image.height = gesture.$imageEl[0].offsetHeight, image.startX = getTranslate(gesture.$imageWrapEl[0], "x") || 0, image.startY = getTranslate(gesture.$imageWrapEl[0], "y") || 0, gesture.slideWidth = gesture.$slideEl[0].offsetWidth, gesture.slideHeight = gesture.$slideEl[0].offsetHeight, gesture.$imageWrapEl.transition(0));
    const scaledWidth = image.width * zoom.scale, scaledHeight = image.height * zoom.scale;
    if (!(scaledWidth < gesture.slideWidth && scaledHeight < gesture.slideHeight)) {
      if (image.minX = Math.min(gesture.slideWidth / 2 - scaledWidth / 2, 0), image.maxX = -image.minX, image.minY = Math.min(gesture.slideHeight / 2 - scaledHeight / 2, 0), image.maxY = -image.minY, image.touchesCurrent.x = e.type === "touchmove" ? e.targetTouches[0].pageX : e.pageX, image.touchesCurrent.y = e.type === "touchmove" ? e.targetTouches[0].pageY : e.pageY, !image.isMoved && !isScaling) {
        if (swiper.isHorizontal() && (Math.floor(image.minX) === Math.floor(image.startX) && image.touchesCurrent.x < image.touchesStart.x || Math.floor(image.maxX) === Math.floor(image.startX) && image.touchesCurrent.x > image.touchesStart.x)) {
          image.isTouched = !1;
          return;
        }
        if (!swiper.isHorizontal() && (Math.floor(image.minY) === Math.floor(image.startY) && image.touchesCurrent.y < image.touchesStart.y || Math.floor(image.maxY) === Math.floor(image.startY) && image.touchesCurrent.y > image.touchesStart.y)) {
          image.isTouched = !1;
          return;
        }
      }
      e.cancelable && e.preventDefault(), e.stopPropagation(), image.isMoved = !0, image.currentX = image.touchesCurrent.x - image.touchesStart.x + image.startX, image.currentY = image.touchesCurrent.y - image.touchesStart.y + image.startY, image.currentX < image.minX && (image.currentX = image.minX + 1 - (image.minX - image.currentX + 1) ** 0.8), image.currentX > image.maxX && (image.currentX = image.maxX - 1 + (image.currentX - image.maxX + 1) ** 0.8), image.currentY < image.minY && (image.currentY = image.minY + 1 - (image.minY - image.currentY + 1) ** 0.8), image.currentY > image.maxY && (image.currentY = image.maxY - 1 + (image.currentY - image.maxY + 1) ** 0.8), velocity.prevPositionX || (velocity.prevPositionX = image.touchesCurrent.x), velocity.prevPositionY || (velocity.prevPositionY = image.touchesCurrent.y), velocity.prevTime || (velocity.prevTime = Date.now()), velocity.x = (image.touchesCurrent.x - velocity.prevPositionX) / (Date.now() - velocity.prevTime) / 2, velocity.y = (image.touchesCurrent.y - velocity.prevPositionY) / (Date.now() - velocity.prevTime) / 2, Math.abs(image.touchesCurrent.x - velocity.prevPositionX) < 2 && (velocity.x = 0), Math.abs(image.touchesCurrent.y - velocity.prevPositionY) < 2 && (velocity.y = 0), velocity.prevPositionX = image.touchesCurrent.x, velocity.prevPositionY = image.touchesCurrent.y, velocity.prevTime = Date.now(), gesture.$imageWrapEl.transform(`translate3d(${image.currentX}px, ${image.currentY}px,0)`);
    }
  }
  function onTouchEnd2() {
    const zoom = swiper.zoom;
    if (!gesture.$imageEl || gesture.$imageEl.length === 0) return;
    if (!image.isTouched || !image.isMoved) {
      image.isTouched = !1, image.isMoved = !1;
      return;
    }
    image.isTouched = !1, image.isMoved = !1;
    let momentumDurationX = 300, momentumDurationY = 300;
    const momentumDistanceX = velocity.x * momentumDurationX, newPositionX = image.currentX + momentumDistanceX, momentumDistanceY = velocity.y * momentumDurationY, newPositionY = image.currentY + momentumDistanceY;
    velocity.x !== 0 && (momentumDurationX = Math.abs((newPositionX - image.currentX) / velocity.x)), velocity.y !== 0 && (momentumDurationY = Math.abs((newPositionY - image.currentY) / velocity.y));
    const momentumDuration = Math.max(momentumDurationX, momentumDurationY);
    image.currentX = newPositionX, image.currentY = newPositionY;
    const scaledWidth = image.width * zoom.scale, scaledHeight = image.height * zoom.scale;
    image.minX = Math.min(gesture.slideWidth / 2 - scaledWidth / 2, 0), image.maxX = -image.minX, image.minY = Math.min(gesture.slideHeight / 2 - scaledHeight / 2, 0), image.maxY = -image.minY, image.currentX = Math.max(Math.min(image.currentX, image.maxX), image.minX), image.currentY = Math.max(Math.min(image.currentY, image.maxY), image.minY), gesture.$imageWrapEl.transition(momentumDuration).transform(`translate3d(${image.currentX}px, ${image.currentY}px,0)`);
  }
  function onTransitionEnd() {
    const zoom = swiper.zoom;
    gesture.$slideEl && swiper.previousIndex !== swiper.activeIndex && (gesture.$imageEl && gesture.$imageEl.transform("translate3d(0,0,0) scale(1)"), gesture.$imageWrapEl && gesture.$imageWrapEl.transform("translate3d(0,0,0)"), zoom.scale = 1, currentScale = 1, gesture.$slideEl = void 0, gesture.$imageEl = void 0, gesture.$imageWrapEl = void 0);
  }
  function zoomIn(e) {
    const zoom = swiper.zoom, params = swiper.params.zoom;
    if (gesture.$slideEl || (e && e.target && (gesture.$slideEl = $(e.target).closest(`.${swiper.params.slideClass}`)), gesture.$slideEl || (swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual ? gesture.$slideEl = swiper.$wrapperEl.children(`.${swiper.params.slideActiveClass}`) : gesture.$slideEl = swiper.slides.eq(swiper.activeIndex)), gesture.$imageEl = gesture.$slideEl.find(`.${params.containerClass}`).eq(0).find("picture, img, svg, canvas, .swiper-zoom-target").eq(0), gesture.$imageWrapEl = gesture.$imageEl.parent(`.${params.containerClass}`)), !gesture.$imageEl || gesture.$imageEl.length === 0 || !gesture.$imageWrapEl || gesture.$imageWrapEl.length === 0) return;
    swiper.params.cssMode && (swiper.wrapperEl.style.overflow = "hidden", swiper.wrapperEl.style.touchAction = "none"), gesture.$slideEl.addClass(`${params.zoomedSlideClass}`);
    let touchX, touchY, offsetX, offsetY, diffX, diffY, translateX, translateY, imageWidth, imageHeight, scaledWidth, scaledHeight, translateMinX, translateMinY, translateMaxX, translateMaxY, slideWidth, slideHeight;
    typeof image.touchesStart.x > "u" && e ? (touchX = e.type === "touchend" ? e.changedTouches[0].pageX : e.pageX, touchY = e.type === "touchend" ? e.changedTouches[0].pageY : e.pageY) : (touchX = image.touchesStart.x, touchY = image.touchesStart.y), zoom.scale = gesture.$imageWrapEl.attr("data-swiper-zoom") || params.maxRatio, currentScale = gesture.$imageWrapEl.attr("data-swiper-zoom") || params.maxRatio, e ? (slideWidth = gesture.$slideEl[0].offsetWidth, slideHeight = gesture.$slideEl[0].offsetHeight, offsetX = gesture.$slideEl.offset().left + window2.scrollX, offsetY = gesture.$slideEl.offset().top + window2.scrollY, diffX = offsetX + slideWidth / 2 - touchX, diffY = offsetY + slideHeight / 2 - touchY, imageWidth = gesture.$imageEl[0].offsetWidth, imageHeight = gesture.$imageEl[0].offsetHeight, scaledWidth = imageWidth * zoom.scale, scaledHeight = imageHeight * zoom.scale, translateMinX = Math.min(slideWidth / 2 - scaledWidth / 2, 0), translateMinY = Math.min(slideHeight / 2 - scaledHeight / 2, 0), translateMaxX = -translateMinX, translateMaxY = -translateMinY, translateX = diffX * zoom.scale, translateY = diffY * zoom.scale, translateX < translateMinX && (translateX = translateMinX), translateX > translateMaxX && (translateX = translateMaxX), translateY < translateMinY && (translateY = translateMinY), translateY > translateMaxY && (translateY = translateMaxY)) : (translateX = 0, translateY = 0), gesture.$imageWrapEl.transition(300).transform(`translate3d(${translateX}px, ${translateY}px,0)`), gesture.$imageEl.transition(300).transform(`translate3d(0,0,0) scale(${zoom.scale})`);
  }
  function zoomOut() {
    const zoom = swiper.zoom, params = swiper.params.zoom;
    gesture.$slideEl || (swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual ? gesture.$slideEl = swiper.$wrapperEl.children(`.${swiper.params.slideActiveClass}`) : gesture.$slideEl = swiper.slides.eq(swiper.activeIndex), gesture.$imageEl = gesture.$slideEl.find(`.${params.containerClass}`).eq(0).find("picture, img, svg, canvas, .swiper-zoom-target").eq(0), gesture.$imageWrapEl = gesture.$imageEl.parent(`.${params.containerClass}`)), !(!gesture.$imageEl || gesture.$imageEl.length === 0 || !gesture.$imageWrapEl || gesture.$imageWrapEl.length === 0) && (swiper.params.cssMode && (swiper.wrapperEl.style.overflow = "", swiper.wrapperEl.style.touchAction = ""), zoom.scale = 1, currentScale = 1, gesture.$imageWrapEl.transition(300).transform("translate3d(0,0,0)"), gesture.$imageEl.transition(300).transform("translate3d(0,0,0) scale(1)"), gesture.$slideEl.removeClass(`${params.zoomedSlideClass}`), gesture.$slideEl = void 0);
  }
  function zoomToggle(e) {
    const zoom = swiper.zoom;
    zoom.scale && zoom.scale !== 1 ? zoomOut() : zoomIn(e);
  }
  function getListeners() {
    const support2 = swiper.support, passiveListener = swiper.touchEvents.start === "touchstart" && support2.passiveListener && swiper.params.passiveListeners ? {
      passive: !0,
      capture: !1
    } : !1, activeListenerWithCapture = support2.passiveListener ? {
      passive: !1,
      capture: !0
    } : !0;
    return {
      passiveListener,
      activeListenerWithCapture
    };
  }
  function getSlideSelector() {
    return `.${swiper.params.slideClass}`;
  }
  function toggleGestures(method) {
    const {
      passiveListener
    } = getListeners(), slideSelector = getSlideSelector();
    swiper.$wrapperEl[method]("gesturestart", slideSelector, onGestureStart, passiveListener), swiper.$wrapperEl[method]("gesturechange", slideSelector, onGestureChange, passiveListener), swiper.$wrapperEl[method]("gestureend", slideSelector, onGestureEnd, passiveListener);
  }
  function enableGestures() {
    gesturesEnabled || (gesturesEnabled = !0, toggleGestures("on"));
  }
  function disableGestures() {
    gesturesEnabled && (gesturesEnabled = !1, toggleGestures("off"));
  }
  function enable() {
    const zoom = swiper.zoom;
    if (zoom.enabled) return;
    zoom.enabled = !0;
    const support2 = swiper.support, {
      passiveListener,
      activeListenerWithCapture
    } = getListeners(), slideSelector = getSlideSelector();
    support2.gestures ? (swiper.$wrapperEl.on(swiper.touchEvents.start, enableGestures, passiveListener), swiper.$wrapperEl.on(swiper.touchEvents.end, disableGestures, passiveListener)) : swiper.touchEvents.start === "touchstart" && (swiper.$wrapperEl.on(swiper.touchEvents.start, slideSelector, onGestureStart, passiveListener), swiper.$wrapperEl.on(swiper.touchEvents.move, slideSelector, onGestureChange, activeListenerWithCapture), swiper.$wrapperEl.on(swiper.touchEvents.end, slideSelector, onGestureEnd, passiveListener), swiper.touchEvents.cancel && swiper.$wrapperEl.on(swiper.touchEvents.cancel, slideSelector, onGestureEnd, passiveListener)), swiper.$wrapperEl.on(swiper.touchEvents.move, `.${swiper.params.zoom.containerClass}`, onTouchMove2, activeListenerWithCapture);
  }
  function disable() {
    const zoom = swiper.zoom;
    if (!zoom.enabled) return;
    const support2 = swiper.support;
    zoom.enabled = !1;
    const {
      passiveListener,
      activeListenerWithCapture
    } = getListeners(), slideSelector = getSlideSelector();
    support2.gestures ? (swiper.$wrapperEl.off(swiper.touchEvents.start, enableGestures, passiveListener), swiper.$wrapperEl.off(swiper.touchEvents.end, disableGestures, passiveListener)) : swiper.touchEvents.start === "touchstart" && (swiper.$wrapperEl.off(swiper.touchEvents.start, slideSelector, onGestureStart, passiveListener), swiper.$wrapperEl.off(swiper.touchEvents.move, slideSelector, onGestureChange, activeListenerWithCapture), swiper.$wrapperEl.off(swiper.touchEvents.end, slideSelector, onGestureEnd, passiveListener), swiper.touchEvents.cancel && swiper.$wrapperEl.off(swiper.touchEvents.cancel, slideSelector, onGestureEnd, passiveListener)), swiper.$wrapperEl.off(swiper.touchEvents.move, `.${swiper.params.zoom.containerClass}`, onTouchMove2, activeListenerWithCapture);
  }
  on2("init", () => {
    swiper.params.zoom.enabled && enable();
  }), on2("destroy", () => {
    disable();
  }), on2("touchStart", (_s, e) => {
    swiper.zoom.enabled && onTouchStart2(e);
  }), on2("touchEnd", (_s, e) => {
    swiper.zoom.enabled && onTouchEnd2();
  }), on2("doubleTap", (_s, e) => {
    !swiper.animating && swiper.params.zoom.enabled && swiper.zoom.enabled && swiper.params.zoom.toggle && zoomToggle(e);
  }), on2("transitionEnd", () => {
    swiper.zoom.enabled && swiper.params.zoom.enabled && onTransitionEnd();
  }), on2("slideChange", () => {
    swiper.zoom.enabled && swiper.params.zoom.enabled && swiper.params.cssMode && onTransitionEnd();
  }), Object.assign(swiper.zoom, {
    enable,
    disable,
    in: zoomIn,
    out: zoomOut,
    toggle: zoomToggle
  });
}
function Lazy({
  swiper,
  extendParams,
  on: on2,
  emit
}) {
  extendParams({
    lazy: {
      checkInView: !1,
      enabled: !1,
      loadPrevNext: !1,
      loadPrevNextAmount: 1,
      loadOnTransitionStart: !1,
      scrollingElement: "",
      elementClass: "swiper-lazy",
      loadingClass: "swiper-lazy-loading",
      loadedClass: "swiper-lazy-loaded",
      preloaderClass: "swiper-lazy-preloader"
    }
  }), swiper.lazy = {};
  let scrollHandlerAttached = !1, initialImageLoaded = !1;
  function loadInSlide(index2, loadInDuplicate = !0) {
    const params = swiper.params.lazy;
    if (typeof index2 > "u" || swiper.slides.length === 0) return;
    const $slideEl = swiper.virtual && swiper.params.virtual.enabled ? swiper.$wrapperEl.children(`.${swiper.params.slideClass}[data-swiper-slide-index="${index2}"]`) : swiper.slides.eq(index2), $images = $slideEl.find(`.${params.elementClass}:not(.${params.loadedClass}):not(.${params.loadingClass})`);
    $slideEl.hasClass(params.elementClass) && !$slideEl.hasClass(params.loadedClass) && !$slideEl.hasClass(params.loadingClass) && $images.push($slideEl[0]), $images.length !== 0 && $images.each((imageEl) => {
      const $imageEl = $(imageEl);
      $imageEl.addClass(params.loadingClass);
      const background = $imageEl.attr("data-background"), src = $imageEl.attr("data-src"), srcset = $imageEl.attr("data-srcset"), sizes = $imageEl.attr("data-sizes"), $pictureEl = $imageEl.parent("picture");
      swiper.loadImage($imageEl[0], src || background, srcset, sizes, !1, () => {
        if (!(typeof swiper > "u" || swiper === null || !swiper || swiper && !swiper.params || swiper.destroyed)) {
          if (background ? ($imageEl.css("background-image", `url("${background}")`), $imageEl.removeAttr("data-background")) : (srcset && ($imageEl.attr("srcset", srcset), $imageEl.removeAttr("data-srcset")), sizes && ($imageEl.attr("sizes", sizes), $imageEl.removeAttr("data-sizes")), $pictureEl.length && $pictureEl.children("source").each((sourceEl) => {
            const $source = $(sourceEl);
            $source.attr("data-srcset") && ($source.attr("srcset", $source.attr("data-srcset")), $source.removeAttr("data-srcset"));
          }), src && ($imageEl.attr("src", src), $imageEl.removeAttr("data-src"))), $imageEl.addClass(params.loadedClass).removeClass(params.loadingClass), $slideEl.find(`.${params.preloaderClass}`).remove(), swiper.params.loop && loadInDuplicate) {
            const slideOriginalIndex = $slideEl.attr("data-swiper-slide-index");
            if ($slideEl.hasClass(swiper.params.slideDuplicateClass)) {
              const originalSlide = swiper.$wrapperEl.children(`[data-swiper-slide-index="${slideOriginalIndex}"]:not(.${swiper.params.slideDuplicateClass})`);
              loadInSlide(originalSlide.index(), !1);
            } else {
              const duplicatedSlide = swiper.$wrapperEl.children(`.${swiper.params.slideDuplicateClass}[data-swiper-slide-index="${slideOriginalIndex}"]`);
              loadInSlide(duplicatedSlide.index(), !1);
            }
          }
          emit("lazyImageReady", $slideEl[0], $imageEl[0]), swiper.params.autoHeight && swiper.updateAutoHeight();
        }
      }), emit("lazyImageLoad", $slideEl[0], $imageEl[0]);
    });
  }
  function load() {
    const {
      $wrapperEl,
      params: swiperParams,
      slides,
      activeIndex
    } = swiper, isVirtual = swiper.virtual && swiperParams.virtual.enabled, params = swiperParams.lazy;
    let slidesPerView = swiperParams.slidesPerView;
    slidesPerView === "auto" && (slidesPerView = 0);
    function slideExist(index2) {
      if (isVirtual) {
        if ($wrapperEl.children(`.${swiperParams.slideClass}[data-swiper-slide-index="${index2}"]`).length)
          return !0;
      } else if (slides[index2]) return !0;
      return !1;
    }
    function slideIndex(slideEl) {
      return isVirtual ? $(slideEl).attr("data-swiper-slide-index") : $(slideEl).index();
    }
    if (initialImageLoaded || (initialImageLoaded = !0), swiper.params.watchSlidesProgress)
      $wrapperEl.children(`.${swiperParams.slideVisibleClass}`).each((slideEl) => {
        const index2 = isVirtual ? $(slideEl).attr("data-swiper-slide-index") : $(slideEl).index();
        loadInSlide(index2);
      });
    else if (slidesPerView > 1)
      for (let i = activeIndex; i < activeIndex + slidesPerView; i += 1)
        slideExist(i) && loadInSlide(i);
    else
      loadInSlide(activeIndex);
    if (params.loadPrevNext)
      if (slidesPerView > 1 || params.loadPrevNextAmount && params.loadPrevNextAmount > 1) {
        const amount = params.loadPrevNextAmount, spv = Math.ceil(slidesPerView), maxIndex = Math.min(activeIndex + spv + Math.max(amount, spv), slides.length), minIndex = Math.max(activeIndex - Math.max(spv, amount), 0);
        for (let i = activeIndex + spv; i < maxIndex; i += 1)
          slideExist(i) && loadInSlide(i);
        for (let i = minIndex; i < activeIndex; i += 1)
          slideExist(i) && loadInSlide(i);
      } else {
        const nextSlide = $wrapperEl.children(`.${swiperParams.slideNextClass}`);
        nextSlide.length > 0 && loadInSlide(slideIndex(nextSlide));
        const prevSlide = $wrapperEl.children(`.${swiperParams.slidePrevClass}`);
        prevSlide.length > 0 && loadInSlide(slideIndex(prevSlide));
      }
  }
  function checkInViewOnLoad() {
    const window2 = getWindow();
    if (!swiper || swiper.destroyed) return;
    const $scrollElement = swiper.params.lazy.scrollingElement ? $(swiper.params.lazy.scrollingElement) : $(window2), isWindow = $scrollElement[0] === window2, scrollElementWidth = isWindow ? window2.innerWidth : $scrollElement[0].offsetWidth, scrollElementHeight = isWindow ? window2.innerHeight : $scrollElement[0].offsetHeight, swiperOffset = swiper.$el.offset(), {
      rtlTranslate: rtl
    } = swiper;
    let inView = !1;
    rtl && (swiperOffset.left -= swiper.$el[0].scrollLeft);
    const swiperCoord = [[swiperOffset.left, swiperOffset.top], [swiperOffset.left + swiper.width, swiperOffset.top], [swiperOffset.left, swiperOffset.top + swiper.height], [swiperOffset.left + swiper.width, swiperOffset.top + swiper.height]];
    for (let i = 0; i < swiperCoord.length; i += 1) {
      const point = swiperCoord[i];
      if (point[0] >= 0 && point[0] <= scrollElementWidth && point[1] >= 0 && point[1] <= scrollElementHeight) {
        if (point[0] === 0 && point[1] === 0) continue;
        inView = !0;
      }
    }
    const passiveListener = swiper.touchEvents.start === "touchstart" && swiper.support.passiveListener && swiper.params.passiveListeners ? {
      passive: !0,
      capture: !1
    } : !1;
    inView ? (load(), $scrollElement.off("scroll", checkInViewOnLoad, passiveListener)) : scrollHandlerAttached || (scrollHandlerAttached = !0, $scrollElement.on("scroll", checkInViewOnLoad, passiveListener));
  }
  on2("beforeInit", () => {
    swiper.params.lazy.enabled && swiper.params.preloadImages && (swiper.params.preloadImages = !1);
  }), on2("init", () => {
    swiper.params.lazy.enabled && (swiper.params.lazy.checkInView ? checkInViewOnLoad() : load());
  }), on2("scroll", () => {
    swiper.params.freeMode && swiper.params.freeMode.enabled && !swiper.params.freeMode.sticky && load();
  }), on2("scrollbarDragMove resize _freeModeNoMomentumRelease", () => {
    swiper.params.lazy.enabled && (swiper.params.lazy.checkInView ? checkInViewOnLoad() : load());
  }), on2("transitionStart", () => {
    swiper.params.lazy.enabled && (swiper.params.lazy.loadOnTransitionStart || !swiper.params.lazy.loadOnTransitionStart && !initialImageLoaded) && (swiper.params.lazy.checkInView ? checkInViewOnLoad() : load());
  }), on2("transitionEnd", () => {
    swiper.params.lazy.enabled && !swiper.params.lazy.loadOnTransitionStart && (swiper.params.lazy.checkInView ? checkInViewOnLoad() : load());
  }), on2("slideChange", () => {
    const {
      lazy,
      cssMode,
      watchSlidesProgress,
      touchReleaseOnEdges,
      resistanceRatio
    } = swiper.params;
    lazy.enabled && (cssMode || watchSlidesProgress && (touchReleaseOnEdges || resistanceRatio === 0)) && load();
  }), on2("destroy", () => {
    swiper.$el && swiper.$el.find(`.${swiper.params.lazy.loadingClass}`).removeClass(swiper.params.lazy.loadingClass);
  }), Object.assign(swiper.lazy, {
    load,
    loadInSlide
  });
}
function Autoplay({
  swiper,
  extendParams,
  on: on2,
  emit
}) {
  let timeout;
  swiper.autoplay = {
    running: !1,
    paused: !1
  }, extendParams({
    autoplay: {
      enabled: !1,
      delay: 3e3,
      waitForTransition: !0,
      disableOnInteraction: !0,
      stopOnLastSlide: !1,
      reverseDirection: !1,
      pauseOnMouseEnter: !1
    }
  });
  function run() {
    if (!swiper.size) {
      swiper.autoplay.running = !1, swiper.autoplay.paused = !1;
      return;
    }
    const $activeSlideEl = swiper.slides.eq(swiper.activeIndex);
    let delay = swiper.params.autoplay.delay;
    $activeSlideEl.attr("data-swiper-autoplay") && (delay = $activeSlideEl.attr("data-swiper-autoplay") || swiper.params.autoplay.delay), clearTimeout(timeout), timeout = nextTick(() => {
      let autoplayResult;
      swiper.params.autoplay.reverseDirection ? swiper.params.loop ? (swiper.loopFix(), autoplayResult = swiper.slidePrev(swiper.params.speed, !0, !0), emit("autoplay")) : swiper.isBeginning ? swiper.params.autoplay.stopOnLastSlide ? stop() : (autoplayResult = swiper.slideTo(swiper.slides.length - 1, swiper.params.speed, !0, !0), emit("autoplay")) : (autoplayResult = swiper.slidePrev(swiper.params.speed, !0, !0), emit("autoplay")) : swiper.params.loop ? (swiper.loopFix(), autoplayResult = swiper.slideNext(swiper.params.speed, !0, !0), emit("autoplay")) : swiper.isEnd ? swiper.params.autoplay.stopOnLastSlide ? stop() : (autoplayResult = swiper.slideTo(0, swiper.params.speed, !0, !0), emit("autoplay")) : (autoplayResult = swiper.slideNext(swiper.params.speed, !0, !0), emit("autoplay")), (swiper.params.cssMode && swiper.autoplay.running || autoplayResult === !1) && run();
    }, delay);
  }
  function start() {
    return typeof timeout < "u" || swiper.autoplay.running ? !1 : (swiper.autoplay.running = !0, emit("autoplayStart"), run(), !0);
  }
  function stop() {
    return !swiper.autoplay.running || typeof timeout > "u" ? !1 : (timeout && (clearTimeout(timeout), timeout = void 0), swiper.autoplay.running = !1, emit("autoplayStop"), !0);
  }
  function pause(speed) {
    swiper.autoplay.running && (swiper.autoplay.paused || (timeout && clearTimeout(timeout), swiper.autoplay.paused = !0, speed === 0 || !swiper.params.autoplay.waitForTransition ? (swiper.autoplay.paused = !1, run()) : ["transitionend", "webkitTransitionEnd"].forEach((event) => {
      swiper.$wrapperEl[0].addEventListener(event, onTransitionEnd);
    })));
  }
  function onVisibilityChange() {
    const document2 = getDocument();
    document2.visibilityState === "hidden" && swiper.autoplay.running && pause(), document2.visibilityState === "visible" && swiper.autoplay.paused && (run(), swiper.autoplay.paused = !1);
  }
  function onTransitionEnd(e) {
    !swiper || swiper.destroyed || !swiper.$wrapperEl || e.target === swiper.$wrapperEl[0] && (["transitionend", "webkitTransitionEnd"].forEach((event) => {
      swiper.$wrapperEl[0].removeEventListener(event, onTransitionEnd);
    }), swiper.autoplay.paused = !1, swiper.autoplay.running ? run() : stop());
  }
  function onMouseEnter() {
    swiper.params.autoplay.disableOnInteraction ? stop() : (emit("autoplayPause"), pause()), ["transitionend", "webkitTransitionEnd"].forEach((event) => {
      swiper.$wrapperEl[0].removeEventListener(event, onTransitionEnd);
    });
  }
  function onMouseLeave() {
    swiper.params.autoplay.disableOnInteraction || (swiper.autoplay.paused = !1, emit("autoplayResume"), run());
  }
  function attachMouseEvents() {
    swiper.params.autoplay.pauseOnMouseEnter && (swiper.$el.on("mouseenter", onMouseEnter), swiper.$el.on("mouseleave", onMouseLeave));
  }
  function detachMouseEvents() {
    swiper.$el.off("mouseenter", onMouseEnter), swiper.$el.off("mouseleave", onMouseLeave);
  }
  on2("init", () => {
    swiper.params.autoplay.enabled && (start(), getDocument().addEventListener("visibilitychange", onVisibilityChange), attachMouseEvents());
  }), on2("beforeTransitionStart", (_s, speed, internal) => {
    swiper.autoplay.running && (internal || !swiper.params.autoplay.disableOnInteraction ? swiper.autoplay.pause(speed) : stop());
  }), on2("sliderFirstMove", () => {
    swiper.autoplay.running && (swiper.params.autoplay.disableOnInteraction ? stop() : pause());
  }), on2("touchEnd", () => {
    swiper.params.cssMode && swiper.autoplay.paused && !swiper.params.autoplay.disableOnInteraction && run();
  }), on2("destroy", () => {
    detachMouseEvents(), swiper.autoplay.running && stop(), getDocument().removeEventListener("visibilitychange", onVisibilityChange);
  }), Object.assign(swiper.autoplay, {
    pause,
    run,
    start,
    stop
  });
}
function freeMode({
  swiper,
  extendParams,
  emit,
  once
}) {
  extendParams({
    freeMode: {
      enabled: !1,
      momentum: !0,
      momentumRatio: 1,
      momentumBounce: !0,
      momentumBounceRatio: 1,
      momentumVelocityRatio: 1,
      sticky: !1,
      minimumVelocity: 0.02
    }
  });
  function onTouchStart2() {
    const translate2 = swiper.getTranslate();
    swiper.setTranslate(translate2), swiper.setTransition(0), swiper.touchEventsData.velocities.length = 0, swiper.freeMode.onTouchEnd({
      currentPos: swiper.rtl ? swiper.translate : -swiper.translate
    });
  }
  function onTouchMove2() {
    const {
      touchEventsData: data,
      touches
    } = swiper;
    data.velocities.length === 0 && data.velocities.push({
      position: touches[swiper.isHorizontal() ? "startX" : "startY"],
      time: data.touchStartTime
    }), data.velocities.push({
      position: touches[swiper.isHorizontal() ? "currentX" : "currentY"],
      time: now()
    });
  }
  function onTouchEnd2({
    currentPos
  }) {
    const {
      params,
      $wrapperEl,
      rtlTranslate: rtl,
      snapGrid,
      touchEventsData: data
    } = swiper, timeDiff = now() - data.touchStartTime;
    if (currentPos < -swiper.minTranslate()) {
      swiper.slideTo(swiper.activeIndex);
      return;
    }
    if (currentPos > -swiper.maxTranslate()) {
      swiper.slides.length < snapGrid.length ? swiper.slideTo(snapGrid.length - 1) : swiper.slideTo(swiper.slides.length - 1);
      return;
    }
    if (params.freeMode.momentum) {
      if (data.velocities.length > 1) {
        const lastMoveEvent = data.velocities.pop(), velocityEvent = data.velocities.pop(), distance = lastMoveEvent.position - velocityEvent.position, time = lastMoveEvent.time - velocityEvent.time;
        swiper.velocity = distance / time, swiper.velocity /= 2, Math.abs(swiper.velocity) < params.freeMode.minimumVelocity && (swiper.velocity = 0), (time > 150 || now() - lastMoveEvent.time > 300) && (swiper.velocity = 0);
      } else
        swiper.velocity = 0;
      swiper.velocity *= params.freeMode.momentumVelocityRatio, data.velocities.length = 0;
      let momentumDuration = 1e3 * params.freeMode.momentumRatio;
      const momentumDistance = swiper.velocity * momentumDuration;
      let newPosition = swiper.translate + momentumDistance;
      rtl && (newPosition = -newPosition);
      let doBounce = !1, afterBouncePosition;
      const bounceAmount = Math.abs(swiper.velocity) * 20 * params.freeMode.momentumBounceRatio;
      let needsLoopFix;
      if (newPosition < swiper.maxTranslate())
        params.freeMode.momentumBounce ? (newPosition + swiper.maxTranslate() < -bounceAmount && (newPosition = swiper.maxTranslate() - bounceAmount), afterBouncePosition = swiper.maxTranslate(), doBounce = !0, data.allowMomentumBounce = !0) : newPosition = swiper.maxTranslate(), params.loop && params.centeredSlides && (needsLoopFix = !0);
      else if (newPosition > swiper.minTranslate())
        params.freeMode.momentumBounce ? (newPosition - swiper.minTranslate() > bounceAmount && (newPosition = swiper.minTranslate() + bounceAmount), afterBouncePosition = swiper.minTranslate(), doBounce = !0, data.allowMomentumBounce = !0) : newPosition = swiper.minTranslate(), params.loop && params.centeredSlides && (needsLoopFix = !0);
      else if (params.freeMode.sticky) {
        let nextSlide;
        for (let j = 0; j < snapGrid.length; j += 1)
          if (snapGrid[j] > -newPosition) {
            nextSlide = j;
            break;
          }
        Math.abs(snapGrid[nextSlide] - newPosition) < Math.abs(snapGrid[nextSlide - 1] - newPosition) || swiper.swipeDirection === "next" ? newPosition = snapGrid[nextSlide] : newPosition = snapGrid[nextSlide - 1], newPosition = -newPosition;
      }
      if (needsLoopFix && once("transitionEnd", () => {
        swiper.loopFix();
      }), swiper.velocity !== 0) {
        if (rtl ? momentumDuration = Math.abs((-newPosition - swiper.translate) / swiper.velocity) : momentumDuration = Math.abs((newPosition - swiper.translate) / swiper.velocity), params.freeMode.sticky) {
          const moveDistance = Math.abs((rtl ? -newPosition : newPosition) - swiper.translate), currentSlideSize = swiper.slidesSizesGrid[swiper.activeIndex];
          moveDistance < currentSlideSize ? momentumDuration = params.speed : moveDistance < 2 * currentSlideSize ? momentumDuration = params.speed * 1.5 : momentumDuration = params.speed * 2.5;
        }
      } else if (params.freeMode.sticky) {
        swiper.slideToClosest();
        return;
      }
      params.freeMode.momentumBounce && doBounce ? (swiper.updateProgress(afterBouncePosition), swiper.setTransition(momentumDuration), swiper.setTranslate(newPosition), swiper.transitionStart(!0, swiper.swipeDirection), swiper.animating = !0, $wrapperEl.transitionEnd(() => {
        !swiper || swiper.destroyed || !data.allowMomentumBounce || (emit("momentumBounce"), swiper.setTransition(params.speed), setTimeout(() => {
          swiper.setTranslate(afterBouncePosition), $wrapperEl.transitionEnd(() => {
            !swiper || swiper.destroyed || swiper.transitionEnd();
          });
        }, 0));
      })) : swiper.velocity ? (emit("_freeModeNoMomentumRelease"), swiper.updateProgress(newPosition), swiper.setTransition(momentumDuration), swiper.setTranslate(newPosition), swiper.transitionStart(!0, swiper.swipeDirection), swiper.animating || (swiper.animating = !0, $wrapperEl.transitionEnd(() => {
        !swiper || swiper.destroyed || swiper.transitionEnd();
      }))) : swiper.updateProgress(newPosition), swiper.updateActiveIndex(), swiper.updateSlidesClasses();
    } else if (params.freeMode.sticky) {
      swiper.slideToClosest();
      return;
    } else params.freeMode && emit("_freeModeNoMomentumRelease");
    (!params.freeMode.momentum || timeDiff >= params.longSwipesMs) && (swiper.updateProgress(), swiper.updateActiveIndex(), swiper.updateSlidesClasses());
  }
  Object.assign(swiper, {
    freeMode: {
      onTouchStart: onTouchStart2,
      onTouchMove: onTouchMove2,
      onTouchEnd: onTouchEnd2
    }
  });
}
function isObject(o) {
  return typeof o == "object" && o !== null && o.constructor && Object.prototype.toString.call(o).slice(8, -1) === "Object";
}
function extend(target, src) {
  const noExtend = ["__proto__", "constructor", "prototype"];
  Object.keys(src).filter((key) => noExtend.indexOf(key) < 0).forEach((key) => {
    typeof target[key] > "u" ? target[key] = src[key] : isObject(src[key]) && isObject(target[key]) && Object.keys(src[key]).length > 0 ? src[key].__swiper__ ? target[key] = src[key] : extend(target[key], src[key]) : target[key] = src[key];
  });
}
function needsNavigation(params = {}) {
  return params.navigation && typeof params.navigation.nextEl > "u" && typeof params.navigation.prevEl > "u";
}
function needsPagination(params = {}) {
  return params.pagination && typeof params.pagination.el > "u";
}
function needsScrollbar(params = {}) {
  return params.scrollbar && typeof params.scrollbar.el > "u";
}
function uniqueClasses(classNames2 = "") {
  const classes2 = classNames2.split(" ").map((c) => c.trim()).filter((c) => !!c), unique = [];
  return classes2.forEach((c) => {
    unique.indexOf(c) < 0 && unique.push(c);
  }), unique.join(" ");
}
const paramsList = [
  "modules",
  "init",
  "_direction",
  "touchEventsTarget",
  "initialSlide",
  "_speed",
  "cssMode",
  "updateOnWindowResize",
  "resizeObserver",
  "nested",
  "focusableElements",
  "_enabled",
  "_width",
  "_height",
  "preventInteractionOnTransition",
  "userAgent",
  "url",
  "_edgeSwipeDetection",
  "_edgeSwipeThreshold",
  "_freeMode",
  "_autoHeight",
  "setWrapperSize",
  "virtualTranslate",
  "_effect",
  "breakpoints",
  "_spaceBetween",
  "_slidesPerView",
  "maxBackfaceHiddenSlides",
  "_grid",
  "_slidesPerGroup",
  "_slidesPerGroupSkip",
  "_slidesPerGroupAuto",
  "_centeredSlides",
  "_centeredSlidesBounds",
  "_slidesOffsetBefore",
  "_slidesOffsetAfter",
  "normalizeSlideIndex",
  "_centerInsufficientSlides",
  "_watchOverflow",
  "roundLengths",
  "touchRatio",
  "touchAngle",
  "simulateTouch",
  "_shortSwipes",
  "_longSwipes",
  "longSwipesRatio",
  "longSwipesMs",
  "_followFinger",
  "allowTouchMove",
  "_threshold",
  "touchMoveStopPropagation",
  "touchStartPreventDefault",
  "touchStartForcePreventDefault",
  "touchReleaseOnEdges",
  "uniqueNavElements",
  "_resistance",
  "_resistanceRatio",
  "_watchSlidesProgress",
  "_grabCursor",
  "preventClicks",
  "preventClicksPropagation",
  "_slideToClickedSlide",
  "_preloadImages",
  "updateOnImagesReady",
  "_loop",
  "_loopAdditionalSlides",
  "_loopedSlides",
  "_loopedSlidesLimit",
  "_loopFillGroupWithBlank",
  "loopPreventsSlide",
  "_rewind",
  "_allowSlidePrev",
  "_allowSlideNext",
  "_swipeHandler",
  "_noSwiping",
  "noSwipingClass",
  "noSwipingSelector",
  "passiveListeners",
  "containerModifierClass",
  "slideClass",
  "slideBlankClass",
  "slideActiveClass",
  "slideDuplicateActiveClass",
  "slideVisibleClass",
  "slideDuplicateClass",
  "slideNextClass",
  "slideDuplicateNextClass",
  "slidePrevClass",
  "slideDuplicatePrevClass",
  "wrapperClass",
  "runCallbacksOnInit",
  "observer",
  "observeParents",
  "observeSlideChildren",
  // modules
  "a11y",
  "_autoplay",
  "_controller",
  "coverflowEffect",
  "cubeEffect",
  "fadeEffect",
  "flipEffect",
  "creativeEffect",
  "cardsEffect",
  "hashNavigation",
  "history",
  "keyboard",
  "lazy",
  "mousewheel",
  "_navigation",
  "_pagination",
  "parallax",
  "_scrollbar",
  "_thumbs",
  "virtual",
  "zoom"
];
function getParams(obj = {}, splitEvents = !0) {
  const params = {
    on: {}
  }, events2 = {}, passedParams = {};
  extend(params, Swiper$1.defaults), extend(params, Swiper$1.extendedDefaults), params._emitClasses = !0, params.init = !1;
  const rest = {}, allowedParams = paramsList.map((key) => key.replace(/_/, "")), plainObj = Object.assign({}, obj);
  return Object.keys(plainObj).forEach((key) => {
    typeof obj[key] > "u" || (allowedParams.indexOf(key) >= 0 ? isObject(obj[key]) ? (params[key] = {}, passedParams[key] = {}, extend(params[key], obj[key]), extend(passedParams[key], obj[key])) : (params[key] = obj[key], passedParams[key] = obj[key]) : key.search(/on[A-Z]/) === 0 && typeof obj[key] == "function" ? splitEvents ? events2[`${key[2].toLowerCase()}${key.substr(3)}`] = obj[key] : params.on[`${key[2].toLowerCase()}${key.substr(3)}`] = obj[key] : rest[key] = obj[key]);
  }), ["navigation", "pagination", "scrollbar"].forEach((key) => {
    params[key] === !0 && (params[key] = {}), params[key] === !1 && delete params[key];
  }), {
    params,
    passedParams,
    rest,
    events: events2
  };
}
function mountSwiper({
  el,
  nextEl,
  prevEl,
  paginationEl,
  scrollbarEl,
  swiper
}, swiperParams) {
  needsNavigation(swiperParams) && nextEl && prevEl && (swiper.params.navigation.nextEl = nextEl, swiper.originalParams.navigation.nextEl = nextEl, swiper.params.navigation.prevEl = prevEl, swiper.originalParams.navigation.prevEl = prevEl), needsPagination(swiperParams) && paginationEl && (swiper.params.pagination.el = paginationEl, swiper.originalParams.pagination.el = paginationEl), needsScrollbar(swiperParams) && scrollbarEl && (swiper.params.scrollbar.el = scrollbarEl, swiper.originalParams.scrollbar.el = scrollbarEl), swiper.init(el);
}
const calcLoopedSlides = (slides, swiperParams) => {
  let slidesPerViewParams = swiperParams.slidesPerView;
  if (swiperParams.breakpoints) {
    const breakpoint = Swiper$1.prototype.getBreakpoint(swiperParams.breakpoints), breakpointOnlyParams = breakpoint in swiperParams.breakpoints ? swiperParams.breakpoints[breakpoint] : void 0;
    breakpointOnlyParams && breakpointOnlyParams.slidesPerView && (slidesPerViewParams = breakpointOnlyParams.slidesPerView);
  }
  let loopedSlides = Math.ceil(parseFloat(swiperParams.loopedSlides || slidesPerViewParams, 10));
  return loopedSlides += swiperParams.loopAdditionalSlides, loopedSlides > slides.length && swiperParams.loopedSlidesLimit && (loopedSlides = slides.length), loopedSlides;
};
function renderLoop(swiper, slides, swiperParams) {
  const modifiedSlides = slides.map((child, index2) => /* @__PURE__ */ React.cloneElement(child, {
    swiper,
    "data-swiper-slide-index": index2
  }));
  function duplicateSlide(child, index2, position) {
    return /* @__PURE__ */ React.cloneElement(child, {
      key: `${child.key}-duplicate-${index2}-${position}`,
      className: `${child.props.className || ""} ${swiperParams.slideDuplicateClass}`
    });
  }
  if (swiperParams.loopFillGroupWithBlank) {
    const blankSlidesNum = swiperParams.slidesPerGroup - modifiedSlides.length % swiperParams.slidesPerGroup;
    if (blankSlidesNum !== swiperParams.slidesPerGroup)
      for (let i = 0; i < blankSlidesNum; i += 1) {
        const blankSlide = /* @__PURE__ */ React.createElement("div", {
          className: `${swiperParams.slideClass} ${swiperParams.slideBlankClass}`
        });
        modifiedSlides.push(blankSlide);
      }
  }
  swiperParams.slidesPerView === "auto" && !swiperParams.loopedSlides && (swiperParams.loopedSlides = modifiedSlides.length);
  const loopedSlides = calcLoopedSlides(modifiedSlides, swiperParams), prependSlides = [], appendSlides = [];
  for (let i = 0; i < loopedSlides; i += 1) {
    const index2 = i - Math.floor(i / modifiedSlides.length) * modifiedSlides.length;
    appendSlides.push(duplicateSlide(modifiedSlides[index2], i, "append")), prependSlides.unshift(duplicateSlide(modifiedSlides[modifiedSlides.length - index2 - 1], i, "prepend"));
  }
  return swiper && (swiper.loopedSlides = loopedSlides), [...prependSlides, ...modifiedSlides, ...appendSlides];
}
function getChangedParams(swiperParams, oldParams, children2, oldChildren, getKey) {
  const keys = [];
  if (!oldParams) return keys;
  const addKey = (key) => {
    keys.indexOf(key) < 0 && keys.push(key);
  };
  if (children2 && oldChildren) {
    const oldChildrenKeys = oldChildren.map(getKey), childrenKeys = children2.map(getKey);
    oldChildrenKeys.join("") !== childrenKeys.join("") && addKey("children"), oldChildren.length !== children2.length && addKey("children");
  }
  return paramsList.filter((key) => key[0] === "_").map((key) => key.replace(/_/, "")).forEach((key) => {
    if (key in swiperParams && key in oldParams)
      if (isObject(swiperParams[key]) && isObject(oldParams[key])) {
        const newKeys = Object.keys(swiperParams[key]), oldKeys = Object.keys(oldParams[key]);
        newKeys.length !== oldKeys.length ? addKey(key) : (newKeys.forEach((newKey) => {
          swiperParams[key][newKey] !== oldParams[key][newKey] && addKey(key);
        }), oldKeys.forEach((oldKey) => {
          swiperParams[key][oldKey] !== oldParams[key][oldKey] && addKey(key);
        }));
      } else swiperParams[key] !== oldParams[key] && addKey(key);
  }), keys;
}
function isChildSwiperSlide(child) {
  return child.type && child.type.displayName && child.type.displayName.includes("SwiperSlide");
}
function processChildren(c) {
  const slides = [];
  return React.Children.toArray(c).forEach((child) => {
    isChildSwiperSlide(child) ? slides.push(child) : child.props && child.props.children && processChildren(child.props.children).forEach((slide2) => slides.push(slide2));
  }), slides;
}
function getChildren(c) {
  const slides = [], slots = {
    "container-start": [],
    "container-end": [],
    "wrapper-start": [],
    "wrapper-end": []
  };
  return React.Children.toArray(c).forEach((child) => {
    if (isChildSwiperSlide(child))
      slides.push(child);
    else if (child.props && child.props.slot && slots[child.props.slot])
      slots[child.props.slot].push(child);
    else if (child.props && child.props.children) {
      const foundSlides = processChildren(child.props.children);
      foundSlides.length > 0 ? foundSlides.forEach((slide2) => slides.push(slide2)) : slots["container-end"].push(child);
    } else
      slots["container-end"].push(child);
  }), {
    slides,
    slots
  };
}
function updateSwiper({
  swiper,
  slides,
  passedParams,
  changedParams,
  nextEl,
  prevEl,
  scrollbarEl,
  paginationEl
}) {
  const updateParams = changedParams.filter((key) => key !== "children" && key !== "direction"), {
    params: currentParams,
    pagination,
    navigation,
    scrollbar,
    virtual,
    thumbs
  } = swiper;
  let needThumbsInit, needControllerInit, needPaginationInit, needScrollbarInit, needNavigationInit;
  changedParams.includes("thumbs") && passedParams.thumbs && passedParams.thumbs.swiper && currentParams.thumbs && !currentParams.thumbs.swiper && (needThumbsInit = !0), changedParams.includes("controller") && passedParams.controller && passedParams.controller.control && currentParams.controller && !currentParams.controller.control && (needControllerInit = !0), changedParams.includes("pagination") && passedParams.pagination && (passedParams.pagination.el || paginationEl) && (currentParams.pagination || currentParams.pagination === !1) && pagination && !pagination.el && (needPaginationInit = !0), changedParams.includes("scrollbar") && passedParams.scrollbar && (passedParams.scrollbar.el || scrollbarEl) && (currentParams.scrollbar || currentParams.scrollbar === !1) && scrollbar && !scrollbar.el && (needScrollbarInit = !0), changedParams.includes("navigation") && passedParams.navigation && (passedParams.navigation.prevEl || prevEl) && (passedParams.navigation.nextEl || nextEl) && (currentParams.navigation || currentParams.navigation === !1) && navigation && !navigation.prevEl && !navigation.nextEl && (needNavigationInit = !0);
  const destroyModule = (mod) => {
    swiper[mod] && (swiper[mod].destroy(), mod === "navigation" ? (currentParams[mod].prevEl = void 0, currentParams[mod].nextEl = void 0, swiper[mod].prevEl = void 0, swiper[mod].nextEl = void 0) : (currentParams[mod].el = void 0, swiper[mod].el = void 0));
  };
  updateParams.forEach((key) => {
    if (isObject(currentParams[key]) && isObject(passedParams[key]))
      extend(currentParams[key], passedParams[key]);
    else {
      const newValue = passedParams[key];
      (newValue === !0 || newValue === !1) && (key === "navigation" || key === "pagination" || key === "scrollbar") ? newValue === !1 && destroyModule(key) : currentParams[key] = passedParams[key];
    }
  }), updateParams.includes("controller") && !needControllerInit && swiper.controller && swiper.controller.control && currentParams.controller && currentParams.controller.control && (swiper.controller.control = currentParams.controller.control), changedParams.includes("children") && slides && virtual && currentParams.virtual.enabled ? (virtual.slides = slides, virtual.update(!0)) : changedParams.includes("children") && swiper.lazy && swiper.params.lazy.enabled && swiper.lazy.load(), needThumbsInit && thumbs.init() && thumbs.update(!0), needControllerInit && (swiper.controller.control = currentParams.controller.control), needPaginationInit && (paginationEl && (currentParams.pagination.el = paginationEl), pagination.init(), pagination.render(), pagination.update()), needScrollbarInit && (scrollbarEl && (currentParams.scrollbar.el = scrollbarEl), scrollbar.init(), scrollbar.updateSize(), scrollbar.setTranslate()), needNavigationInit && (nextEl && (currentParams.navigation.nextEl = nextEl), prevEl && (currentParams.navigation.prevEl = prevEl), navigation.init(), navigation.update()), changedParams.includes("allowSlideNext") && (swiper.allowSlideNext = passedParams.allowSlideNext), changedParams.includes("allowSlidePrev") && (swiper.allowSlidePrev = passedParams.allowSlidePrev), changedParams.includes("direction") && swiper.changeDirection(passedParams.direction, !1), swiper.update();
}
function renderVirtual(swiper, slides, virtualData) {
  if (!virtualData) return null;
  const style = swiper.isHorizontal() ? {
    [swiper.rtlTranslate ? "right" : "left"]: `${virtualData.offset}px`
  } : {
    top: `${virtualData.offset}px`
  };
  return slides.filter((child, index2) => index2 >= virtualData.from && index2 <= virtualData.to).map((child) => /* @__PURE__ */ React.cloneElement(child, {
    swiper,
    style
  }));
}
const updateOnVirtualData = (swiper) => {
  !swiper || swiper.destroyed || !swiper.params.virtual || swiper.params.virtual && !swiper.params.virtual.enabled || (swiper.updateSlides(), swiper.updateProgress(), swiper.updateSlidesClasses(), swiper.lazy && swiper.params.lazy.enabled && swiper.lazy.load(), swiper.parallax && swiper.params.parallax && swiper.params.parallax.enabled && swiper.parallax.setTranslate());
};
function useIsomorphicLayoutEffect(callback, deps) {
  return typeof window > "u" ? useEffect(callback, deps) : useLayoutEffect(callback, deps);
}
const SwiperSlideContext = /* @__PURE__ */ createContext(null), SwiperContext = /* @__PURE__ */ createContext(null);
function _extends$1() {
  return _extends$1 = Object.assign ? Object.assign.bind() : function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source)
        Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key]);
    }
    return target;
  }, _extends$1.apply(this, arguments);
}
const Swiper2 = /* @__PURE__ */ forwardRef(function(_temp, externalElRef) {
  let {
    className,
    tag: Tag = "div",
    wrapperTag: WrapperTag = "div",
    children: children2,
    onSwiper,
    ...rest
  } = _temp === void 0 ? {} : _temp, eventsAssigned = !1;
  const [containerClasses, setContainerClasses] = useState("swiper"), [virtualData, setVirtualData] = useState(null), [breakpointChanged, setBreakpointChanged] = useState(!1), initializedRef = useRef(!1), swiperElRef = useRef(null), swiperRef = useRef(null), oldPassedParamsRef = useRef(null), oldSlides = useRef(null), nextElRef = useRef(null), prevElRef = useRef(null), paginationElRef = useRef(null), scrollbarElRef = useRef(null), {
    params: swiperParams,
    passedParams,
    rest: restProps,
    events: events2
  } = getParams(rest), {
    slides,
    slots
  } = getChildren(children2), onBeforeBreakpoint = () => {
    setBreakpointChanged(!breakpointChanged);
  };
  Object.assign(swiperParams.on, {
    _containerClasses(swiper, classes2) {
      setContainerClasses(classes2);
    }
  });
  const initSwiper = () => {
    if (Object.assign(swiperParams.on, events2), eventsAssigned = !0, swiperRef.current = new Swiper$1(swiperParams), swiperRef.current.loopCreate = () => {
    }, swiperRef.current.loopDestroy = () => {
    }, swiperParams.loop && (swiperRef.current.loopedSlides = calcLoopedSlides(slides, swiperParams)), swiperRef.current.virtual && swiperRef.current.params.virtual.enabled) {
      swiperRef.current.virtual.slides = slides;
      const extendWith = {
        cache: !1,
        slides,
        renderExternal: setVirtualData,
        renderExternalUpdate: !1
      };
      extend(swiperRef.current.params.virtual, extendWith), extend(swiperRef.current.originalParams.virtual, extendWith);
    }
  };
  swiperElRef.current || initSwiper(), swiperRef.current && swiperRef.current.on("_beforeBreakpoint", onBeforeBreakpoint);
  const attachEvents2 = () => {
    eventsAssigned || !events2 || !swiperRef.current || Object.keys(events2).forEach((eventName) => {
      swiperRef.current.on(eventName, events2[eventName]);
    });
  }, detachEvents2 = () => {
    !events2 || !swiperRef.current || Object.keys(events2).forEach((eventName) => {
      swiperRef.current.off(eventName, events2[eventName]);
    });
  };
  useEffect(() => () => {
    swiperRef.current && swiperRef.current.off("_beforeBreakpoint", onBeforeBreakpoint);
  }), useEffect(() => {
    !initializedRef.current && swiperRef.current && (swiperRef.current.emitSlidesClasses(), initializedRef.current = !0);
  }), useIsomorphicLayoutEffect(() => {
    if (externalElRef && (externalElRef.current = swiperElRef.current), !!swiperElRef.current)
      return swiperRef.current.destroyed && initSwiper(), mountSwiper({
        el: swiperElRef.current,
        nextEl: nextElRef.current,
        prevEl: prevElRef.current,
        paginationEl: paginationElRef.current,
        scrollbarEl: scrollbarElRef.current,
        swiper: swiperRef.current
      }, swiperParams), onSwiper && onSwiper(swiperRef.current), () => {
        swiperRef.current && !swiperRef.current.destroyed && swiperRef.current.destroy(!0, !1);
      };
  }, []), useIsomorphicLayoutEffect(() => {
    attachEvents2();
    const changedParams = getChangedParams(passedParams, oldPassedParamsRef.current, slides, oldSlides.current, (c) => c.key);
    return oldPassedParamsRef.current = passedParams, oldSlides.current = slides, changedParams.length && swiperRef.current && !swiperRef.current.destroyed && updateSwiper({
      swiper: swiperRef.current,
      slides,
      passedParams,
      changedParams,
      nextEl: nextElRef.current,
      prevEl: prevElRef.current,
      scrollbarEl: scrollbarElRef.current,
      paginationEl: paginationElRef.current
    }), () => {
      detachEvents2();
    };
  }), useIsomorphicLayoutEffect(() => {
    updateOnVirtualData(swiperRef.current);
  }, [virtualData]);
  function renderSlides() {
    return swiperParams.virtual ? renderVirtual(swiperRef.current, slides, virtualData) : !swiperParams.loop || swiperRef.current && swiperRef.current.destroyed ? slides.map((child) => /* @__PURE__ */ React.cloneElement(child, {
      swiper: swiperRef.current
    })) : renderLoop(swiperRef.current, slides, swiperParams);
  }
  return /* @__PURE__ */ React.createElement(Tag, _extends$1({
    ref: swiperElRef,
    className: uniqueClasses(`${containerClasses}${className ? ` ${className}` : ""}`)
  }, restProps), /* @__PURE__ */ React.createElement(SwiperContext.Provider, {
    value: swiperRef.current
  }, slots["container-start"], /* @__PURE__ */ React.createElement(WrapperTag, {
    className: "swiper-wrapper"
  }, slots["wrapper-start"], renderSlides(), slots["wrapper-end"]), needsNavigation(swiperParams) && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("div", {
    ref: prevElRef,
    className: "swiper-button-prev"
  }), /* @__PURE__ */ React.createElement("div", {
    ref: nextElRef,
    className: "swiper-button-next"
  })), needsScrollbar(swiperParams) && /* @__PURE__ */ React.createElement("div", {
    ref: scrollbarElRef,
    className: "swiper-scrollbar"
  }), needsPagination(swiperParams) && /* @__PURE__ */ React.createElement("div", {
    ref: paginationElRef,
    className: "swiper-pagination"
  }), slots["container-end"]));
});
Swiper2.displayName = "Swiper";
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source)
        Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key]);
    }
    return target;
  }, _extends.apply(this, arguments);
}
const SwiperSlide = /* @__PURE__ */ forwardRef(function(_temp, externalRef) {
  let {
    tag: Tag = "div",
    children: children2,
    className = "",
    swiper,
    zoom,
    virtualIndex,
    ...rest
  } = _temp === void 0 ? {} : _temp;
  const slideElRef = useRef(null), [slideClasses, setSlideClasses] = useState("swiper-slide");
  function updateClasses(_s, el, classNames2) {
    el === slideElRef.current && setSlideClasses(classNames2);
  }
  useIsomorphicLayoutEffect(() => {
    if (externalRef && (externalRef.current = slideElRef.current), !(!slideElRef.current || !swiper)) {
      if (swiper.destroyed) {
        slideClasses !== "swiper-slide" && setSlideClasses("swiper-slide");
        return;
      }
      return swiper.on("_slideClass", updateClasses), () => {
        swiper && swiper.off("_slideClass", updateClasses);
      };
    }
  }), useIsomorphicLayoutEffect(() => {
    swiper && slideElRef.current && !swiper.destroyed && setSlideClasses(swiper.getSlideClasses(slideElRef.current));
  }, [swiper]);
  const slideData = {
    isActive: slideClasses.indexOf("swiper-slide-active") >= 0 || slideClasses.indexOf("swiper-slide-duplicate-active") >= 0,
    isVisible: slideClasses.indexOf("swiper-slide-visible") >= 0,
    isDuplicate: slideClasses.indexOf("swiper-slide-duplicate") >= 0,
    isPrev: slideClasses.indexOf("swiper-slide-prev") >= 0 || slideClasses.indexOf("swiper-slide-duplicate-prev") >= 0,
    isNext: slideClasses.indexOf("swiper-slide-next") >= 0 || slideClasses.indexOf("swiper-slide-duplicate-next") >= 0
  }, renderChildren = () => typeof children2 == "function" ? children2(slideData) : children2;
  return /* @__PURE__ */ React.createElement(Tag, _extends({
    ref: slideElRef,
    className: uniqueClasses(`${slideClasses}${className ? ` ${className}` : ""}`),
    "data-swiper-slide-index": virtualIndex
  }, rest), /* @__PURE__ */ React.createElement(SwiperSlideContext.Provider, {
    value: slideData
  }, zoom ? /* @__PURE__ */ React.createElement("div", {
    className: "swiper-zoom-container",
    "data-swiper-zoom": typeof zoom == "number" ? zoom : void 0
  }, renderChildren()) : renderChildren()));
});
SwiperSlide.displayName = "SwiperSlide";
function _toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++)
      arr2[i] = arr[i];
    return arr2;
  } else
    return Array.from(arr);
}
var hasPassiveEvents = !1;
if (typeof window < "u") {
  var passiveTestOptions = {
    get passive() {
      hasPassiveEvents = !0;
    }
  };
  window.addEventListener("testPassive", null, passiveTestOptions), window.removeEventListener("testPassive", null, passiveTestOptions);
}
var isIosDevice = typeof window < "u" && window.navigator && window.navigator.platform && (/iP(ad|hone|od)/.test(window.navigator.platform) || window.navigator.platform === "MacIntel" && window.navigator.maxTouchPoints > 1), locks = [], documentListenerAdded = !1, initialClientY = -1, previousBodyOverflowSetting = void 0, previousBodyPaddingRight = void 0, allowTouchMove = function(el) {
  return locks.some(function(lock) {
    return !!(lock.options.allowTouchMove && lock.options.allowTouchMove(el));
  });
}, preventDefault = function(rawEvent) {
  var e = rawEvent || window.event;
  return allowTouchMove(e.target) || e.touches.length > 1 ? !0 : (e.preventDefault && e.preventDefault(), !1);
}, setOverflowHidden = function(options) {
  if (previousBodyPaddingRight === void 0) {
    var _reserveScrollBarGap = !1, scrollBarGap = window.innerWidth - document.documentElement.clientWidth;
    _reserveScrollBarGap && scrollBarGap > 0 && (previousBodyPaddingRight = document.body.style.paddingRight, document.body.style.paddingRight = scrollBarGap + "px");
  }
  previousBodyOverflowSetting === void 0 && (previousBodyOverflowSetting = document.body.style.overflow, document.body.style.overflow = "hidden");
}, restoreOverflowSetting = function() {
  previousBodyPaddingRight !== void 0 && (document.body.style.paddingRight = previousBodyPaddingRight, previousBodyPaddingRight = void 0), previousBodyOverflowSetting !== void 0 && (document.body.style.overflow = previousBodyOverflowSetting, previousBodyOverflowSetting = void 0);
}, isTargetElementTotallyScrolled = function(targetElement) {
  return targetElement ? targetElement.scrollHeight - targetElement.scrollTop <= targetElement.clientHeight : !1;
}, handleScroll = function(event, targetElement) {
  var clientY = event.targetTouches[0].clientY - initialClientY;
  return allowTouchMove(event.target) ? !1 : targetElement && targetElement.scrollTop === 0 && clientY > 0 || isTargetElementTotallyScrolled(targetElement) && clientY < 0 ? preventDefault(event) : (event.stopPropagation(), !0);
}, disableBodyScroll = function(targetElement, options) {
  if (!targetElement) {
    console.error("disableBodyScroll unsuccessful - targetElement must be provided when calling disableBodyScroll on IOS devices.");
    return;
  }
  if (!locks.some(function(lock2) {
    return lock2.targetElement === targetElement;
  })) {
    var lock = {
      targetElement,
      options: {}
    };
    locks = [].concat(_toConsumableArray(locks), [lock]), isIosDevice ? (targetElement.ontouchstart = function(event) {
      event.targetTouches.length === 1 && (initialClientY = event.targetTouches[0].clientY);
    }, targetElement.ontouchmove = function(event) {
      event.targetTouches.length === 1 && handleScroll(event, targetElement);
    }, documentListenerAdded || (document.addEventListener("touchmove", preventDefault, hasPassiveEvents ? { passive: !1 } : void 0), documentListenerAdded = !0)) : setOverflowHidden();
  }
}, clearAllBodyScrollLocks = function() {
  isIosDevice ? (locks.forEach(function(lock) {
    lock.targetElement.ontouchstart = null, lock.targetElement.ontouchmove = null;
  }), documentListenerAdded && (document.removeEventListener("touchmove", preventDefault, hasPassiveEvents ? { passive: !1 } : void 0), documentListenerAdded = !1), initialClientY = -1) : restoreOverflowSetting(), locks = [];
}, enableBodyScroll = function(targetElement) {
  if (!targetElement) {
    console.error("enableBodyScroll unsuccessful - targetElement must be provided when calling enableBodyScroll on IOS devices.");
    return;
  }
  locks = locks.filter(function(lock) {
    return lock.targetElement !== targetElement;
  }), isIosDevice ? (targetElement.ontouchstart = null, targetElement.ontouchmove = null, documentListenerAdded && locks.length === 0 && (document.removeEventListener("touchmove", preventDefault, hasPassiveEvents ? { passive: !1 } : void 0), documentListenerAdded = !1)) : locks.length || restoreOverflowSetting();
};
export {
  Autoplay as A,
  Lazy as L,
  Navigation as N,
  Pagination as P,
  Swiper2 as S,
  Zoom as Z,
  __rest as _,
  SwiperSlide as a,
  __awaiter as b,
  classNames as c,
  disableBodyScroll as d,
  enableBodyScroll as e,
  freeMode as f,
  clearAllBodyScrollLocks as g,
  api as h,
  queryString as q
};
//# sourceMappingURL=vendor-CgDuhM0G.mjs.map
